module.exports = {
	"pl": {
		"moet-core": {
			"select_language": {
				"title": "Wybierz swój język",
				"paragraph": "Będzie to Twój domyślny język.",
				"submit": "OK"
			},
			"products": {
				"mandatory": "Zawsze w zestawie",
				"kco": {
					"name": {
						"default": "Przy kasie"
					},
					"description": {
						"default": "Zaoferuj wszystkie nasze sposoby płatności"
					},
					"options": {
						"kco-pay-now": {
							"name": {
								"default": "Zapłać teraz"
							},
							"description": {
								"default": "Zaoferuj natychmiastowe płatności kartą lub przelewem."
							}
						},
						"kco-pay-later": {
							"name": {
								"default": "Zapłać za 30 dni"
							},
							"description": {
								"default": "Zaoferuj 30 dni na zapłatę. Bez odsetek."
							}
						},
						"kco-slice-it": {
							"name": {
								"default": "Finansowanie"
							},
							"description": {
								"default": "Zaoferuj możliwość spłaty przez 6–36 miesięcy.",
								"DE": "Zaoferuj możliwość spłaty przez 6–24 miesiące",
								"AT": "Zaoferuj możliwość spłaty przez 6–24 miesiące."
							}
						},
						"kco-slice-it-in-3": {
							"name": {
								"default": "Raty"
							},
							"description": {
								"default": "Zaoferuj 3 bezodsetkowe raty.",
								"GB": "Zaoferuj 3 bezodsetkowe raty."
							}
						},
						"kco-slice-it-in-4": {
							"name": {
								"default": "Płatność podzielona na 4 raty",
								"US": "Raty",
								"AU": "Zapłać w 4 ratach"
							},
							"description": {
								"default": "Zaoferuj 4 bezodsetkowe raty.",
								"GB": "Zaoferuj 4 bezodsetkowe raty."
							}
						}
					}
				},
				"kp": {
					"name": {
						"default": "Sposoby płatności"
					},
					"description": {
						"default": "Wybierz spośród naszych samodzielnych rozwiązań płatniczych. Wybierz jedno lub połącz kilka. Prosta, jednorazowa integracja, bez względu na to, co wybierzesz."
					},
					"options": {
						"kp-pay-now": {
							"name": {
								"default": "Zapłać teraz"
							},
							"description": {
								"default": "Zaoferuj natychmiastowe płatności kartą lub przelewem."
							}
						},
						"kp-pay-later": {
							"name": {
								"default": "Zapłać za 30 dni"
							},
							"description": {
								"default": "Zaoferuj 30 dni na zapłatę. Bez odsetek."
							}
						},
						"kp-slice-it": {
							"name": {
								"default": "Finansowanie"
							},
							"description": {
								"default": "Zaoferuj możliwość spłaty przez 6–36 miesięcy.",
								"DE": "Zaoferuj możliwość spłaty przez 6–24 miesiące",
								"AT": "Zaoferuj możliwość spłaty przez 6–24 miesiące."
							}
						},
						"kp-slice-it-in-3": {
							"name": {
								"default": "Raty"
							},
							"description": {
								"default": "Zaoferuj 3 bezodsetkowe raty.",
								"GB": "Zaoferuj 3 bezodsetkowe raty."
							}
						},
						"kp-slice-it-in-4": {
							"name": {
								"default": "Płatność podzielona na 4 raty",
								"US": "4 płatności",
								"CA": "4 płatności",
								"AU": "Zapłać w 4 ratach"
							},
							"description": {
								"default": "Zaoferuj 4 bezodsetkowe raty.",
								"GB": "Zaoferuj 4 bezodsetkowe raty.",
								"US": "Zamówienia od 35 do 1000 USD mogą być podzielone na 4 bezodsetkowe raty, płatne co 2 tygodnie.",
								"CA": "Zamówienia od 35 do 1000 USD mogą być podzielone na 4 bezodsetkowe raty, płatne co 2 tygodnie."
							}
						}
					}
				},
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Zastąp standardową bramkę płatności w swoim sklepie zoptymalizowaną bramką Klarny."
					},
					"description_expanded": {
						"default": "Zastąp standardową bramkę płatności w swoim sklepie zoptymalizowaną bramką Klarny."
					}
				},
				"kp_one": {
					"name": {
						"default": "Sposób płatności"
					},
					"description": {
						"default": "Dodaj rozwiązania płatnicze Klarny do swojego check-outu"
					},
					"description_expanded": {
						"default": "Oferowanie rozwiązań płatniczych Klarna generuje wzrosty: wzrost konwersji średnio o 30%, średniego koszyka o 41% i częstotliwości zakupów o 36%."
					}
				}
			}
		},
		"products-fe": {
			"error_messages": {
				"validation": {
					"required": "Aby przejść dalej, konieczne jest wypełnienie tego pola",
					"generic": "Wprowadzona wartość jest nieprawidłowa",
					"required_suffix": "jest wymagane, aby kontynuować",
					"generic_suffix": "jest niepoprawne",
					"min_one": "Musisz wybrać co najmniej jeden element",
					"min": "Musisz wybrać co najmniej {min} elementy",
					"max": "Nie możesz wybrać więcej elementów (max.: {max})",
					"given_name": "Brak imienia",
					"family_name": {
						"general": "Brak nazwiska",
						"too_short": "Podaj prawidłowe nazwisko"
					},
					"date_of_birth": {
						"general": {
							"default": "Podaj aktualną datę urodzenia (DD/MM/RRRR)",
							"US": "Podaj aktualną datę urodzenia (MM/DD/RRRR)"
						},
						"too_young": "Wszyscy uczestnicy muszą mieć ukończone 16 lat.",
						"too_young_eighteen": "Musisz mieć ukończone 18 lat"
					},
					"street_address": "Podaj adres",
					"street_address2": "Wpisz prawidłową 2. linię adresu",
					"postal_code": "Podaj kod pocztowy",
					"country": "Podaj kraj",
					"region": "Podaj region",
					"state": "Podaj stan",
					"iban": "Podaj numer konta (IBAN)",
					"companyName": "Podaj nazwę firmy",
					"email": "Podaj prawidłowy adres e-mail",
					"contact_email": "Podaj prawidłowy adres e-mail",
					"support_email": "Podaj prawidłowy adres e-mail obsługi klienta",
					"support_phone": "Podaj prawidłowy numer telefonu obsługi klienta",
					"selling_countries": "Musisz wybrać co najmniej jeden kraj",
					"store_category": "Należy wybrać jedną z opcji",
					"name": "Podaj nazwę sklepu",
					"legal_form": "Wybierz jeden z wymienionych rodzajów działalności",
					"generic_toggle_undefined": "Wybierz jedną z opcji",
					"website": "Podaj prawidłowy adres URL witryny internetowej",
					"bankAccounts": "Podaj co najmniej jeden rachunek bankowy",
					"product": "Wybierz produkt",
					"platform": "Wybierz platformę",
					"password": "Utwórz silne hasło",
					"currency_code": "Podaj kod waluty",
					"account_holder": "Podaj posiadacza rachunku bankowego",
					"account_type": "Podaj typ konta bankowego",
					"routing_number": "Podaj prawidłowy numer routingowy",
					"account_number": {
						"first": "Podaj prawidłowy numer konta dla domyślnego rachunku bankowego",
						"second": "Podaj aktualny numer konta dla pierwszego dodatkowego rachunku bankowego",
						"third": "Podaj aktualny numer konta dla drugiego dodatkowego rachunku bankowego",
						"fourth": "Podaj aktualny numer konta dla trzeciego dodatkowego rachunku bankowego",
						"general": "Podaj prawidłowy numer konta"
					},
					"role": "Podaj rolę",
					"address": "Podaj adres",
					"political_exposed_person": "Podaj informacje dotyczące PEP",
					"pep_position": "Podaj informacje o stanowisku",
					"pep_relationship": "Podaj informacje o pokrewieństwie z osobą PEP",
					"goodsCategory": "Podaj kategorię towarów",
					"registered": "Podaj informacje rejestrowe firmy",
					"subjectToVat": "Podaj numer VAT",
					"registrationCourt": "Podaj nazwę sądu rejestrowego",
					"registrationId": {
						"general": {
							"default": "Wprowadź prawidłowy numer rejestracyjny",
							"AT": "Wprowadź prawidłowy numer rejestracyjny",
							"AU": "Wprowadź prawidłowy numer ACN",
							"ES": "Wprowadź prawidłowy numer NIF / NIE / DNI przedsiębiorstwa",
							"GB": "Wprowadź prawidłowy numer organizacji",
							"GR": "Wprowadź prawidłowy numer G.E.MI. (Γ.Ε.ΜΗ.)",
							"CA": "Wprowadź prawidłowy numer firmy",
							"NZ": "Wprowadź prawidłowy numer firmowy",
							"US": "Wprowadź prawidłowy numer identyfikacyjny pracodawcy (Employer Identification Number)"
						},
						"missing_leading_0_GB": "Podaj 8-cyfrowy numer organizacji. W numerze Twojej organizacji może brakować początkowego 0 (np. 03452678)",
						"invalid": {
							"default": "Wprowadź prawidłowy numer rejestracyjny",
							"AT": "Numer rejestracyjny powinien zawierać od 5 do 11 znaków. Pamiętaj, że nie jest to Twój numer podatkowy ani ID sprzedawcy.",
							"AU": "ACN powinien mieć długość 9 cyfr, bez spacji. Przykład: 123456789",
							"BE": "Numer rejestracyjny powinien składać się z 10 cyfr. Przykład: 1234567890",
							"CA": "Numer firmowy powinien składać się z 9 cyfr. Przykład: 123456789",
							"CZ": "Numer rejestracyjny powinien składać się z 8 cyfr. Przykład: 12345678",
							"DE": "Numer rejestracyjny powinien składać się z 6 do 11 znaków i musi zaczynać się od HRA, HRB, GnR, VR lub PR, po których następuje spacja. Pamiętaj, że nie jest to Twój numer podatkowy ani ID sprzedawcy.",
							"ES": "NIF / NIE / DNI powinien składać się z 8 lub 9 znaków, zaczynających się od 1 litery/cyfry, po których następuje 6 lub 7 cyfr i 1 litera/cyfra",
							"FI": "Numer rejestracyjny powinien składać się z 8 cyfr z myślnikiem przed ostatnią cyfrą, bez spacji. Przykład: 1234567-8",
							"FR": "Numer rejestracyjny powinien składać się z 9 cyfr, np. 123 456 789 lub 123456789 (SIREN), lub 14 cyfr, np. 123 456 789 12345 lub 12345678912345 (SIRET).",
							"IE": "Numer rejestracyjny składa się z 2 liter i następujących po nich 6 cyfr lub w przypadku osób prowadzących jednoosobową działalność gospodarczą – tylko z 6 cyfr (np. AB123456).",
							"IT": "Numer rejestracyjny powinien składać się z 11 cyfr (np. 01234567890) lub kombinacji 16 cyfr i dużych liter (np. ABCABC12A12A123A).",
							"GB": "Numer organizacji powinien mieć długość 8 cyfr. Np.: 12345678, lub dwie litery, po których następuje 6 cyfr (SC123456), lub jedna litera, po której następuje 7 cyfr (S1234567)",
							"GR": "Numer G.E.MI. powinien składać się z 12 cyfr, np. 012345678901",
							"NL": "Numer rejestracyjny powinien składać się z 8 cyfr. Przykład: 12345678",
							"NO": "Numer rejestracyjny powinien składać się z 9 cyfr, bez spacji. Przykład: 123456789",
							"NZ": "Numer firmowy powinien składać się z 13 cyfr. Przykład: 1234567890123",
							"PL": "Numer rejestracyjny powinien składać się z 10 cyfr, bez spacji. Przykład: 1234561234",
							"PT": "Numer rejestracyjny powinien składać się z 9 cyfr, bez spacji. Przykład: 123123123",
							"SE": "Numer rejestracyjny powinien składać się z 10 cyfr z myślnikiem, bez spacji. Przykład: 123456-1234",
							"US": "Numer identyfikacyjny pracodawcy powinien składać się z 9 cyfr z symbolem „-” po pierwszych dwóch. Przykład: 12-3456789",
							"MX": "RFC powinien składać się z 12 znaków, zaczynających się od inicjałów firmy, 6-cyfrowej daty założenia i wartości kontrolnej. Na przykład: ABC921010H20"
						}
					},
					"tocLink": "Podczas przygotowywania Warunków i regulaminu wystąpił błąd. Spróbuj ponownie później lub skontaktuj się z naszym działem obsługi klienta pod adresem {supportEmail}.",
					"vat": {
						"general": {
							"default": "Wprowadź prawidłowy numer VAT",
							"AU": "Wprowadź prawidłowy numer ABN",
							"ES": "Wprowadź prawidłowy numer NIF / NIE / DNI firmy",
							"NZ": "Wprowadź prawidłowy numer GST"
						},
						"invalid": {
							"default": "Nieprawidłowy numer VAT",
							"AT": "Numer VAT powinien zaczynać się od ATU, po którym następuje 8 cyfr. Przykład: ATU12345678",
							"AU": "ABN powinien składać się z 11 cyfr.",
							"CZ": "Numer VAT powinien zaczynać się od liter CZ, po których następuje 8, 9 lub 10 cyfr. Przykład: CZ123456789",
							"GR": "Nr VAT składa się z 9 cyfr i musi zaczynać się od liter EL. Przykład: EL123456789",
							"DE": "Numer VAT powinien zaczynać się od DE, po którym następuje 9 cyfr. Przykład: DE123456789",
							"ES": "NIF / NIE / DNI powinien składać się z 8 lub 9 znaków, zaczynających się od 1 litery/cyfry, po których następuje 6 lub 7 cyfr i 1 litera/cyfra",
							"FR": "Numer VAT powinien składać się z liter FR, po których następują 2 litery/cyfry i 9 cyfr (SIREN), np. FRXX123456789",
							"GB": "Numer VAT powinien zawierać od 6 do 15 znaków.",
							"IE": "Numer VAT powinien składać się z liter IE, po których następuje 8 lub 9 znaków zawierających 1 lub 2 litery. Na przykład: IE1234567WA, IE1234567A.",
							"IT": "Numer VAT powinien zaczynać się od IT, po którym następuje 11 cyfr. Przykład: IT12345678912",
							"NL": "Numer VAT powinien składać się z liter NL, po których następuje 9 cyfr, a następnie B i 2 cyfry. Przykład: NL123456789B12",
							"NZ": "Numer GST powinien składać się z 8 cyfr (12345678) lub 9 cyfr, z lub bez myślników co 3 cyfry (123-123-123 lub 123123123)",
							"PL": "Numer VAT powinien zaczynać się od PL, po którym następuje 10 cyfr. Przykład: PL1234567890",
							"PT": "Numer VAT powinien zaczynać się od liter PT, po których następuje 9 cyfr. Przykład: PT123123123",
							"MX": "RFC powinien zaczynać się od inicjałów firmy, 6-cyfrowej daty założenia i wartości kontrolnej. Na przykład: ABC921010H20"
						}
					},
					"personal_id": {
						"US": {
							"general": "Podaj 4 ostatnie cyfry swojego numeru SSN",
							"format": "Podaj 4 ostatnie cyfry swojego numeru SSN"
						},
						"US_FULL_SSN": {
							"general": "Podaj cały numer SSN (9 cyfr)",
							"format": "Podaj swój cały numer SSN (9 cyfr)"
						},
						"CA": {
							"general": "Podaj ważny numer SIN lub numer paszportu",
							"format": "SIN: XXX-XXX-XXX / Numer paszportu: ABXXXXXX"
						},
						"SE": {
							"general": "Podaj prawidłowy numer identyfikacyjny (PNO)",
							"format": "Podaj PNO w formacie: RRRRMMDD-XXXX"
						},
						"FI": {
							"general": "Podaj prawidłowy osobisty kod identyfikacyjny (HETU)",
							"format": "Wpisz HETU w formacie: DDMMYYSXXXX"
						},
						"NO": {
							"general": "Podaj ważny krajowy numer identyfikacyjny (National Identity Number)",
							"format": "Wpisz go w formacie: DDMMYYXXXXX"
						},
						"DK": {
							"general": "Podaj prawidłowy numer identyfikacyjny (CPR)",
							"format": "Wpisz CPR w formacie: DDMMYY-XXXX"
						},
						"IT": {
							"general": "Podaj prawidłowy kod fiskalny",
							"format": "Wpisz kod fiskalny w formacie: CLDNRG84L58H501R"
						},
						"ES": {
							"general": "Podaj prawidłowy numer identyfikacyjny (DNI lub NIE)",
							"format": "Wpisz DNI lub NIE, np. 12345678A."
						},
						"PL": {
							"general": "Podaj prawidłowy osobisty kod identyfikacyjny (PESEL)",
							"format": "Wpisz PESEL w formacie: YYMMDDZZZXQ"
						},
						"default": {
							"general": "Podaj prawidłowy numer paszportu"
						}
					},
					"store_name": "Podaj nazwę sklepu"
				},
				"errors_keys": {
					"correlationIdLabel": "Identyfikator korelacji: {correlationId}",
					"decisionTaken": "Decyzja wstępna została już podjęta. Prosimy przeładować stronę.",
					"maintenanceMode": "Nasza aplikacja jest obecnie wyłączona z powodu konserwacji. Odwiedź nas później.",
					"validation": {
						"storeName": {
							"invalidType": "Podaj poprawną nazwę sklepu."
						},
						"email": {
							"invalidType": "Podaj poprawny adres e-mail."
						},
						"goodsCategory": {
							"invalidType": "Podaj kategorię towaru."
						},
						"website": {
							"invalidType": "Podaj poprawny adres witryny."
						}
					}
				}
			},
			"general": {
				"yes": "Tak",
				"no": "Nie",
				"encrypted_text": "*******",
				"pricing_link_eu": "Zobacz wszystkie ceny dla poszczególnych krajów",
				"pricing_link_us": "Zobacz ceny",
				"formFieldOptional": "opcjonalne",
				"buttons": {
					"next": "Dalej",
					"back": "Wstecz",
					"continue": "Kontynuuj",
					"submit_application": {
						"default": "Zaczynamy",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Zaczynamy"
					},
					"add_aditional_item": "+ Dodaj dodatkowy produkt"
				},
				"unknown_step_title": "Podaj wymagane informacje",
				"selected": "Wybrano",
				"clear_all": "Wyczyść wszystko"
			},
			"errors": {
				"general": "Wystąpił błąd. Prosimy o kontakt z naszym działem wsparcia.",
				"salesforce": "Spróbuj odświeżyć stronę. Jeśli błąd nadal występuje, prześlij ID błędu na kanał #smooothforce-support, a my pomożemy Ci rozwiązać problem.",
				"managed_kyc": "Spróbuj odświeżyć stronę. Jeśli błąd nadal występuje, skontaktuj się z naszym działem obsługi klienta lub z działem wsparcia dla handlowców.",
				"copy": "Skopiuj",
				"noTermsAccepted": "Przeczytaj i zaakceptuj wszystkie wymienione umowy",
				"termsAlreadyAccepted": "Wszystkie wymienione umowy zostały już zaakceptowane",
				"mandatoryField": " jest wymagane"
			},
			"options": {
				"entity_types": {
					"SOLE_TRADER": "Jednoosobowa działalność gospodarcza",
					"PARTNERSHIP": "Współpraca",
					"PUBLIC_LISTED_COMPANY": "Spółka publiczna notowana na giełdzie",
					"PRIVATE_COMPANY": "Przedsiębiorstwo prywatne"
				},
				"organization_entity_types": {
					"C_CORP": "Korporacja C",
					"S_CORP": "Korporacja S",
					"PARTNERSHIP": "Współpraca",
					"TRUST_ESTATE": "Fundusz powierniczy",
					"INDIVIDUAL": "Indywidualna",
					"SOLE_PROPRIETORSHIP": "Jednoosobowa działalność gospodarcza",
					"SOLE_TRADER": "Jednoosobowa działalność gospodarcza",
					"LIMITED_LIABILITY_COMPANY": "Spółka z ograniczoną odpowiedzialnością",
					"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Jednoosobowa spółka z ograniczoną odpowiedzialnością"
				},
				"goods_categories": {
					"ADULT_SHOES_AND_CLOTHING": "Odzież i obuwie – Obuwie i odzież dla dorosłych",
					"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Produkty samochodowe – Części i akcesoria samochodowe",
					"BAGS_AND_WALLETS": "Biżuteria i akcesoria – Torby i portfele",
					"BODY_AND_HAIR_CARE": "Zdrowie i uroda – Pielęgnacja ciała i włosów",
					"BOOK_AND_MAGAZINES": "Rozrywka – książki i czasopisma",
					"CANDY": "Żywność i napoje – Cukierki",
					"CAR_ELECTRONICS": "Elektronika – Elektronika samochodowa",
					"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Produkty dla dzieci – Odzież dziecięca i produkty pielęgnacyjne",
					"CHILDREN_TOYS": "Produkty dla dzieci – Zabawki dla dzieci",
					"CLEANING_AND_SANITARY": "Dom i ogród – Sprzątanie i higiena",
					"COLLECTIBLES": "Rekreacja, sport i hobby – Kolekcje",
					"CONCEPT_STORES_AND_MISCELLANEOUS": "Rekreacja, sport i hobby – Concept store’y i pozostałe",
					"COSMETICS": "Zdrowie i uroda – Kosmetyki",
					"COSTUMES_AND_PARTY_SUPPLIES": "Rekreacja, sport i hobby – Kostiumy i artykuły na przyjęcia",
					"DATING_SERVICES": "Produkty niematerialne – Usługi randkowe",
					"DECORATION_AND_ART": "Dom i ogród – Dekoracje i sztuka",
					"DIETARY_SUPPLEMENTS": "Zdrowie i uroda – Suplementy diety",
					"DIGITAL_SERVICES": "Produkty niematerialne – Usługi cyfrowe",
					"DIVERSIFIED_CHILDREN_PRODUCTS": "Produkty dla dzieci – Różne produkty dla dzieci",
					"DIVERSIFIED_ELECTRONICS": "Elektronika – Różna elektronika",
					"DIVERSIFIED_ENTERTAINMENT": "Rozrywka – Różna rozrywka",
					"DIVERSIFIED_EROTIC_MATERIAL": "Materiały Erotyczne – Różne materiały erotyczne",
					"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Zdrowie i uroda – Różne produkty dla zdrowia i urody",
					"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Dom i ogród – Różne produkty dla domu i ogrodu",
					"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Biżuteria i akcesoria – Różna biżuteria i akcesoria",
					"EDUCATION": "Produkty niematerialne – Edukacja",
					"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektronika – Sprzęt elektroniczny i związane z nim akcesoria",
					"EROTIC_CLOTHING_AND_ACCESSORIES": "Materiały Erotyczne – Odzież i akcesoria erotyczne",
					"EVENT_TICKETS": "Produkty niematerialne – Bilety na imprezy",
					"FOOD_AND_BEVERAGE": "Żywność i napoje – Żywność i napoje",
					"FRAGRANCES": "Zdrowie i uroda – Perfumy",
					"FURNITURE": "Dom i ogród – Meble",
					"GENERAL_SHOES_AND_CLOTHING": "Odzież i obuwie – Obuwie i odzież ogólnie",
					"HOBBY_ARTICLES": "Rekreacja, sport i hobby – Artykuły hobbystyczne",
					"HOUSEHOLD_ELECTRONICS": "Elektronika – Elektronika użytkowa",
					"JEWELRY_AND_WATCHES": "Biżuteria i akcesoria – Biżuteria i zegarki",
					"KITCHENWARE": "Dom i ogród – Przybory kuchenne",
					"MARKETPLACES": "Produkty niematerialne – Rynki",
					"MUSIC_AND_MOVIES": "Rozrywka – Muzyka i filmy",
					"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Rekreacja, sport i hobby – Instrumenty i sprzęt muzyczny",
					"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Biżuteria i akcesoria – Okulary przeciwsłoneczne bez recepty i soczewki",
					"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektronika – Urządzenia biurowe i podobne akcesoria",
					"OTHER_SERVICES": "Produkty niematerialne – Pozostałe usługi",
					"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Zdrowie i uroda – Pielęgnacja osobista i poprawa sylwetki",
					"PET_SUPPLIES": "Dom i ogród – Artykuły dla zwierząt domowych",
					"PHARMACEUTICAL_PRODUCTS": "Zdrowie i uroda – Produkty farmaceutyczne",
					"PLANTS_AND_FLOWERS": "Dom i ogród – Rośliny i kwiaty",
					"PRESCRIPTION_OPTICS": "Zdrowie i uroda – Optyka na receptę",
					"PRINTS_AND_PHOTOS": "Rekreacja, sport i hobby – Wydruki i zdjęcia",
					"SAFETY_PRODUCTS": "Dom i ogród – Produkty związane z bezpieczeństwem",
					"SEX_TOYS": "Materiały Erotyczne – Zabawki erotyczne",
					"SPORTS_GEAR_AND_OUTDOOR": "Rekreacja, sport i hobby – Sprzęt sportowy i outdoor",
					"TOBACCO": "Żywność i napoje – Tytoń",
					"TOOLS_AND_HOME_IMPROVEMENT": "Dom i ogród – Narzędzia i wyposażenie domu",
					"TRAVEL_SERVICES": "Produkty niematerialne – Usługi turystyczne",
					"UNDERWEAR": "Odzież i buty – Bielizna",
					"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Rozrywka – Gry wideo i powiązane akcesoria",
					"WHEELS_AND_TIRES": "Produkty samochodowe – Koła i opony",
					"WINE_BEER_AND_LIQUOR": "Żywność i napoje – piwo, wino i alkohole wysokoprocentowe",
					"YOUTHFUL_SHOES_AND_CLOTHING": "Odzież i obuwie – Obuwie i odzież dla młodzieży",
					"GAMBLING_BETTING_CASINOS_AND_LOTTERY": "Z ograniczeniem wieku – hazard, zakłady, kasyna i loterie",
					"CHARITIES_AND_NGO": "Produkty niematerialne – Usługi organizacji charytatywnych i pozarządowych",
					"EROTIC_SERVICES": "Materiały Erotyczne – Usługi erotyczne",
					"FINANCIAL_SERVICES_CRYPTO": "Usługi finansowe – Działania związane z kryptowalutami",
					"FINANCIAL_SERVICES_MSB": "Usługi finansowe – Usługi pieniężne",
					"FINANCIAL_SERVICES_E_WALLETS": "Usługi finansowe – portfele elektroniczne",
					"FINANCIAL_SERVICES_TRADING": "Usługi finansowe – handel",
					"SOCIAL_PLATFORMS_COMMUNITIES": "Produkty niematerialne – Społeczności platform społecznościowych",
					"TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS": "Podróżowanie – podróże lotnicze i operatorzy rejsów",
					"TRAVEL_BROKER_AND_AGENCIES": "Podróżowanie – Brokerzy i Agencje",
					"TRAVEL_GROUND_TRANSPORTATION": "Podróżowanie - Transport naziemny",
					"TRAVEL_ACCOMMODATION_AND_RESORTS": "Podróżowanie – Zakwaterowanie i kurorty",
					"EVENT_ORGANIZER": "Eventy – Organizator",
					"EVENT_BROKER_AND_AGENCIES": "Eventy – Brokerzy i Agencje"
				},
				"us_states": {
					"AL": "Alabama",
					"AK": "Alaska",
					"AZ": "Arizona",
					"AR": "Arkansas",
					"CA": "Kalifornia",
					"CO": "Kolorado",
					"CT": "Connecticut",
					"DC": "Dystrykt Kolumbia",
					"DE": "Delaware",
					"FL": "Floryda",
					"GA": "Georgia",
					"HI": "Hawaje",
					"ID": "Idaho",
					"IL": "Illinois",
					"IN": "Indiana",
					"IA": "Iowa",
					"KS": "Kansas",
					"KY": "Kentucky",
					"LA": "Luizjana",
					"ME": "Maine",
					"MD": "Maryland",
					"MA": "Massachusetts",
					"MI": "Michigan",
					"MN": "Minnesota",
					"MS": "Missisipi",
					"MO": "Missouri",
					"MT": "Montana",
					"NE": "Nebraska",
					"NV": "Nevada",
					"NH": "New Hampshire",
					"NJ": "New Jersey",
					"NM": "Nowy Meksyk",
					"NY": "Nowy Jork",
					"NC": "Północna Karolina",
					"ND": "Północna Dakota",
					"OH": "Ohio",
					"OK": "Oklahoma",
					"OR": "Oregon",
					"PA": "Pensylwania",
					"RI": "Rhode Island",
					"SC": "Południowa Karolina",
					"SD": "Południowa Dakota",
					"TN": "Tennessee",
					"TX": "Teksas",
					"UT": "Utah",
					"VT": "Vermont",
					"VA": "Virginia",
					"WA": "Waszyngton",
					"WV": "Zachodnia Wirginia",
					"WI": "Wisconsin",
					"WY": "Wyoming"
				},
				"stakeholder": {
					"types": {
						"PERSON": "Osoba",
						"COMPANY": "Firma"
					},
					"roles": {
						"OWNER": "Właściciel",
						"ULTIMATE_BENEFICIAL_OWNER": "Beneficjent ostateczny",
						"CONTROL_OVER_MANAGEMENT": "Kontrola nad zarządem",
						"APPLICANT": "Upoważniony sygnatariusz",
						"SOLE_TRADER": "Jednoosobowa działalność gospodarcza",
						"PARTNER": "Partner/partnerka"
					}
				},
				"payment_intervals": {
					"DAILY": "Codziennie",
					"WEEKLY": "Tygodniowo"
				},
				"business_concepts": {
					"TRADITIONAL_SALE_OF_GOODS": {
						"label": "Tradycyjna sprzedaż towarów",
						"description": "Sprzedawca sprzedaje produkty lub usługi w sposób tradycyjny: towary są uważane za w pełni skonsumowane w momencie pierwszej dostawy i zazwyczaj nie ma wydłużonego okresu pomiędzy zamówieniem a dostawą"
					},
					"VOUCHER": {
						"label": "Voucher",
						"description": "Ponad 10% sprzedaży stanowią vouchery i/lub karty podarunkowe"
					},
					"MEMBERSHIP": {
						"label": "Członkostwo",
						"description": "Ponad 10% sprzedaży stanowią członkostwa"
					},
					"SUBSCRIPTION": {
						"label": "Subskrypcja",
						"description": "Ponad 10% sprzedaży stanowią subskrypcje"
					},
					"PHARMACIES": {
						"label": "Apteki",
						"description": "Sprzedawca sprzedaje leki na receptę lub bez recepty"
					},
					"US_PHARMACIES": {
						"label": "Apteki amerykańskie",
						"description": "Sprzedawca sprzedaje leki na receptę lub bez recepty w USA"
					},
					"MEDICAL_SERVICES": {
						"label": "Usługi medyczne",
						"description": "Sprzedawca sprzedaje usługi medyczne takie jak testy, badania, opieka pielęgniarska"
					},
					"MARKETPLACES": {
						"label": "Rynki",
						"description": "Sprzedawca posiada relację dalszej odsprzedaży"
					},
					"FIREARM_DEALERS": {
						"label": "Handlarze broni palnej",
						"description": "Handlarz sprzedający broń i amunicję wymagające pozwolenia"
					},
					"AUCTIONS": {
						"label": "Aukcje",
						"description": "Sprzedawca to dom aukcyjny"
					},
					"ALCOHOL": {
						"label": "Alkohol",
						"description": "Sprzedawca sprzedaje alkohol"
					},
					"TOBACCO": {
						"label": "Tytoń",
						"description": "Sprzedawca sprzedaje wyroby tytoniowe zawierające lub niezawierające nikotyny lub sprzedaje e-papierosy"
					},
					"HEMP_CBD_THC": {
						"label": "Konopie, CBD lub THC",
						"description": "Sprzedawca sprzedaje produkty zawierające konopie, CBD lub THC"
					},
					"DONATIONS_CHARITY": {
						"label": "Darowizny i działalność charytatywna",
						"description": "Sprzedawca jest darczyńcą lub organizacją charytatywną, która korzysta z usługi „Wypłata po rozliczeniu”."
					},
					"TRAVEL": {
						"label": "Podróże",
						"description": "Ponad 10% sprzedaży stanowią podróże"
					},
					"EVENTS": {
						"label": "Eventy",
						"description": "Ponad 10% sprzedaży stanowią eventy"
					},
					"COURSES": {
						"label": "Kursy",
						"description": "Ponad 10% sprzedaży stanowią kursy"
					},
					"EDUCATIONAL_COURSES": {
						"label": "Kursy edukacyjne",
						"description": "Sprzedawca sprzedaje kursy edukacyjne trwające przez określony czas."
					},
					"FOOD_DELIVERY": {
						"label": "Dostawa jedzenia",
						"description": "Sprzedawca świadczy usługę dostawy jedzenia."
					},
					"CUSTOMISED_PRE_ORDER_FURNITURE": {
						"label": "Niestandardowe zamówienie w przedsprzedaży / meble",
						"description": "Sprzedawca oferuje produkty do nabycia w przedsprzedaży, takie jak meble."
					},
					"DIGITAL_CONTENT": {
						"label": "Treści cyfrowe",
						"description": "Sprzedawca oferuje treści cyfrowe, takie jak e-booki czy gry online."
					},
					"GAMING_INDUSTRY": {
						"label": "Branża gier (hazard, zakłady, kasyna, loterie)",
						"description": "Sprzedawca świadczy usługi związane z branżą gier, takie jak hazard, zakłady, kasyna i loterie."
					}
				}
			},
			"pages": {
				"select_products_page": {
					"page_header": {
						"primary_title": "Witamy, {firstName}!",
						"primary_title_without_name": "Witamy!",
						"sub_title": "Więcej Klarna to więcej Klarna, jak powiedział Szekspir.",
						"sub_title_no_products": "Rozpocznij swoją przygodę z Klarna, wybierając produkt poniżej.",
						"sub_title_kp_products": "Wybierz inny produkt Klarna",
						"sub_title_ongoing_product": "Kontynuuj konfigurację produktu „{productName}”."
					},
					"sidebar_left": {
						"products": {
							"title": "Produkty płatnicze",
							"text_blocks": [
								{
									"text": "Dodaj rozwiązanie do swojej konfiguracji"
								}
							]
						}
					},
					"buttons": {
						"start": "Start",
						"continue": "Kontynuuj",
						"view_summary": "Zobacz podsumowanie",
						"add_another_product": "Dodaj kolejny produkt"
					},
					"goodie_bags": {
						"playground": {
							"title": "Otoczenie",
							"text": "Przełącz się do środowiska Playground, aby poznać i wygenerować poświadczenia testowe API i przetestować swoją platformę.",
							"link": "Otoczenie"
						},
						"marketing_assets": {
							"title": "Zasoby marketingowe",
							"text": "Korzystanie z Klarna to smoooth przejażdżka dla Twoich klientów. Wykorzystaj nasze zasoby marketingowe, aby ich zachwycić.",
							"link": "Pobierz zasoby"
						},
						"your_application": {
							"title": "Twój wniosek",
							"text": "Kliknij tutaj, aby zakończyć konfigurację lub wyświetlić szczegóły wniosku, w tym Warunki i regulamin.",
							"link": "Otwarte"
						},
						"invite_more_users": {
							"title": "Zaproś więcej użytkowników",
							"text": "Zaproś swoich współpracowników do Portalu dla handlowców. Pozwoli Ci to ustawić własne uprawnienia dla każdego z nich!",
							"link": "Zaproś użytkowników"
						}
					},
					"footer": {
						"title": "Zawsze w zestawie z Klarna",
						"list": {
							"merchant_portal": {
								"title": "Portal dla handlowców",
								"text_blocks": [
									{
										"text": "Zarządzaj wszystkim, co dotyczy Klarna, z pełnym dostępem do backendu."
									}
								]
							},
							"global_products": {
								"title": "Globalne produkty, lokalne twarze",
								"text_blocks": [
									{
										"text": "Wszystkie nasze produkty są być dostosowane do lokalnych preferencji i przepisów."
									}
								]
							},
							"local_support": {
								"title": "Lokalne wsparcie dla Ciebie i Twoich klientów",
								"text_blocks": [
									{
										"text": "Mamy tysiące ludzi gotowych do pomocy Twoim klientom, gdy potrzebna jest ludzka ręka."
									}
								]
							},
							"marketing_tool": {
								"title": "Klarna jako narzędzie marketingowe",
								"text_blocks": [
									{
										"text": "Zapewnimy Ci dostęp do materiałów Klarna, które możesz wykorzystać w swoich inicjatywach marketingowych."
									}
								]
							},
							"single_integration": {
								"title": "Pojedyncza integracja, automatyczne aktualizacje",
								"text_blocks": [
									{
										"text": "Jedna integracja, brak aktualizacji. Nigdy."
									},
									{
										"text": "Po zintegrowaniu Klarna, to będzie już wszystko. Zawsze aktualna – a Ty nie musisz nawet kiwnąć palcem."
									}
								]
							},
							"no_risk": {
								"title": "Brak ryzyka dla Ciebie i Twoich klientów",
								"text_blocks": [
									{
										"text": "Twoje wypłaty są zawsze gwarantowane, a Twoi klienci są objęci Programem ochrony kupujących Klarna."
									}
								]
							}
						}
					}
				},
				"credentials_page": {
					"sidebar_left": {
						"connection_key": {
							"title": "Dane uwierzytelniające API Klarna",
							"text_blocks": [
								{
									"text": "Dane uwierzytelniające API Klarna łączą nasz produkt z Twoim sklepem, co pozwoli Ci rozpocząć sprzedaż."
								}
							]
						},
						"toc_key": {
							"title": "Warunki i regulamin",
							"text_blocks": [
								{
									"text": "Musisz zaktualizować swoje Warunki i regulamin dotyczące handlu elektronicznego"
								}
							]
						},
						"connect_to_your_platform": {
							"title": "Instrukcja na temat integracji",
							"text_blocks": [
								{
									"text": ""
								}
							]
						}
					},
					"main": {
						"how_to_use": {
							"title": "Jak korzystać z danych uwierzytelniających API Klarna",
							"ordered_list": {
								"one": "Wygeneruj i pobierz swoje dane uwierzytelniające",
								"two": "Wklej dane uwierzytelniające (nazwa użytkownika API Klarna i hasło) do swojej platformy, tak jak wyjaśniono w instrukcjach integracji poniżej"
							}
						},
						"number_of_live_keys_in_total": {
							"title": "Łącznie 5 poświadczeń API Klarna",
							"text": "Możesz wygenerować do pięciu poświadczeń API Klarna. Pobierz pierwsze z nich tutaj, a następnie utwórz pozostałe w Ustawieniach.",
							"button": "Generowanie poświadczeń API Klarna"
						},
						"how_to_update_toc": {
							"title": "Jak zaktualizować Warunki i Regulamin",
							"ordered_list": {
								"one": "Odwiedź stronę",
								"two": "Przeczytaj instrukcję i skopiuj tekst",
								"three": "Umieść go w regulaminie swojego sklepu internetowego."
							}
						},
						"update_toc_link": {
							"title": "",
							"text": "Pamiętaj, aby zaktualizować tekst o produkty, na które się zapisano.",
							"linkText": "Przejdź do aktualizacji Warunków i regulaminu >"
						},
						"buttons": {
							"back": "Wstecz"
						}
					}
				},
				"whats_next_page": {
					"communication": {
						"TRANSACTIONS_REVIEW_AUTOMATED": "Twój wniosek jest w trakcie sprawdzania…",
						"TRANSACTION_DETAILS_STARTED": "Twój wniosek jest w trakcie sprawdzania przez nasz zespół. Odezwiemy się do Ciebie tak szybko, jak to możliwe.",
						"TRANSACTIONS_REVIEW_MANUAL": "Twój wniosek jest w trakcie sprawdzania przez nasz zespół. Odezwiemy się do Ciebie tak szybko, jak to możliwe.",
						"TRANSACTIONS_ENABLED": "Gratulacje! Możesz już zacząć sprzedawać wspólnie z Klarna.",
						"PAYOUTS_REVIEW_AUTOMATED": "Twoja prośba o wypłatę jest w trakcie rozpatrywania...",
						"PAYOUTS_REVIEW_MANUAL": "Twoja prośba o wypłatę jest sprawdzana przez nasz zespół. Odezwiemy się do Ciebie tak szybko, jak to możliwe.",
						"PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION": "Czekamy na Twoją pierwszą sprzedaż z Klarna...",
						"TRANSACTIONS_DISABLED": "Twoje konto jest nieaktywne do czasu zakończenia etapu włączania wypłat.",
						"SUSPENDED": "Twoje konto jest zawieszone.",
						"notice": "Obecnie mamy dłuższy czas oczekiwania na rozpatrzenie Twojego wniosku. Nie martw się, Twój wniosek jest sprawdzana, a my skontaktujemy się z Tobą w celu przekazania Ci informacji o kolejnych krokach. Doceniamy Twoją cierpliwość i dziękujemy za wyrozumiałość."
					},
					"statuses": {
						"pending": "Otwarte",
						"done": "Gotowe"
					},
					"in_review": {
						"title": "Sprawdzamy Twój wniosek",
						"subtitle": "Obecnie dokonujemy ostatecznego przeglądu Twojego wniosku przesłanego do Klarna, aby upewnić się, że wszystko w umowie wygląda poprawnie. Jest to proces ręczny, więc czas obsługi może się różnić, ale zrobimy to tak szybko, jak to możliwe.",
						"content": {
							"title": "Aby przegląd był wykonany jak najszybciej, upewnij się, że w Twojej witrynie internetowej widoczne są poniższe informacje:",
							"list": {
								"default": {
									"item_1": "Nazwa zarejestrowanej firmy",
									"item_2": "Numer zarejestrowanej firmy",
									"item_3": "Adres zarejestrowanej firmy",
									"item_4": "Polityka zwrotów wynosząca co najmniej 14 dni",
									"item_5": "Adres e-mail lub numer do obsługi klienta"
								},
								"US": {
									"item_1": "Zarejestrowana nazwa firmy",
									"item_2": "Polityka zwrotów",
									"irem_3": "Adres e-mail lub numer do obsługi klienta"
								},
								"AU": {
									"item_1": "ABN (numer firmy) lub zarejestrowana nazwa firmy.",
									"item_3": "Adres zarejestrowanej firmy",
									"item_4": "Polityka zwrotów wynosząca co najmniej 14 dni",
									"item_5": "Adres e-mail lub numer do obsługi klienta"
								}
							}
						},
						"footer": "Wyślemy Ci wiadomość e-mail, gdy przegląd zostanie zakończony lub gdy będziemy potrzebować od Ciebie dodatkowych informacji."
					},
					"suspended": {
						"title": "Niestety...",
						"subtitle": "Po zapoznaniu się ze szczegółami Twojej umowy, musieliśmy odrzucić Twój wniosek. Może być kilka powodów, dla których Twój wniosek nie został zatwierdzony. Poniżej przedstawiamy kilka najczęstszych czynników ogólnych:",
						"content": {
							"title": "",
							"list": {
								"item_1": "Twój sklep nie spełnia wymogów etycznych firmy Klarna.",
								"item_2": "Podana osoba kontaktowa jest nieosiągalna.",
								"item_3": "Inne czynniki techniczne lub administracyjne."
							}
						},
						"footer": "Dziękujemy za zainteresowanie Klarna. Jeśli masz jakiekolwiek pytania dotyczące lub jeśli zechcesz zarejestrować inny sklep w przyszłości – skontaktuj się z nami."
					},
					"disabled": {
						"title": "Twoja aplikacja jest nieaktywna.",
						"subtitle": "Twoje konto zostało automatycznie zablokowane, ponieważ brakuje prawnie wymaganych informacji.",
						"content": {
							"title": "Zwykle dzieje się tak, gdy Klarna poprosi Cię o podanie pewnych informacji i nie otrzyma odpowiedzi przed upływem wyznaczonego terminu."
						},
						"footer": "Jeśli uważasz, że jest to błąd lub chcesz ponownie przesłać informacje, skontaktuj się z działem wsparcia dla handlowców, korzystając z informacji kontaktowych w stopce tej strony."
					},
					"ready_to_connect": {
						"title": "Połącz swój sklep",
						"subtitle": "Twoja umowa jest kompletna i możesz teraz zintegrować Klarna w swoim sklepie. Wykonaj poniższe kroki, aby zakończyć integrację.",
						"status_messsage": {
							"title": "Integracja jeszcze nie została zakończona",
							"subtitle": "Postępuj zgodnie z instrukcjami integracji, aby połączyć swój sklep. Gdy zostanie dokonana transakcja przy użyciu Klarna, status ten zmieni kolor na zielony."
						},
						"content": {
							"title": "Instrukcje",
							"options": {
								"label_1": "Wygeneruj i zapisz dane uwierzytelniające API Klarna",
								"description_1": "Wygeneruj nowe dane uwierzytelniające API i pobierz je na swój komputer. Będziesz potrzebować tych danych uwierzytelniających API w następnej sekcji.",
								"label_2": "Instalacja Klarna w swoim sklepie Shopify"
							}
						}
					},
					"ready_to_connect_new_ig": {
						"title": "Już prawie koniec!",
						"subtitle": "Jesteś o krok bliżej do zaoferowania swoim klientom smoooth zakupów! Twoja umowa została sfinalizowana, a sklep jest gotowy do integracji.",
						"buttons": {
							"connect": "Połącz swój sklep"
						},
						"additional_info": "Pamiętaj, że integracja zostanie oznaczona jako w pełni ukończona dopiero po otrzymaniu pierwszego zakupu, co może zająć trochę czasu w zależności od platformy."
					},
					"store_connected": {
						"title": "Twój sklep jest połączony",
						"subtitle": "Integracja Twojego sklepu z Klarna została zakończona i Twoi klienci mogą już płacić za pomocą Klarna.",
						"status_messsage": {
							"title": "Integracja zakończona sukcesem",
							"subtitle": "Transakcja Klarna została pomyślnie przetworzona przez Twój sklep.",
							"button_text": {
								"shown": "Pokaż instrukcje integracji",
								"hidden": "Pokaż instrukcje integracji"
							}
						}
					},
					"actions": {
						"view_summary": {
							"title": "Twój wniosek",
							"subtitle": "Przejrzyj informacje o swoim wniosku.",
							"button_text": "Pokaż podsumowanie"
						},
						"connect_store": {
							"title": "Dane uwierzytelniające API Klarna",
							"subtitle": "Wygeneruj dane uwierzytelniające API Klarna, aby zintegrować swój sklep.",
							"button_text": "Generowanie danych uwierzytelniających API Klarna"
						},
						"add_product": {
							"title": "Produkty",
							"subtitle": "Kliknij tutaj, jeśli chcesz dodać produkt dla tej konfiguracji.",
							"button_text": "Dodaj produkty"
						}
					},
					"timeline": {
						"application": {
							"title": "Twój wniosek",
							"alert": {
								"view_summary": "Pokaż podsumowanie",
								"rejected": "Musieliśmy odrzucić Twój wniosek.",
								"review": "Zapoznaj się z informacjami na temat wniosku, klikając poniższe łącze."
							}
						},
						"payouts": {
							"title": "Wypłaty włączone"
						},
						"integration": {
							"title": "Integracja jeszcze nie została zakończona",
							"alert": "Postępuj zgodnie z instrukcjami integracji, aby połączyć swój sklep."
						},
						"integration_complete": {
							"title": "Integracja zakończona!"
						}
					}
				},
				"summary_page": {
					"header": {
						"title": "Gratulacje, Twoja konfiguracja została zakończona!",
						"rejection": "Przepraszamy, nie mogliśmy zakończyć konfiguracji."
					},
					"header_new": {
						"title": "Witaj, Sprzedawco Klarna!",
						"subtitle": "Podsumowanie",
						"rejection": "Wniosek odrzucony"
					},
					"joy_section": {
						"approved": {
							"title": "Zatwierdzone!",
							"content": "Twój wniosek został sprawdzony i zatwierdzony. Pełny dostęp do usług Klarna jest teraz na wyciągnięcie ręki. Cieszymy się, że będziemy mogli z Tobą pracować!",
							"button_title": "Sprawdź swoje zamówienia",
							"link": "lub nasze materiały marketingowe"
						},
						"rejected": {
							"title": "Niestety...",
							"content_1": "Po zapoznaniu się z Twoim wnioskiem nie jesteśmy w stanie zatwierdzić Twojej umowy dla sprzedawcy.",
							"content_2": "W razie jakichkolwiek pytań prosimy o kontakt z naszym zespołem pomocy technicznej."
						}
					},
					"sidebar_left": {
						"application_details": "Dane dotyczące Twojego wniosku",
						"store_details": {
							"title": "Szczegóły sklepu",
							"text_blocks": [
								{
									"text": "Podsumowanie Twoich danych"
								}
							]
						},
						"credentials": {
							"title": "Dane uwierzytelniające API Klarna",
							"text_blocks": [
								{
									"text": "Twoje dane uwierzytelniające API Klarna"
								}
							]
						},
						"payouts": {
							"title": "Wypłaty",
							"text_blocks": [
								{
									"text": "Twoje dane bankowe"
								}
							]
						},
						"additional_bank_accounts": {
							"title": "Dodatkowe rachunki bankowe",
							"text_block": null
						},
						"business_owners": {
							"title": "Właściciele firmy",
							"text_blocks": null
						},
						"material_influencers": {
							"title": "Osoby decyzyjne",
							"text_blocks": null
						},
						"stakeholders": {
							"title": "Interesariusze",
							"text_blocks": [
								{
									"text": "Przesłane przez Ciebie informacje"
								}
							]
						}
					},
					"main": {
						"store_details": {
							"business_owners": {
								"title": "Właściciele firmy",
								"no_elements": "Nie zgłoszono żadnych właścicieli firm"
							}
						},
						"payouts": {
							"default_bank_accounts": {
								"title": "Domyślne konto bankowe",
								"no_elements": "Brak domyślnego konta bankowego"
							},
							"additional_bank_accounts": {
								"title": "Dodatkowe rachunki bankowe",
								"no_elements": "Nie podano żadnych dodatkowych rachunków bankowych"
							}
						},
						"stakeholders": {
							"owners": {
								"title": "Właściciele",
								"no_elements": "Nie zgłoszono żadnych właścicieli"
							},
							"ultimate_beneficial_owner": {
								"title": "Beneficjenci",
								"no_elements": "Nie zgłoszono żadnych beneficjentów"
							},
							"applicant": {
								"title": "Wnioskodawcy",
								"no_elements": "Nie zgłoszono żadnych wnioskodawców"
							},
							"control_over_management": {
								"title": "Osoby sprawujące kontrolę nad zarządzaniem",
								"no_elements": "Nie zgłoszono żadnych interesariuszy zarządzających"
							}
						},
						"buttons": {
							"back": "Wstecz",
							"next_step": "Dalej"
						}
					}
				},
				"additional_products_page": {
					"sidebar_left": {
						"we_have_your_data": {
							"title": "Mamy już Twoje dane",
							"text_blocks": [
								{
									"text": "Są to informacje, które zostały nam wcześniej przekazane."
								}
							]
						}
					},
					"main": {
						"business_ownership": {
							"no_elements": "Nie zgłoszono żadnych właścicieli firm"
						},
						"buttons": {
							"submit": "Prześlij",
							"back": "Wstecz"
						}
					}
				},
				"checking_page": {
					"title": "Bieżący",
					"subtitle": "Dziękujemy za przesłanie zgłoszenia. Prosimy poczekać, aż je sprawdzimy..."
				},
				"success_page": {
					"title": "Teraz możesz połączyć swój sklep",
					"subtitle": "Dziękujemy za przesłanie wniosku.",
					"buttons": {
						"next": "Dalej"
					}
				}
			},
			"components": {
				"split_image_container": {
					"timeline": {
						"basics": "Podstawy",
						"business": "Firmy",
						"stakeholders": "Interesariusze",
						"bank_accounts": "Rachunki bankowe"
					}
				},
				"app_error": {
					"title": "Aplikacja Produkty jest obecnie niedostępna",
					"message": "Mamy małe problemu z naszą aplikacją i już nad tym pracujemy. Staramy się rozwiązywać problemy tak szybko, jak to możliwe. Spróbuj ponownie później."
				},
				"temporarily_down": {
					"title": "Mamy pewne problemy techniczne.",
					"message": "Przepraszamy za wszelkie niedogodności i zapewniamy, że robimy wszystko, co w naszej mocy, aby rozwiązać ten problem. Prosimy o ponowne odwiedziny w późniejszym terminie."
				},
				"maintenance_mode": {
					"title": {
						"products_app": "Nasza aplikacja Produkty jest obecnie wyłączona z powodu konserwacji",
						"signup_app": "Nasza aplikacja Rejestracja jest obecnie wyłączona z powodu konserwacji"
					},
					"message": "Pracujemy nad poprawą Twoich wrażeń i mamy nadzieję, że uda nam się to zrobić jak najszybciej. Prosimy o ponowne odwiedziny w późniejszym terminie."
				},
				"unknown_merchant": {
					"before_link": "Jeśli masz już z nami umowę, odwiedź",
					"link_text": "tę stronę",
					"after_link": "i dowiedz się więcej o naszych produktach!"
				},
				"pre_assessment_error": {
					"title": {
						"invalid_flow_type": "Wystąpił błąd.",
						"invalid_token": "Ten link wygasł"
					},
					"message": {
						"invalid_token_risk": " Prosimy o kontakt na kanale #smooothforce-support, a pomożemy Ci rozwiązać problem.",
						"invalid_token": "Prosimy o kontakt z przedstawicielem handlowym.",
						"invalid_flow_type": "Typ i status wdrożenia tego sprzedawcy są niezgodne. Jeśli uważasz, że jest to błąd, prosimy o kontakt z działem wsparcia dla handlowców."
					}
				},
				"topbar": {
					"title": "Konfiguracja",
					"widget_type": {
						"MANAGED_KYC": "Gromadzenie danych KYC",
						"MANAGED_RISK": "Gromadzenie danych do oceny wstępnej",
						"MANAGED_SME_RISK": "Gromadzenie danych do oceny wstępnej MŚP"
					}
				},
				"product_card": {
					"incompatible_description": "Niedostępne dla Twojego kraju/platformy",
					"kco_footer_text": "Metody płatności dostępne w Płatnościach Klarna zależą od kraju, w którym dokonano rejestracji oraz kraju, w którym prowadzisz sprzedaż.",
					"products_link_text": "Więcej"
				},
				"product_prices_card": {
					"title": "Produkty",
					"subtitle": "{country}",
					"pricing": "{country} – cennik",
					"monthly_fee": "Opłata miesięczna",
					"transaction_fee": "Prowizja od transakcji",
					"before_link": "Zgadzam się na przedstawione przez Klarna",
					"link_text": "Warunki i regulamin",
					"after_link_one_product": "dla tego produktu",
					"after_link_more_than_one_product": "dla tych produktów",
					"product_not_available_in_your_country": "* Ten produkt nie jest dostępny na Twoim rynku, ale będzie działać w innych krajach.",
					"edit_link": "Edytuj",
					"merchant_agreement": {
						"before_link": "Akceptuję",
						"link_text": "Umowę handlową",
						"after_link_one_product": "dla tego produktu",
						"after_link_more_than_one_product": "dla tych produktów"
					},
					"pricing_annex": {
						"before_link": "Akceptuję",
						"link_text": "Warunki cenowe",
						"after_link_one_product": "dla tego produktu"
					}
				},
				"support_footer": {
					"text": "Wsparcie w języku angielskim",
					"copyright": {
						"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Wszelkie prawa zastrzeżone.",
						"ap": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579.",
						"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215."
					},
					"terms_and_conditions": "Warunki i regulamin.",
					"privacy_policy": "Polityka prywatności",
					"merchant_id": "ID sprzedawcy {merchantId}",
					"email": "moa.support@klarna.com",
					"contact_number": "+46 (8) 123 45 67",
					"support_link": "Wsparciem dla handlowców,",
					"recaptcha": {
						"1_main_text": "Ta strona jest chroniona przez reCAPTCHA i Google",
						"2_privacy_policy": "Polityka prywatności",
						"3_and": "a następnie",
						"4_terms_of_service": "Warunki korzystania z usługi",
						"5_apply": "Zastosuj"
					}
				},
				"global_prices_dialog": {
					"title_eu": "Ceny w innych krajach",
					"title_us": "Ceny",
					"subtitle": "Pobieramy tylko opłaty związane z dokonanymi zamówieniami - to jest właśnie smoooth!",
					"table": {
						"country": "Kraj",
						"price_column_heading": "Opłata za transakcję",
						"global": "Globalnie",
						"title": {
							"kp": "Sposoby płatności",
							"kco": "Klarna Checkout",
							"kco_one": "Klarna Checkout",
							"kp_one": "Klarna Payment Method"
						},
						"headers": {
							"kp_one": "Opłata za obsługę"
						}
					},
					"buttons": {
						"back": "Wstecz"
					},
					"foot_notes": {
						"global_price": "* Lokalna waluta sprzedawcy, w przeciwnym razie "
					}
				},
				"fake_approval": {
					"first_transaction": {
						"title": "Pierwsza transakcja",
						"content": "Zanim będziemy mogli sprawdzić szczegóły wypłaty, wymagamy pierwszego zamówienia. Nie chcesz marnować własnych pieniędzy? Żaden problem.",
						"button": "Udawaj!"
					},
					"transactions": {
						"title": "Zatwierdzanie transakcji",
						"content": "Możesz po prostu wprowadzić nieistniejące zatwierdzenie transakcji salesforce",
						"button": "Zatwierdź"
					},
					"payouts": {
						"title": "Zatwierdzanie wypłat",
						"content": "Możesz po prostu wprowadzić nieistniejące zatwierdzenie wypłaty salesforce",
						"button": "Zatwierdź"
					}
				},
				"bank_account_summary": {
					"subtitle": {
						"default": "Domyślne konto bankowe",
						"additional": "Dodatkowy rachunek bankowy {index}",
						"normal": "Konto bankowe {index}"
					},
					"currency_code": {
						"label": "Waluta"
					},
					"country_of_bank_account": {
						"label": "Kraj"
					},
					"account_number": {
						"label": {
							"default": "Numer konta",
							"MX_LOCAL": "Numer CLABE"
						}
					},
					"account_holder": {
						"label": "Nazwisko posiadacza rachunku"
					},
					"routing_number": {
						"label": "Numer rozliczeniowy"
					},
					"transit_number": {
						"label": "Numer tranzytowy"
					},
					"institution_number": {
						"label": "Numer instytucji"
					},
					"bic": {
						"label": {
							"default": "BIC",
							"AU": "BSB"
						}
					},
					"no_edit_button": "Możesz edytować informacje o rachunku bankowym po zakończeniu wdrożenia"
				},
				"store_details_summary": {
					"legal_company_name": {
						"label": "Nazwa prawna przedsiębiorstwa"
					},
					"country": {
						"label": "Kraj"
					},
					"registrationId": {
						"label": {
							"default": "Numer rejestracyjny",
							"AT": "Numer rejestracyjny",
							"AU": "ACN",
							"CA": "Numer firmowy",
							"ES": "NIF / NIE / DNI firmy",
							"GB": "Numer organizacji",
							"GR": "Numer G.E.MI. (Γ.Ε.ΜΗ.)",
							"US": "Numer identyfikacyjny pracodawcy"
						}
					},
					"organizationRegistrationAuthority": {
						"label": "Sąd rejestrowy"
					},
					"goodsCategory": {
						"label": "Kategoria towarów"
					},
					"registered": {
						"label": {
							"default": "Zarejestrowana firma",
							"AU": "Firma posiada numer ACN"
						}
					},
					"subjectToVat": {
						"label": {
							"default": "Firma podlega VAT",
							"AU": "Firma podlega ABN",
							"ES": "Firma posiada NIF / NIE / DNI"
						}
					},
					"vatId": {
						"label": {
							"default": "Numer VAT",
							"AU": "ABN",
							"ES": "NIF / NIE / DNI firmy"
						}
					},
					"storeName": {
						"label": "Nazwa sklepu"
					},
					"website": {
						"label": "Witryna internetowa"
					},
					"email": {
						"label": "E-mail do obsługi klienta"
					},
					"entityType": {
						"label": "Typ podmiotu"
					},
					"toc_data": {
						"label": "Warunki i regulamin",
						"toc_approval_text": {
							"before_link": "Twoje",
							"link_text": "Warunki i regulamin",
							"after_link": "zaakceptowane {date}",
							"merchant_agreement": {
								"before_link": "Twoja",
								"link_text": "Umowa handlowa",
								"after_link": "zaakceptowana {date}"
							},
							"pricing_annex": {
								"before_link": "Twój",
								"link_text": "Załącznik cenowy",
								"after_link": "zaakceptowano {date}"
							}
						}
					},
					"companyName": {
						"label": "Nazwa spółki"
					},
					"registeredCompanyName": {
						"label": "Nazwa firmy"
					},
					"address": {
						"label": "Adres"
					},
					"operatingAddress": {
						"label": "Adres operacyjny"
					},
					"organizationEntityType": {
						"label": "Klasyfikacja podatkowa"
					}
				},
				"api_key_dialog": {
					"title": "Wygenerowano dane uwierzytelniające API Klarna!",
					"subtitle": "Dane uwierzytelniające zostaną wyświetlone tylko jeden raz. Kliknij poniższy przycisk, aby pobrać swoje dane uwierzytelniające przed zamknięciem tego okna.",
					"key_box": {
						"username": {
							"label": "nazwa użytkownika api klarna"
						},
						"password": {
							"label": "Hasło API Klarna"
						},
						"file_name": "Klarna_credentials"
					},
					"buttons": {
						"download": "Pobierz jako .txt"
					}
				},
				"platform_instructions": {
					"step": "Krok {current}/{max}",
					"next": "Dalej",
					"back": "Wstecz",
					"shopify": [
						{
							"title": "Wygeneruj i zapisz dane uwierzytelniające API Klarna",
							"step_instructions": [
								[
									{
										"text": "Wygeneruj nowe dane uwierzytelniające API i pobierz plik na swój komputer. Otwórz plik i pozostaw otwarty, ponieważ będziesz potrzebować tych danych uwierzytelniających API w następnej sekcji."
									}
								]
							],
							"alternate": [
								{
									"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopify, postępuj zgodnie z"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "rozszerzonym przewodnikiem po integracji."
								}
							]
						},
						{
							"title": "Instalacja Klarna w swoim sklepie Shopify",
							"step_instructions": [
								[
									{
										"text": "Przejdź do"
									},
									{
										"link": "https://www.klarnapayments.com/merchant_admin/guide/install_app/slice_it_pay_over_time_with_klarna/enter-your-shopify-store-name-here",
										"text": "Kreator konfiguracji wtyczki Klarna Payment Method dla Shopify."
									}
								],
								[
									{
										"text": "Postępuj zgodnie z instrukcjami, aby zakończyć integrację."
									}
								]
							],
							"alternate": [
								{
									"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopify, postępuj zgodnie z"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "rozszerzonym przewodnikiem po integracji."
								}
							]
						},
						{
							"title": "Dokonaj zakupu próbnego",
							"step_instructions": [
								[
									{
										"text": "Aby sprawdzić, czy integracja jest poprawnie skonfigurowana, prosimy o dokonanie próbnego zakupu w Waszym sklepie."
									}
								],
								[
									{
										"text": "Po złożeniu zamówienia przejdź do sekcji"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Zamówienia w Portalu dla handlowców,"
									},
									{
										"text": "znajdź swoje zamówienie i anuluj je, aby nie płacić za nie."
									}
								],
								[
									{
										"text": "Gdy integracja przebiegnie pomyślnie, baner na górze strony zmieni kolor na zielony i wyświetli napis „Integracja zakończona”."
									}
								]
							],
							"alternate": [
								{
									"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopify, postępuj zgodnie z"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "rozszerzonym przewodnikiem po integracji."
								}
							]
						}
					],
					"plentymarkets": [
						{
							"title": "Aktywacja wtyczki Klarna Payment Method dla Plentymarkets",
							"step_instructions": [
								[
									{
										"text": "Aby zainstalować wtyczkę Klarna, potrzebujesz działającego systemu Plentymarkets CERES. Wtyczka"
									},
									{
										"link": "https://marketplace.plentymarkets.com/en/plugins/sales/online-shops/ceres_4697",
										"text": "Ceres"
									},
									{
										"text": "jest dostępna do pobrania na stronie plentyMarketplace. Stamtąd również przejdziesz do"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/online-store/setting-up-ceres",
										"text": "instrukcji instalacji."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Szczegółowe informacje na temat integracji Klarna z Plentymarkets Ceres można znaleźć pod"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "tym linkiem."
									}
								]
							]
						},
						{
							"title": "Instalacja i konfiguracja",
							"step_instructions": [
								[
									{
										"text": "Instalacja wtyczki Klarna odbywa się poprzez"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "plentyMarketplace."
									},
									{
										"text": "Nastąpi również przekierowanie do plentyMarketplace z backendu systemu plentymarkets. Instrukcję,"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/slp/plugins/plugins-system-hinzufuegen",
										"text": "jak zainstalować wtyczki w plentymarkets,"
									},
									{
										"text": "znajdziesz na stronie plentyKnowledge."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Szczegółowe informacje na temat integracji Klarna z Plentymarkets Ceres można znaleźć pod"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "tym linkiem."
									}
								]
							]
						},
						{
							"title": "Konfiguracja wtyczki",
							"step_instructions": [
								[
									{
										"text": "Konfiguracja wtyczki odbywa się bezpośrednio w danym zestawie. Gdy klikniesz wiersz"
									},
									{
										"bold": "wtyczki Klarna,"
									},
									{
										"text": "otworzy się strona konfiguracji."
									}
								],
								[
									{
										"text": "Konfiguracja podzielona jest na dwa obszary:"
									},
									{
										"list": [
											[
												{
													"bold": "Uwierzytelnianie:"
												},
												{
													"text": "Tryb służy do określenia, czy jest to tryb testowy czy produkcyjny. W zależności od trybu pracy należy zapisać nazwę użytkownika i hasło."
												}
											],
											[
												{
													"bold": "Ustawienia ogólne:"
												},
												{
													"text": "Tutaj wybierasz produkt, którego chcesz użyć. Albo poszczególne metody płatności Klarna (Klarna Payment), albo cała kasa Klarna (Klarna Checkout). Przy wyborze Klarna Checkout kasa w sklepie zostanie automatycznie nadpisana przez Klarna Checkout."
												}
											]
										]
									},
									{
										"text": "Nie ma potrzeby wprowadzania dalszych ustawień, a jeśli dezaktywujesz wtyczkę, zostanie ona cofnięta."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Szczegółowe informacje na temat integracji Klarna z Plentymarkets Ceres można znaleźć pod"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "tym linkiem."
									}
								]
							]
						},
						{
							"title": "Informacje końcowe",
							"step_instructions": [
								[
									{
										"text": "Obowiązują następujące wymagania systemowe:"
									},
									{
										"list": [
											{
												"text": "Plentymarkets wersja 7"
											},
											{
												"text": "Zainstalowane Ceres i IO Plugins"
											}
										]
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Szczegółowe informacje na temat integracji Klarna z Plentymarkets Ceres można znaleźć pod"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "tym linkiem."
									}
								]
							]
						}
					],
					"woocommerce_kco": [
						{
							"title": "Aktywacja wtyczki Płatności Klarna (Klarna Checkout) dla WooCommerce",
							"step_instructions": [
								[
									{
										"text": "Po pierwsze, upewnij się, że zainstalowano wtyczkę Klarna Checkout dla WooCommerce. Jeśli nie masz jeszcze tej wtyczki, przejdź na"
									},
									{
										"link": "https://woocommerce.com/products/klarna-checkout/#",
										"text": "tę stronę,"
									},
									{
										"text": "aby ją pobrać."
									}
								],
								[
									{
										"text": "Gdy zdobędziesz już swoje dane uwierzytelniające API Klarna, przejdź do sekcji „Ustawienia”, a następnie „Kasa” (Checkout) w panelu WooCommerce. Wybierz Klarna Checkout."
									}
								],
								[
									{
										"text": "Włącz Klarna Checkout poprzez zaznaczenie pola wyboru „Włącz Klarna Checkout”."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji WooCommerce, zapoznaj się z ich"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "rozszerzonym przewodnikiem."
									}
								]
							]
						},
						{
							"title": "Konfiguracja swoich ustawień",
							"step_instructions": [
								[
									{
										"text": "Skonfiguruj ustawienia dla swojej wtyczki Klarna Checkout. Zwróć uwagę, że pole „Tytuł” jest używane do ustawienia tytułu dla metody płatności wyświetlanej w kasie i e-mailach potwierdzających zamówienie (np. Klarna Checkout)."
									}
								],
								[
									{
										"text": "Zaznacz pole wyboru „Tryb testowy”, jeśli chcesz tworzyć zamówienia z użyciem poświadczeń testowych."
									}
								],
								[
									{
										"text": "Teraz nadszedł czas, aby wypełnić ustawienia kraju. Jeśli mieszkasz w Europie, kliknij „rozwiń” w sekcji Europa. Jeśli mieszkasz w USA, kliknij „rozwiń” w sekcji Stany Zjednoczone."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji WooCommerce, zapoznaj się z ich"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "rozszerzonym przewodnikiem."
									}
								]
							]
						},
						{
							"title": "Dodawanie swoich danych uwierzytelniających API Klarna",
							"step_instructions": [
								[
									{
										"text": "Dodaj swoje dane uwierzytelniające API Klarna w polach nazwa użytkownika Klarna API i hasło Klarna API."
									}
								],
								[
									{
										"text": "Zapisz ustawienia."
									}
								],
								[
									{
										"text": "Ostatnią rzeczą do zrobienia jest ustawienie Klarna Checkout jako domyślnego sposobu płatności. Przejdź do sekcji „Ustawienia”, a następnie „Płatności” w swoim panelu WooCommerce. Znajdź sekcję „Sposoby płatności” i ustaw Klarna Checkout jako domyślny."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji WooCommerce, zapoznaj się z ich"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "rozszerzonym przewodnikiem."
									}
								]
							]
						},
						{
							"title": "Kroki końcowe",
							"step_instructions": [
								[
									{
										"text": "Upewnij się, że masz włączone"
									},
									{
										"link": "https://codex.wordpress.org/Using_Permalinks",
										"text": "ładne permalinki"
									},
									{
										"text": "w swojej instalacji WordPress. W przeciwnym razie wywołania zwrotne z Klarna do Twojego sklepu nie będą działać, a zamówienia nie będą aktualizowane z prawidłowym statusem zamówienia/informacjami."
									}
								],
								[
									{
										"text": "Jeśli chcesz obsługiwać zamówienia Klarna bezpośrednio w WooCommerce, zainstaluj wtyczkę"
									},
									{
										"link": "https://wordpress.org/plugins/klarna-order-management-for-woocommerce/",
										"text": "Zarządzanie zamówieniami Klarna"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Upewnij się, że Płatności Klarna wyświetlają się zgodnie z oczekiwaniami – dodaj przedmiot do koszyka i przejdź do kasy (nie składaj zamówienia)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji WooCommerce, zapoznaj się z ich"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "rozszerzonym przewodnikiem."
									}
								]
							]
						}
					],
					"woocommerce_kp": [
						{
							"title": "Wygeneruj i zapisz dane uwierzytelniające API Klarna",
							"step_instructions": [
								[
									{
										"text": "Wygeneruj nowe dane uwierzytelniające API i pobierz plik na swój komputer. Otwórz plik i pozostaw otwarty, ponieważ będziesz potrzebować tych danych uwierzytelniających API w następnej sekcji."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji WooCommerce, zapoznaj się z ich"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "rozszerzonym przewodnikiem po integracji."
									}
								]
							]
						},
						{
							"title": "Instalacja i uruchomienie wtyczki Klarna Payment Method",
							"step_instructions": [
								[
									{
										"text": "Zainstaluj"
									},
									{
										"link": "https://woocommerce.com/products/klarna-payments/",
										"text": "Wtyczka Klarna Payment Method dla WooCommerce."
									}
								],
								[
									{
										"text": "Na swoim koncie WooCommerce wybierz kolejno"
									},
									{
										"bold": "Ustawienia → Płatności → Klarna Payment Method."
									}
								],
								[
									{
										"text": "Włącz wtyczkę Klarna Payment Method, zaznaczając pole wyboru „Włącz wtyczkę Klarna Payment Method”."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji WooCommerce, zapoznaj się z ich"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "rozszerzonym przewodnikiem po integracji."
									}
								]
							]
						},
						{
							"title": "Konfiguracja ustawień kraju",
							"step_instructions": [
								[
									{
										"text": "Wypełnij ustawienia dotyczące kraju. Każdy kraj, w którym działa Klarna, ma swój własny zestaw ustawień specyficznych dla danego kraju. Dodając dane uwierzytelniające sprzedawcy dla danego kraju, włączasz również wtyczkę Klarna Payment Method jako dostępny sposób płatności dla tego kraju."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji WooCommerce, zapoznaj się z ich"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "rozszerzonym przewodnikiem po integracji."
									}
								]
							]
						},
						{
							"title": "Wprowadzanie danych uwierzytelniających API Klarna",
							"step_instructions": [
								[
									{
										"text": "Wprowadź swoje dane uwierzytelniające API Klarna w polach nazwa użytkownika Klarna API i hasło Klarna API."
									}
								],
								[
									{
										"text": "Zapisz ustawienia."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji WooCommerce, zapoznaj się z ich"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "rozszerzonym przewodnikiem po integracji."
									}
								]
							]
						},
						{
							"title": "Dokonaj zakupu próbnego",
							"step_instructions": [
								[
									{
										"text": "Aby sprawdzić, czy integracja jest poprawnie skonfigurowana, prosimy o dokonanie próbnego zakupu w Waszym sklepie."
									}
								],
								[
									{
										"text": "Po złożeniu zamówienia przejdź do sekcji"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Zamówienia w Portalu dla handlowców,"
									},
									{
										"text": "znajdź swoje zamówienie i anuluj je, aby nie płacić za nie."
									}
								],
								[
									{
										"text": "Gdy integracja przebiegnie pomyślnie, baner na górze strony zmieni kolor na zielony i wyświetli napis „Integracja zakończona”."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji WooCommerce, zapoznaj się z ich"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "rozszerzonym przewodnikiem po integracji."
									}
								]
							]
						}
					],
					"magento_kco": [
						{
							"title": "Konfiguracja ustawień dla swojej wtyczki Płatności (Klarna Checkout)",
							"step_instructions": [
								[
									{
										"text": "Po pierwsze, upewnij się, że zainstalowano wtyczkę Klarna Checkout dla Magento. Jeśli nie masz jeszcze tego modułu, przejdź na"
									},
									{
										"link": "https://marketplace.magento.com/klarna-m2-checkout.html",
										"text": "tę stronę,"
									},
									{
										"text": "aby go pobrać."
									}
								],
								[
									{
										"text": "Po uzyskaniu poświadczeń API Klarna otwórz swój panel Magento. Wybierz kolejno Sklepy → Konfiguracja → Sprzedaż → Sposoby płatności → Klarna → Klarna API."
									}
								],
								[
									{
										"text": "Rozwiń sekcję „API Klarna” i podaj wersję API, nazwę użytkownika API Klarna oraz hasło API Klarna. Jeśli chcesz, aby wszystko już działało na Twojej stronie, upewnij się, że wyłączono tryb testowy."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji Magento, zapoznaj się z ich"
									},
									{
										"link": "https://marketplace.magento.com/media/catalog/product/klarna-m2-checkout-6-2-0-ce/user_guides.pdf",
										"text": "rozszerzonym przewodnikiem."
									}
								]
							]
						},
						{
							"title": "Kroki końcowe",
							"step_instructions": [
								[
									{
										"text": "Kiedy ustawienia są skonfigurowane, sprawdź, czy Płatności Klarna są włączone w opcjach kasy."
									}
								],
								[
									{
										"text": "W panelu Magento wybierz kolejno Sklepy → Konfiguracja → Sprzedaż → Kasa → Opcje Płatności Klarna."
									}
								],
								[
									{
										"text": "Płatności Klarna powinny być domyślnie włączone. Jeśli nie, zmień na"
									},
									{
										"bold": "Włącz"
									},
									{
										"text": "w sekcji „Włącz Płatności Klarna”."
									}
								]
							]
						}
					],
					"magento_kp": [
						{
							"title": "Wygeneruj i zapisz dane uwierzytelniające API Klarna",
							"step_instructions": [
								[
									{
										"text": "Wygeneruj nowe dane uwierzytelniające API i pobierz plik na swój komputer. Otwórz plik i pozostaw otwarty, ponieważ będziesz potrzebować tych danych uwierzytelniających API w następnej sekcji."
									}
								]
							]
						},
						{
							"title": "Instalacja i aktywacji modułu Klarna Payment Method",
							"step_instructions": [
								[
									{
										"text": "Odwiedź stronę"
									},
									{
										"link": "https://docs.magento.com/user-guide/payment/klarna-setup.html#set-up-klarna-payments-in-magento",
										"text": "Konfigurowanie Klarna w podręczniku użytkownika Magento"
									},
									{
										"text": "i postępuj zgodnie z instrukcjami, aby zainstalować i skonfigurować moduł na swoim koncie Magento."
									}
								]
							]
						},
						{
							"title": "Dokonaj zakupu próbnego",
							"step_instructions": [
								[
									{
										"text": "Aby sprawdzić, czy integracja jest poprawnie skonfigurowana, prosimy o dokonanie próbnego zakupu w Waszym sklepie."
									}
								],
								[
									{
										"text": "Po złożeniu zamówienia przejdź do sekcji"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Zamówienia w Portalu dla handlowców,"
									},
									{
										"text": "znajdź swoje zamówienie i anuluj je, aby nie płacić za nie."
									}
								],
								[
									{
										"text": "Gdy integracja przebiegnie pomyślnie, baner na górze strony zmieni kolor na zielony i wyświetli napis „Integracja zakończona”."
									}
								]
							]
						}
					],
					"shopware_kp": [
						{
							"title": "Aktywacja wtyczki Klarna Payment Method dla Shopware",
							"step_instructions": [
								[
									{
										"text": "Po pierwsze, upewnij się, że masz zainstalowaną wtyczkę Klarna Payment Method dla Shopware. Jeśli nie masz jeszcze tej wtyczki, przejdź na"
									},
									{
										"link": "https://store.shopware.com/en/besti13231874259f/klarna-payments.html",
										"text": "tę stronę,"
									},
									{
										"text": "aby ją pobrać."
									}
								],
								[
									{
										"text": "W kolejnym kroku należy zaimportować wtyczkę Klarna Payment Method dla Shopware, klikając kolejno"
									},
									{
										"bold": "Konfiguracja → Menedżer wtyczek → Zainstalowane → Prześlij wtyczkę."
									},
									{
										"text": "Kliknij"
									},
									{
										"bold": "Wybierz"
									},
									{
										"text": "i wybrać plik ZIP wtyczki Klarna Payment Method. Potwierdź, klikając"
									},
									{
										"bold": "Prześlij wtyczkę."
									},
									{
										"text": "Wtyczkę znajdziesz teraz w menedżerze wtyczek."
									}
								],
								[
									{
										"text": "Zainstaluj wtyczkę, klikając ikonę"
									},
									{
										"bold": "zielonego symbolu „+”"
									},
									{
										"text": "Ikona"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Konfiguracja wtyczki Klarna Payment Method dla Shopware",
							"step_instructions": [
								[
									{
										"text": "Przejdź do ustawień wtyczki, klikając kolejno"
									},
									{
										"bold": "Konfiguracja → Ustawienia podstawowe → Wyszukaj wtyczki Klarna Payment Method"
									}
								],
								[
									{
										"text": "Wprowadź swoje dane uwierzytelniające API Klarna w polach"
									},
									{
										"bold": "nazwa użytkownika api klarna"
									},
									{
										"text": "a następnie"
									},
									{
										"bold": "Hasło API Klarna"
									},
									{
										"text": "i zapisz zmiany."
									}
								],
								[
									{
										"text": "Upewnij się, że korzystasz z trybu „live”, i użyj swoich danych uwierzytelniających API Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Konfiguracja bramek płatności dla wtyczki Klarna Payment Method",
							"step_instructions": [
								[
									{
										"text": "Przed rozpoczęciem korzystania z Klarna należy aktywować bramki płatności Klarna Payment Method. Można je znaleźć, klikając kolejno"
									},
									{
										"bold": "Konfiguracja → Sposoby płatności"
									}
								],
								[
									{
										"text": "Domyślnie wszystkie bramki płatności Klarna Payment Method są zainstalowane. Otwórz dostępne bramki płatności Klarna Payment Method i aktywuj je poprzez zaznaczenie opcji"
									},
									{
										"bold": "Aktywne"
									},
									{
										"text": "w polu zaznaczenia. Zapisz swoje zmiany"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Konfiguracja kosztów wysyłki",
							"step_instructions": [
								[
									{
										"text": "Skonfiguruj koszty wysyłki dla bramki płatności Klarna Payment Method, klikając kolejno"
									},
									{
										"bold": "Konfiguracja → Koszt wysyłki"
									}
								],
								[
									{
										"text": "Wybierz metody wysyłki, które powinny być dostępne dla Klarna, klikając"
									},
									{
										"bold": "ikonę ołówka."
									}
								],
								[
									{
										"text": "Wybierz zakładkę „Wybór sposobu płatności” i przenieś bramki płatności Klarna Payment Method z pozycji"
									},
									{
										"bold": "Dostępny"
									},
									{
										"text": "Do"
									},
									{
										"bold": "Wybrano."
									},
									{
										"text": "Zapisz ustawienia."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Aktywacja wtyczki Klarna Payment Method",
							"step_instructions": [
								[
									{
										"text": "Następnie należy aktywować wtyczkę płatności Klarna Payment Method. Kliknij kolejno"
									},
									{
										"bold": "Konfiguracja → Menedżer wtyczek → Zainstalowane"
									},
									{
										"text": "celem przejścia do Menedżera wtyczek."
									}
								],
								[
									{
										"text": "Aktywuj wtyczkę, klikając ikonę"
									},
									{
										"bold": "czerwonego symbolu „X”"
									},
									{
										"text": "Ikona"
									}
								],
								[
									{
										"text": "Pojawi się pytanie, czy chcesz wyczyścić pamięć podręczną. Kliknij"
									},
									{
										"bold": "Tak."
									},
									{
										"text": "Pamiętaj, że musisz wyczyścić pamięć podręczną i skompilować motywy za każdym razem, gdy zmienisz coś w ustawieniach modułu lub sposobów płatności Klarna."
									}
								],
								[
									{
										"text": "Aby w pełni aktywować wtyczkę płatności Klarna Payment Method, motyw sklepu musi zostać ponownie skompilowany. Kliknij"
									},
									{
										"bold": "Kompiluj motywy,"
									},
									{
										"text": "gdy system Cię to to poprosi."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Kroki końcowe",
							"step_instructions": [
								[
									{
										"text": "Aby uniknąć błędów zaokrąglania, upewnij się, że masz zainstalowane rozszerzenie PHP bcmath na swoim serwerze. Prosimy o zapoznanie się z przewodnikiem"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "tutaj"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Zrestartuj swój backend, aby upewnić się, że wszystkie konfiguracje są dostępne w sklepie."
									}
								],
								[
									{
										"text": "Upewnij się, że produkty Płatności Klarna wyświetlają się zgodnie z oczekiwaniami, dodając przedmiot do koszyka, wybierając Klarna jako sposób płatności i przechodząc do kasy (nie składaj zamówienia)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						}
					],
					"shopware_kco": [
						{
							"title": "Aktywacja wtyczki Płatności Klarna (Klarna Checkout) dla Shopware",
							"step_instructions": [
								[
									{
										"text": "Po pierwsze, upewnij się, że zainstalowano wtyczkę Klarna Checkout dla Shopware (wersja 5.2.17 lub nowsza). Jeśli nie masz jeszcze tej wtyczki, przejdź na"
									},
									{
										"link": "https://store.shopware.com/en/besti56121054232f/klarna-checkout.html",
										"text": "tę stronę,"
									},
									{
										"text": "aby ją pobrać."
									}
								],
								[
									{
										"text": "W kolejnym kroku należy zaimportować wtyczkę Klarna Checkout do Shopware, klikając kolejno"
									},
									{
										"bold": "Konfiguracja → Menedżer wtyczek → Zainstalowane → Prześlij wtyczkę."
									},
									{
										"text": "Kliknij"
									},
									{
										"bold": "Wybierz"
									},
									{
										"text": "i wybierz plik ZIP wtyczki Klarna Checkout. Potwierdź, klikając"
									},
									{
										"bold": "Prześlij wtyczkę."
									},
									{
										"text": "Wtyczkę znajdziesz teraz w menedżerze wtyczek."
									}
								],
								[
									{
										"text": "Zainstaluj wtyczkę, klikając ikonę"
									},
									{
										"bold": "zielonego symbolu „+”"
									},
									{
										"text": "Ikona"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Konfiguracja wtyczki Klarna Checkout dla Shopware",
							"step_instructions": [
								[
									{
										"text": "Przejdź do ustawień wtyczki, klikając kolejno"
									},
									{
										"bold": "Konfiguracja → Ustawienia podstawowe → Wyszukaj płatności Klarna"
									}
								],
								[
									{
										"text": "Wprowadź swoje dane uwierzytelniające API Klarna w polach"
									},
									{
										"bold": "nazwa użytkownika api klarna"
									},
									{
										"text": "a następnie"
									},
									{
										"bold": "Hasło API Klarna"
									},
									{
										"text": "i zapisz zmiany."
									}
								],
								[
									{
										"text": "Upewnij się, że korzystasz z trybu „live”, i użyj swoich danych uwierzytelniających API Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Aktywacja bramki płatności Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Przed rozpoczęciem korzystania z Klarna należy aktywować bramkę płatności Klarna. Można je znaleźć, klikając kolejno"
									},
									{
										"bold": "Konfiguracja → Sposoby płatności"
									}
								],
								[
									{
										"text": "Otwórz bramkę Płatności Klarna (Klarna Checkout) i aktywuj ją, zaznaczając opcję"
									},
									{
										"bold": "Aktywne"
									},
									{
										"text": "w polu zaznaczenia. Zapisz swoje zmiany"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Konfiguracja kosztów wysyłki",
							"step_instructions": [
								[
									{
										"text": "Skonfiguruj koszty wysyłki dla Klarna Checkout, klikając kolejno"
									},
									{
										"bold": "Konfiguracja → Koszt wysyłki"
									}
								],
								[
									{
										"text": "Wybierz metody wysyłki, które powinny być dostępne dla Klarna, klikając"
									},
									{
										"bold": "ikonę ołówka."
									}
								],
								[
									{
										"text": "Wybierz zakładkę wyboru metody płatności i przenieś pozycję Klarna Checkout z"
									},
									{
										"bold": "Dostępny"
									},
									{
										"text": "Do"
									},
									{
										"bold": "Wybrano."
									},
									{
										"text": "Zapisz ustawienia."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Aktywacja wtyczki Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Następnie należy aktywować wtyczkę Płatności Klarna, klikając kolejno"
									},
									{
										"bold": "Konfiguracja → Menedżer wtyczek → Zainstalowane"
									},
									{
										"text": "celem przejścia do Menedżera wtyczek."
									}
								],
								[
									{
										"text": "Aktywuj wtyczkę, klikając ikonę"
									},
									{
										"bold": "czerwonego symbolu „X”"
									},
									{
										"text": "Ikona"
									}
								],
								[
									{
										"text": "Pojawi się pytanie, czy chcesz wyczyścić pamięć podręczną. Kliknij"
									},
									{
										"bold": "Tak."
									}
								],
								[
									{
										"text": "Aby w pełni aktywować wtyczkę Klarna Checkout, motyw sklepu musi zostać ponownie skompilowany. Kliknij"
									},
									{
										"bold": "Kompiluj motywy,"
									},
									{
										"text": "gdy system Cię to to poprosi."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Kroki końcowe",
							"step_instructions": [
								[
									{
										"text": "Aby uniknąć błędów zaokrąglania, upewnij się, że masz zainstalowane rozszerzenie PHP bcmath na swoim serwerze. Prosimy o zapoznanie się z przewodnikiem"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "tutaj"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Upewnij się, że „Dodatkowa linia adresowa 1” i „Dodatkowa linia adresowa 2” nie są zaznaczone jako obowiązkowe."
									}
								],
								[
									{
										"text": "Zrestartuj swój backend, aby upewnić się, że wszystkie konfiguracje są dostępne w sklepie."
									}
								],
								[
									{
										"text": "Upewnij się, że Płatności Klarna wyświetlają się zgodnie z oczekiwaniami, dodając przedmiot do koszyka, wybierając Klarna jako sposób płatności i przechodząc do kasy (nie składaj zamówienia)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						}
					],
					"shopware_6_kp": [
						{
							"title": "Aktywacja wtyczki Klarna Payment Method dla Shopware",
							"step_instructions": [
								[
									{
										"text": "Aby zainstalować wtyczkę Klarna, musisz mieć uruchomiony system Shopware 6. Wskazówki dotyczące instalacji można znaleźć"
									},
									{
										"link": "https://docs.shopware.com/en/shopware-6-en/first-steps/installing-shopware-6",
										"text": "w tym miejscu."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Instalacja i konfiguracja Jest kilka sposobów na zainstalowanie wtyczki Klarna.",
							"step_instructions": [
								[
									{
										"text": "Kreator pierwszego uruchomienia."
									}
								],
								[
									{
										"text": "Instalacja poprzez Administrację."
									}
								],
								[
									{
										"text": "Instalacja poprzez Community Store Direct Download."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Włączenie wtyczki płatności Klarna Payment Method dla Shopware",
							"step_instructions": [
								[
									{
										"text": "Przejdź do przeglądu Twoich wtyczek w Administracji Shopware. Możesz uzyskać do niej dostęp, klikając kolejno"
									},
									{
										"bold": "Ustawienia > System > Wtyczki."
									}
								],
								[
									{
										"text": "Wybierz"
									},
									{
										"bold": "Zainstaluj"
									},
									{
										"text": "z menu kontekstowego („...”). Otrzymasz wiadomość od Shopware, że wtyczka została pomyślnie zainstalowana."
									}
								],
								[
									{
										"text": "Ze względów bezpieczeństwa wtyczka jest teraz zainstalowana, ale jeszcze nie aktywowana. Musisz najpierw zoptymalizować ją pod kątem danych dostępowych i indywidualnych ustawień."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Kreator",
							"step_instructions": [
								[
									{
										"text": "Po aktywacji wtyczki przejdź do"
									},
									{
										"bold": "menu kontekstowego („...”) > kreator.",
										"text": "Następnie przejdziesz do żądanej procedury."
									}
								],
								[
									{
										"text": "Czynność przeprowadzi Cię przez cały proces konfiguracji i pozwoli Ci zarejestrować się w Klarna, jeśli nie masz jeszcze konta dealera."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Konfiguracja wtyczki",
							"step_instructions": [
								[
									{
										"bold": "Kanały sprzedaży."
									},
									{
										"text": "Tutaj możesz określić, czy poniższe ustawienia mają zostać zastosowane dla „wszystkich kanałów sprzedaży”, czy też mają dotyczyć tylko określonych, pojedynczych kanałów sprzedaży."
									}
								],
								[
									{
										"bold": "Ustawienia API."
									},
									{
										"text": "Nazwa użytkownika API i hasło API: Wprowadź w odpowiednich sekcjach dane dostępu do API dla trybu live i testowego."
									}
								],
								[
									{
										"text": "Możesz sprawdzić swoje dane uwierzytelniające API Klarna, klikając przycisk"
									},
									{
										"bold": "Przetestuj dane uwierzytelniające API,",
										"text": "który znajduje się w nagłówku. Otrzymasz wtedy komunikat o powodzeniu lub wskazanie, które dane wydają się być nieprawidłowe."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Aktywacja/dezaktywacja wtyczki",
							"step_instructions": [
								[
									{
										"text": "Jeśli chcesz aktywować/dezaktywować wtyczkę Klarna Payment Method lub po prostu chcesz zobaczyć aktualny status aktywacji, przejdź do Shopware Admin i wybierz kolejno"
									},
									{
										"bold": "Ustawienia > System > Wtyczki."
									}
								],
								[
									{
										"text": "Aktualny stan można znaleźć w tabeli, w sekcji"
									},
									{
										"bold": "„Moje wtyczki”."
									}
								],
								[
									{
										"text": "Status można zmienić, klikając suwak."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						},
						{
							"title": "Kroki końcowe",
							"step_instructions": [
								[
									{
										"text": "Aby uniknąć błędów zaokrąglania, upewnij się, że masz wersję PHP  >= 7.2."
									}
								],
								[
									{
										"text": "Pełna instalacja Shopware"
									},
									{
										"bold": "(Storefront + Administracja, nie „headless”)."
									}
								],
								[
									{
										"text": "System musi być dostępny z zewnątrz w celu aktualizacji statusu płatności."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z Shopware, zapoznaj się z ich"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozszerzonym przewodnikiem (w języku niemieckim)."
									}
								]
							]
						}
					],
					"3dcart_kp": [
						{
							"title": "Wygeneruj i zapisz dane uwierzytelniające API Klarna",
							"step_instructions": [
								[
									{
										"text": "Wygeneruj nowe dane uwierzytelniające API i pobierz plik na swój komputer. Otwórz plik i pozostaw otwarty, ponieważ będziesz potrzebować tych danych uwierzytelniających API w następnej sekcji."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji 3dcart, postępuj zgodnie z"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "rozszerzonym przewodnikiem po integracji."
									}
								]
							]
						},
						{
							"title": "Aktywuj płatności Klarna Payment Method w Menedżerze sklepu internetowego",
							"step_instructions": [
								[
									{
										"text": "Zaloguj się do"
									},
									{
										"link": "https://www.shift4shop.com/login-page.html",
										"text": "3dcart Online Store Manager,"
									},
									{
										"text": "i wybierz kolejno"
									},
									{
										"bold": "Ustawienia → Płatność."
									}
								],
								[
									{
										"text": "Na stronie płatności kliknij przycisk"
									},
									{
										"bold": "Wybierz sposób płatności"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Wyświetli się lista wstępnie zainstalowanych modułów. Zlokalizuj moduł Klarna i aktywuj go za pomocą przełącznika."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji 3dcart, postępuj zgodnie z"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "rozszerzonym przewodnikiem po integracji."
									}
								]
							]
						},
						{
							"title": "Wprowadzanie danych uwierzytelniających API Klarna",
							"step_instructions": [
								[
									{
										"text": "Po aktywacji modułu wprowadź swoją nazwę użytkownika API Klarna (UID) w odpowiednim polu. Znajdziesz go w pliku z danymi uwierzytelniającymi, który pobrano wcześniej."
									}
								],
								[
									{
										"text": "Następnie należy kliknąć link"
									},
									{
										"bold": "Zmiana hasła"
									},
									{
										"text": "i wprowadzić swoje hasło API Klarna w polu hasła."
									}
								],
								[
									{
										"text": "Poniżej"
									},
									{
										"bold": "Język kraj"
									},
									{
										"text": "wybierz język kraju, który będzie używany dla opcji Płatności Klarna w sklepie."
									}
								],
								[
									{
										"text": "Nad polem nazwy użytkownika znajduje się pole wyboru oznaczone jako"
									},
									{
										"bold": "„Tryb testowy”."
									},
									{
										"text": "Zaznacz opcję, aby włączyć tryb testowy, umożliwiający składanie zamówień bez ponoszenia żadnych opłat i czynności płatniczych podczas testowania modułu."
									}
								],
								[
									{
										"text": "Po zakończeniu konfiguracji ustawień kliknij „Zapisz” w prawym górnym rogu."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji 3dcart, postępuj zgodnie z"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "rozszerzonym przewodnikiem po integracji."
									}
								]
							]
						},
						{
							"title": "Dokonaj zakupu próbnego",
							"step_instructions": [
								[
									{
										"text": "Aby sprawdzić, czy integracja jest poprawnie skonfigurowana, prosimy o dokonanie próbnego zakupu w Waszym sklepie."
									}
								],
								[
									{
										"text": "Po złożeniu zamówienia przejdź do sekcji"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Zamówienia w Portalu dla handlowców,"
									},
									{
										"text": "znajdź swoje zamówienie i anuluj je, aby nie płacić za nie."
									}
								],
								[
									{
										"text": "Gdy integracja przebiegnie pomyślnie, baner na górze strony zmieni kolor na zielony i wyświetli napis „Integracja zakończona”."
									}
								],
								[
									{
										"text": "Jeśli włączono „Tryb testowy” w poprzednim kroku, odznacz go i zapisz jeszcze przed uruchomieniem sklepu, aby prawdziwe zamówienia były poprawnie realizowane."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji 3dcart, postępuj zgodnie z"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "rozszerzonym przewodnikiem po integracji."
									}
								]
							]
						}
					],
					"bigcommerce_kp": [
						{
							"title": "Wygeneruj i zapisz dane uwierzytelniające API Klarna",
							"step_instructions": [
								[
									{
										"text": "Wygeneruj nowe dane uwierzytelniające API i pobierz plik na swój komputer. Otwórz plik i pozostaw otwarty, ponieważ będziesz potrzebować tych danych uwierzytelniających API w następnej sekcji."
									}
								]
							],
							"alternate": [
								{
									"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z BigCommerce, postępuj zgodnie z"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "rozszerzonym przewodnikiem po integracji."
								}
							]
						},
						{
							"title": "Konfiguracja ustawień BigCommerce",
							"step_instructions": [
								[
									{
										"text": "W BigCommerce wybierz kolejno"
									},
									{
										"link": "http://login.bigcommerce.com/deep-links/settings/payment",
										"text": "Konfiguracja sklepu › Płatności"
									},
									{
										"text": "i rozwiń sekcję Sposoby płatności online. Następnie kliknij"
									},
									{
										"bold": "Konfiguruj"
									},
									{
										"text": "obok opcji Klarna Payment Method."
									}
								],
								[
									{
										"text": "Przejdziesz do zakładki Ustawienia modułu Klarna Payment Method. Wejdź do pliku z poświadczeniami API, który zapisano w poprzedniej sekcji, i skopiuj nazwę użytkownika i hasło do odpowiednich pól."
									}
								],
								[
									{
										"text": "Zapisz swoje zmiany, gdy wszystko będzie gotowe."
									}
								]
							],
							"alternate": [
								{
									"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z BigCommerce, postępuj zgodnie z"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "rozszerzonym przewodnikiem po integracji."
								}
							]
						},
						{
							"title": "Dokonaj zakupu próbnego",
							"step_instructions": [
								[
									{
										"text": "Aby sprawdzić, czy integracja jest poprawnie skonfigurowana, prosimy o dokonanie próbnego zakupu w Waszym sklepie."
									}
								],
								[
									{
										"text": "Po złożeniu zamówienia przejdź do sekcji"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Zamówienia w Portalu dla handlowców,"
									},
									{
										"text": "znajdź swoje zamówienie i anuluj je, aby nie płacić za nie."
									}
								],
								[
									{
										"text": "Gdy integracja przebiegnie pomyślnie, baner na górze strony zmieni kolor na zielony i wyświetli napis „Integracja zakończona”."
									}
								]
							],
							"alternate": [
								{
									"text": "Aby uzyskać więcej szczegółowych informacji na temat integracji z BigCommerce, postępuj zgodnie z"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "rozszerzonym przewodnikiem po integracji."
								}
							]
						}
					],
					"prestashop_kco": [
						{
							"title": "Aktywacja modułu Płatności Klarna (Klarna Checkout)",
							"step_instructions": [
								[
									{
										"text": "Po pierwsze, upewnij się, że masz zainstalowany oficjalny moduł Klarna dla Prestashop. Jeśli jeszcze go nie masz, przejdź na"
									},
									{
										"link": "https://addons.prestashop.com/en/express-checkout-process/90132-klarna-checkout.html?no_cache=1",
										"text": "tę stronę"
									},
									{
										"text": "aby go pobrać."
									}
								],
								[
									{
										"text": "Niestety, od 1 stycznia 2023 roku te wtyczki opracowane przez firmę Prestasworks A.B (SI) i będące jej własnością nie będą już dystrybuowane za darmo. Jeśli chcesz korzystać z Klarna, możesz kupić wtyczkę lub poczekać na wtyczki stworzone przez Klarna, których spodziewamy się w 2. kwartale 2023 r."
									}
								],
								[
									{
										"text": "Zaloguj się na stronie administratora Prestashop i wybierz kolejno"
									},
									{
										"bold": "Moduły → Moduły."
									}
								],
								[
									{
										"text": "Poszukaj „Klarna” w pasku wyszukiwania, aby znaleźć moduł Klarna firmy Prestaworks AB. Kliknij"
									},
									{
										"bold": "Konfiguruj."
									}
								]
							]
						},
						{
							"title": "Skonfiguruj ustawienia swojego modułu Klarna",
							"step_instructions": [
								[
									{
										"text": "Jesteś teraz na stronie ustawień modułu. W górnej części „Ustawień ogólnych” znajduje się przycisk o nazwie"
									},
									{
										"bold": "Aktywuj KCO w tym sklepie"
									},
									{
										"text": "(Klarna Checkout V3). Wybierz"
									},
									{
										"bold": "Tak."
									}
								],
								[
									{
										"text": "Kliknij"
									},
									{
										"bold": "Zapisz"
									},
									{
										"text": "i zapisz ustawienia."
									}
								],
								[
									{
										"text": "Teraz kliknij swój kraj sprzedaży w menu po lewej stronie i wprowadź swoje dane uwierzytelniające API Klarna w sekcjach"
									},
									{
										"bold": "nazwa użytkownika api klarna"
									},
									{
										"text": "a następnie"
									},
									{
										"bold": "Hasło API Klarna."
									}
								],
								[
									{
										"text": "Kliknij"
									},
									{
										"bold": "Zapisz"
									}
								]
							]
						},
						{
							"title": "Kroki końcowe",
							"step_instructions": [
								[
									{
										"text": "Upewnij się, że tryb testowy jest wyłączony, o ile wszystko już gotowe i sklep może zostać uruchomiony. Można to zrobić w zakładce"
									},
									{
										"bold": "Ustawienia wspólne."
									},
									{
										"text": "Przycisk"
									},
									{
										"bold": "Testdrive"
									},
									{
										"text": "powinien być ustawiony na"
									},
									{
										"bold": "Nie."
									}
								],
								[
									{
										"text": "Natomiast w sekcji"
									},
									{
										"bold": "Ustawienia wspólne"
									},
									{
										"text": "upewnij się, że skonfigurowano ustawienia dotyczące sposobu obsługi zamówień, ustawień wysyłania faktur itp."
									}
								],
								[
									{
										"text": "Upewnij się, że Płatności Klarna wyświetlają się zgodnie z oczekiwaniami – dodaj przedmiot do koszyka i przejdź do kasy (nie składaj zamówienia)."
									}
								]
							]
						}
					],
					"prestashop_kp": [
						{
							"title": "Wygeneruj i zapisz dane uwierzytelniające API Klarna",
							"step_instructions": [
								[
									{
										"text": "Wygeneruj nowe dane uwierzytelniające API i pobierz plik na swój komputer. Otwórz plik i pozostaw otwarty, ponieważ będziesz potrzebować tych danych uwierzytelniających API w następnej sekcji."
									}
								]
							]
						},
						{
							"title": "Instalacja i aktywacji modułu Klarna Payment Method",
							"step_instructions": [
								[
									{
										"text": "Otwórz"
									},
									{
										"link": "https://addons.prestashop.com/en/payment-card-wallet/90140-klarna-payments.html?no_cache=1",
										"text": "Strona instrukcji modułu Klarna Payment Method dla Prestashop"
									},
									{
										"text": "i postępuj zgodnie z instrukcjami, aby zainstalować i skonfigurować moduł na swoim koncie Prestashop."
									}
								]
							]
						},
						{
							"title": "Dokonaj zakupu próbnego",
							"step_instructions": [
								[
									{
										"text": "Aby sprawdzić, czy integracja jest poprawnie skonfigurowana, prosimy o dokonanie próbnego zakupu w Waszym sklepie."
									}
								],
								[
									{
										"text": "Po złożeniu zamówienia przejdź do sekcji"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Zamówienia w Portalu dla handlowców,"
									},
									{
										"text": "znajdź swoje zamówienie i anuluj je, aby nie płacić za nie."
									}
								],
								[
									{
										"text": "Gdy integracja przebiegnie pomyślnie, baner na górze strony zmieni kolor na zielony i wyświetli napis „Integracja zakończona”."
									}
								]
							]
						}
					],
					"jumpseller": [
						{
							"title": "Wygeneruj swoje dane uwierzytelniające API Klarna.",
							"step_instructions": [
								[
									{
										"text": "Będziesz potrzebować tych poświadczeń, aby zintegrować Klarna w swoim sklepie."
									}
								]
							]
						},
						{
							"title": "Dodaj Klarna jako nową metodę płatności.",
							"step_instructions": [
								[
									{
										"text": "W panelu administracyjnym Jumpseller przejdź do sekcji Ustawienia > Płatności, znajdź „Klarna” na liście pól wyboru i kliknij „Dodaj metodę”."
									}
								]
							]
						},
						{
							"title": "Skonfiguruj naszą nową metodę płatności.",
							"step_instructions": [
								[
									{
										"text": "W panelu konfiguracji Klarna (w Panelu administracyjnym Jumpseller przejdź do Ustawienia > Płatności > Klarna), (i) dodaj poświadczenia API Klarna wygenerowane w pierwszym kroku, (ii) wybierz pakiety EDM, które chcesz / musisz udostępnić Klarna i (iii) wybierz, czy chcesz automatycznie przyjmować zamówienia (domyślnie nie)."
									}
								]
							]
						}
					],
					"lightspeed": [
						{
							"title": "Integracja z Lightspeed eCom",
							"step_instructions": [
								[
									{
										"text": "Zobacz przewodnik integracji w"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/eng.pdf",
										"text": "Angielski"
									},
									{
										"text": "i w"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/nl.pdf",
										"text": "Niderlandzki"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"shoper": [
						{
							"title": "Zintegruj Shoper",
							"step_instructions": [
								[
									{
										"text": "Zobacz przewodnik integracji w"
									},
									{
										"link": "https://www.shoper.pl/help/artykul/klarna-platnosci-odroczone-konfiguracja",
										"text": "witrynie Shopper"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"timma": [
						{
							"title": "Zintegruj Timma",
							"step_instructions": [
								[
									{
										"text": "Zobacz przewodnik integracji w"
									},
									{
										"link": "https://help.timma.fi/sv/articles/4990994-betalning-via-klarna",
										"text": "witrynie Timma"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"smartetailing": [
						{
							"title": "Wygeneruj i zapisz dane uwierzytelniające API Klarna",
							"step_instructions": [
								[
									{
										"text": "Wygeneruj nowe dane uwierzytelniające API i pobierz plik na swój komputer. Otwórz plik i pozostaw otwarty, ponieważ będziesz potrzebować tych danych uwierzytelniających API w następnej sekcji."
									}
								]
							]
						},
						{
							"title": "Zintegruj z SmartEtailing",
							"step_instructions": [
								[
									{
										"text": "Wykonaj instrukcje na"
									},
									{
										"link": "https://www.smartetailing.com/help/financing-with-klarna",
										"text": "stronie SmartEtailing."
									}
								]
							]
						}
					],
					"workstand": [
						{
							"title": "Wygeneruj i zapisz dane uwierzytelniające API Klarna",
							"step_instructions": [
								[
									{
										"text": "Wygeneruj nowe dane uwierzytelniające API i pobierz plik na swój komputer. Otwórz plik i pozostaw otwarty, ponieważ będziesz potrzebować tych danych uwierzytelniających API w następnej sekcji."
									}
								]
							]
						},
						{
							"title": "Zintegruj z Workstand",
							"step_instructions": [
								[
									{
										"text": "Wykonaj instrukcje na"
									},
									{
										"link": "https://www.workstand.com/help/financing-with-klarna",
										"text": "stronie Workstand."
									}
								]
							]
						}
					],
					"jtl5_kco": [
						{
							"title": "Przeczytaj dokumentację naszej wtyczki",
							"step_instructions": [
								[
									{
										"text": "Przejdź do"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "strony z naszą dokumentacją"
									}
								]
							]
						},
						{
							"title": "Aktywuj moduł Klarna Checkout dla JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Upewnij się, że masz zainstalowany oficjalne rozszerzenie Klarna. Jeśli jeszcze go nie masz,"
									},
									{
										"text": "przejdź do"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "tę stronę,"
									},
									{
										"text": "aby go pobrać."
									}
								]
							]
						}
					],
					"jtl5_kp": [
						{
							"title": "Przeczytaj dokumentację naszej wtyczki",
							"step_instructions": [
								[
									{
										"text": "Przejdź do"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "strony z naszą dokumentacją"
									}
								]
							]
						},
						{
							"title": "Aktywuj moduł Klarna Payments dla JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Upewnij się, że masz zainstalowany oficjalne rozszerzenie Klarna. Jeśli jeszcze go nie masz,"
									},
									{
										"text": "przejdź do"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "tę stronę,"
									},
									{
										"text": "aby go pobrać."
									}
								]
							]
						}
					],
					"no_instructions": [
						{
							"title": "Oto, co należy zrobić:",
							"step_instructions": [
								[
									{
										"bold": "Wygeneruj swoje dane uwierzytelniające API Klarna."
									},
									{
										"text": "Potrzebujesz tych poświadczeń, aby zintegrować Klarna w swoim sklepie."
									}
								],
								[
									{
										"bold": "Dodaj dane uwierzytelniające API Klarna w swoim systemie back-end, aby włączyć Klarna."
									},
									{
										"text": "Sprawdź naszą stronę"
									},
									{
										"link": "https://developers.klarna.com/",
										"text": "Portal programisty"
									},
									{
										"text": "– tam otrzymasz dodatkową pomoc."
									}
								]
							]
						}
					]
				},
				"stakeholders": {
					"form": {
						"first_name": {
							"label": "Imię",
							"error": "Wpisz imię"
						},
						"last_name": {
							"label": "Nazwisko",
							"error": "Wpisz nazwisko"
						},
						"dateOfBirth": {
							"label": {
								"default": "Data urodzenia (DD/MM/RRRR)",
								"without_format": "Data urodzenia",
								"US": "Data urodzenia (DD/MM/RRRR)"
							},
							"error": "Wprowadź poprawną datę",
							"error_too_young": "Aby sprzedawać we współpracy z Klarna, musisz mieć ukończone 18 lat."
						},
						"address": {
							"label": "Adres zamieszkania",
							"error": "Podaj adres"
						},
						"city": {
							"label": "Miasto",
							"error": "Podaj miasto"
						},
						"country": {
							"label": "Kraj",
							"error": "Podaj kraj"
						},
						"postal_code": {
							"label": {
								"default": "Kod pocztowy",
								"US": "Kod pocztowy"
							},
							"error": {
								"default": "Podaj prawidłowy kod pocztowy",
								"US": "Podaj prawidłowy kod pocztowy"
							}
						},
						"region": {
							"label": "Państwo/region (nieobowiązkowo)",
							"label_summary": "Państwo/region"
						},
						"state": {
							"label": "Stan",
							"error": "Podaj stan"
						},
						"role_question": {
							"OWNER": "Czy ta osoba jest właścicielem/właścicielką?",
							"BENEFICIAL_OWNER": "Czy osoba ta kontroluje więcej niż 25% akcji lub praw głosu?",
							"ULTIMATE_BENEFICIAL_OWNER": "Osoba ta posiada lub kontroluje więcej niż 25% akcji lub praw głosu"
						},
						"is_person_pep": [
							{
								"text": "Czy ta osoba jest"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "osobą zajmującą eksponowane stanowisko polityczne (PEP)"
							},
							{
								"text": ","
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "należy do najbliższej rodziny"
							},
							{
								"text": "lub"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "jest znanym współpracownikiem/współpracowniczką"
							},
							{
								"text": "takiej osoby?"
							}
						],
						"pep_relationship": {
							"label": "Relacja",
							"error": "Wybierz, jaki stosunek łączy tę osobę z PEP"
						},
						"pep_position": {
							"label": "PEP – stanowisko",
							"error": "Podaj stanowisko, które zajmuje PEP"
						},
						"personal_id_question": "Ta osoba nie posiada osobistego numeru identyfikacyjnego",
						"personal_id": {
							"US": {
								"label": "Numer ubezpieczenia społecznego (ostatnie 4 cyfry)",
								"label_summary": "Numer ubezpieczenia społecznego"
							},
							"US_FULL_SSN": {
								"label": "Numer ubezpieczenia społecznego",
								"label_summary": "Numer ubezpieczenia społecznego"
							},
							"CA": {
								"label": "Numer ubezpieczenia społecznego (SIN) lub numer paszportu",
								"label_summary": "Numer ubezpieczenia społecznego (SIN) lub numer paszportu"
							},
							"SE": {
								"label": "Osobisty Numer Identyfikacyjny (PNO)",
								"label_summary": "Osobisty Numer Identyfikacyjny (PNO)"
							},
							"FI": {
								"label": "Osobisty Kod Identyfikacyjny (HETU)",
								"label_summary": "Osobisty Numer Identyfikacyjny (HETU)"
							},
							"NO": {
								"label": "Krajowy Numer Identyfikacyjny",
								"label_summary": "Krajowy Numer Identyfikacyjny"
							},
							"DK": {
								"label": "Osobisty Numer Identyfikacyjny",
								"label_summary": "Osobisty Numer Identyfikacyjny (CPR)"
							},
							"IT": {
								"label": "Kod fiskalny",
								"label_summary": "Kod fiskalny"
							},
							"ES": {
								"label": "Osobisty Numer Identyfikacyjny",
								"label_summary": "Osobisty Numer Identyfikacyjny (DNI)"
							},
							"PL": {
								"label": "Osobisty Numer Identyfikacyjny (PESEL)",
								"label_summary": "Osobisty Numer Identyfikacyjny (PESEL)"
							},
							"default": {
								"label": "Numer paszportu",
								"label_summary": "Numer paszportu"
							},
							"value": "Poufne"
						},
						"registration_number": {
							"label": "Numer identyfikacyjny przedsiębiorstwa",
							"error": "Wpisz numer EIN w formacie: XX-XXXXXXXXX"
						},
						"company_name": {
							"label": "Nazwa sklepu",
							"error": "Podaj prawidłową nazwę firmy"
						},
						"legal_company_name": {
							"label": "Nazwa prawna przedsiębiorstwa",
							"error_label": "Podaj nazwę prawną firmy"
						},
						"add_person": "Dodaj osobę",
						"remove": "Usuń",
						"edit": "Edytuj"
					}
				},
				"steps_headers": {
					"merchant": {
						"merchant_id": "ID sprzedawcy: {merchantId}"
					}
				},
				"goodie_bags": {
					"marketing_material": {
						"title": "Materiały marketingowe",
						"text": "Teraz jesteś częścią rodziny Klarna. Oto pakiet materiałów, aby rozpocząć.",
						"link": "Pobierz"
					},
					"invite_more_users": {
						"title": "Zaproś więcej użytkowników",
						"text": "Zaproś swoich współpracowników do Portalu dla handlowców. Pozwoli Ci to ustawić własne uprawnienia dla każdego z nich!",
						"link": "Zaproś użytkowników"
					}
				},
				"terms_and_conditions_confirmation": {
					"title": "Produkty i ceny",
					"subtitle": "{country}",
					"pricing": "{country} – cennik",
					"monthly_fee": "Opłata miesięczna",
					"transaction_fee": "Prowizja od transakcji",
					"before_link": "Zgadzam się na przedstawione przez Klarna",
					"link_text": "Warunki i regulamin",
					"after_link_one_product": "dla tego produktu",
					"after_link_more_than_one_product": "dla tych produktów",
					"product_not_available_in_your_country": "* Ten produkt nie jest dostępny na Twoim rynku, ale będzie działać w innych krajach."
				},
				"product_description": {
					"product_attributes": {
						"installed": {
							"text": "Zainstalowany"
						},
						"in_progress": {
							"text": "W toku"
						}
					}
				},
				"phone_collection_block": {
					"title": "Masz problemy z integracją z Klarna?",
					"description": "Podaj swój numer poniżej, a jeden z naszych agentów zadzwoni do Ciebie, aby pomóc Ci w dodaniu Klarna do Twojego rozwiązania e-commerce.",
					"success_banner": "Wielkie dzięki! Nasz zespół skontaktuje się z Tobą jak najszybciej.",
					"submit": "Wyślij",
					"fields": {
						"phone": {
							"label": "Numer telefonu",
							"tooltip": "Musisz podać numer kierunkowy kraju, np. +48 54 754 3010.",
							"errors": {
								"required": "Wymagany jest numer telefonu",
								"invalid": "Niepoprawny numer telefonu"
							}
						}
					}
				}
			},
			"containers": {
				"applicant": {
					"title": {
						"unmanaged": "Kto podpisuje umowy w Twojej firmie?",
						"managed": "Kto podpisuje umowy w Twojej firmie?",
						"recollection": "Kto jest upoważniony do składania podpisów w imieniu Twojej firmy?"
					},
					"subtitle": {
						"unmanaged": "Twoja firma ma zamiar zawrzeć umowę z Klarna. Musimy wiedzieć, kto jest prawnie upoważniony do podpisywania umów.",
						"managed": "Prosimy o podanie informacji o wszystkich upoważnionych sygnatariuszach firmy, którzy zawierają umowę. Jesteśmy prawnie zobowiązani do zatwierdzania uprawnień tych przedstawicieli do podpisywania dokumentów. Jeśli nikt z listy nie podpisał umowy, kliknij „Dodaj osobę” i podaj wymagane informacje.",
						"recollection": "Ponieważ Twoja firma ma aktywną umowę z Klarna, jesteśmy prawnie zobowiązani do zbierania i weryfikowania informacji o wszystkich Twoich przedstawicielach prawnych."
					},
					"form_title": "Podaj informacje",
					"robot_message": {
						"unmanaged": "Są to zazwyczaj dyrektorzy zarządu lub kadra kierownicza, taka jak CEO, CFO lub COO. Wpisanie dwóch lub więcej osób może przyspieszyć zatwierdzenie umowy.",
						"managed": "Są to zazwyczaj dyrektorzy zarządu lub kadra kierownicza, taka jak CEO, CFO lub COO. Wpisanie dwóch lub więcej osób może przyspieszyć zatwierdzenie umowy."
					},
					"error_tooltip": {
						"too_young": "Ta osoba nie może złożyć wniosku, ponieważ ma poniżej {minAge} lat."
					},
					"alert_all_too_young": "Wszystkie osoby przystępujące do umowy muszą mieć ukończone {minAge} lat. Aby kontynuować, dodaj i wybierz wnioskodawcę, który ma więcej niż {minAge} lat.",
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz",
						"add_person": "+ Dodaj osobę"
					},
					"role": {
						"recollection": "Przedstawiciel prawny"
					}
				},
				"application_summary": {
					"title": "Przejrzyj i złóż swój wniosek.",
					"subtitle": {
						"unmanaged": "Przed wysłaniem sprawdź swoje dane.",
						"managed": "Przed wysłaniem sprawdź swoje dane."
					},
					"stakeholders": {
						"title": "Zarząd firmy",
						"subtitle": "Interesariusz {index}"
					},
					"businessDetailsCard": {
						"title": "Szczegóły dotyczące firmy"
					},
					"businessDetailsCardFields": {
						"companyName": "Nazwa firmy",
						"organizationEntityType": "Klasyfikacja podatkowa",
						"organizationRegistrationAuthority": "Sąd rejestrowy",
						"goodsCategory": "Kategoria towarów",
						"registrationId": {
							"default": "Numer rejestracyjny",
							"AT": "Numer rejestracyjny",
							"AU": "ACN",
							"CA": "Numer firmowy",
							"ES": "NIF / NIE / DNI firmy",
							"GB": "Numer organizacji",
							"GR": "Numer G.E.MI. (Γ.Ε.ΜΗ.)",
							"NZ": "Numer firmowy",
							"US": "Numer identyfikacyjny pracodawcy"
						},
						"registered": {
							"default": "Zarejestrowana firma",
							"AU": "Firma posiada numer ACN"
						},
						"subjectToVat": {
							"default": "Firma podlega VAT",
							"AU": "Firma podlega ABN"
						},
						"vatId": {
							"default": "Numer VAT",
							"AU": "ABN",
							"NZ": "Numer GST",
							"ES": "NIF / NIE / DNI firmy"
						},
						"storeName": "Nazwa sklepu",
						"storeName_us": "Nazwa marki / DBA",
						"website": "Witryna internetowa",
						"email": "E-mail do obsługi klienta",
						"entityType": "Typ podmiotu"
					},
					"companyRegistrationAddressCard": {
						"title": "Adres rejestracyjny firmy"
					},
					"companyAddressCard": {
						"title": "Adres firmy"
					},
					"operatingAddressCard": {
						"title": "Adres spółki operacyjnej"
					},
					"documentsCard": {
						"title": "Przesłane dokumenty"
					},
					"buttons": {
						"edit": "Edytuj",
						"back": "Wstecz",
						"submit": "Prześlij"
					},
					"noTermsAccepted": "Prosimy przeczytać i zaakceptować Regulamin",
					"noTermsAcceptedWithPricingAnnex": "Prosimy przeczytać i zaakceptować Umowę handlową i Warunki cenowe"
				},
				"artificial_ultimate_beneficial_owner": {
					"title": {
						"default": "Kto zarządza firmą?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Jesteśmy prawnie zobowiązani przez dyrektywę UE w sprawie przeciwdziałania praniu brudnych pieniędzy ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "), aby zbierać takie informacje."
							}
						],
						"US": [
							{
								"text": "Jako instytucja finansowa jesteśmy prawnie zobowiązani do gromadzenia tych informacji."
							}
						],
						"CA": [
							{
								"text": "Jako instytucja finansowa jesteśmy prawnie zobowiązani do gromadzenia tych informacji."
							}
						],
						"AU": [
							{
								"text": "Jako instytucja finansowa jesteśmy prawnie zobowiązani do gromadzenia tych informacji."
							}
						]
					},
					"infobox": {
						"default": "Podaj dane osobowe i adres zamieszkania prezesa firmy.",
						"US": "Podaj dane osobowe i adres zamieszkania właściciela większościowego lub menedżera wysokiego szczebla, takiego jak dyrektor generalny, dyrektor finansowy lub dyrektor operacyjny.",
						"CA": "Podaj dane osobowe i adres zamieszkania właściciela większościowego lub menedżera wysokiego szczebla, takiego jak dyrektor generalny, dyrektor finansowy lub dyrektor operacyjny."
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"managed_artificial_ultimate_beneficial_owner": {
					"title": "Czy przedsiębiorstwo to jest spółką publiczną lub jest wyłączną własnością spółki publicznej?",
					"title_stakeholder": "Kto zarządza firmą?",
					"subtitle": "Jako instytucja finansowa jesteśmy prawnie zobowiązani do gromadzenia tych informacji.",
					"subtitle_stakeholder": "Podaj dane osobowe i adres zamieszkania prezesa firmy.",
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"bank_account": {
					"title": {
						"default": "Podaj dane konta bankowego Twojej firmy."
					},
					"subtitle": {
						"US": "Transakcje Klarna będą przekazywane na ten rachunek bankowy.",
						"default": "Będziemy korzystać z nich podczas przekazywania płatności za dokonane zamówienia w Twoim sklepie."
					},
					"no_more_bank_accounts": "Masz już dodane konta bankowe dla wszystkich obsługiwanych walut. Dobra robota!",
					"robot_message_general": "Domyślny rachunek bankowy musi być prowadzony w kraju, w którym zarejestrowana jest Twoja firma. Musisz także dodać konto bankowe dla każdej waluty, którą.",
					"robot_message": "IBAN to skrót od International Bank Account Number (Międzynarodowy Numer Rachunku Bankowego) i jest przypisany przez bank do Twojego numer konta.",
					"robot_message_account_number": {
						"AU": "Numer konta jest podawany przez Twój bank i składa się z 6 do 10 cyfr. Przykład: 12345678",
						"US": "Numer konta jest podawany przez Twój bank i składa się z 5 do 17 cyfr. Przykład: 12345678",
						"GB": "Numer konta jest nadawany przez Twój bank i składa się z 8 cyfr. Na przykład: 12345678. Niektóre banki w Wielkiej Brytanii oferują krótsze numery kont (tzn. 7-cyfrowe). W takim przypadku zera zostaną dodane na początku Twojego numeru, aby zwiększyć jego długość do 8."
					},
					"robot_message_revolut": "Podany przez Ciebie IBAN nie obsługuje krajowych płatności w GBP. Trzeba będzie skontaktować się ze swoim bankiem i poprosić o dane konta, które obsługuje krajowe przelewy w GBP.",
					"robot_message_local": "Podany przez Ciebie IBAN to lokalny IBAN Twojego banku, który nie jest przez nas obsługiwany. Trzeba będzie skontaktować się ze swoim bankiem i poprosić o osobisty numer IBAN lub użyć innego konta do połączenia z Klarna.",
					"buttons": {
						"add_bank_account": "Dodaj konto bankowe",
						"skip": "Na razie pomiń",
						"remove": "Usuń",
						"submit": "Prześlij",
						"next": "Dalej",
						"back": "Wstecz"
					},
					"fields": {
						"currency_code": {
							"label": "Waluta",
							"disable_reason": {
								"account_in_merchant_currency_required": "Domyślną walutą jest {currency} ze względu na kraj, w którym Twoja firma jest zarejestrowana."
							},
							"errors": {
								"general": "Wybierz walutę"
							}
						},
						"country_of_bankaccount": {
							"label": "Kraj",
							"errors": {
								"general": "Podaj kraj"
							}
						},
						"iban_account_number": {
							"label": "Numer rachunku (IBAN)",
							"errors": {
								"general": "Podaj numer rachunku bankowego (IBAN)"
							}
						},
						"use_as_default_bank_account": {
							"label": "Użyj tego konta dla nieokreślonych walut",
							"tooltip": "Zamówienia z walutami niewymienionymi na tej stronie będą wypłacane na to konto. Twój bank może pobierać dodatkowe opłaty za niektóre waluty."
						},
						"local_account_number": {
							"label": {
								"default": "Numer konta",
								"MX": "Numer CLABE"
							},
							"errors": {
								"general": {
									"default": "Podaj numer konta bankowego",
									"MX": "Podaj prawidłowy numer CLABE"
								}
							}
						},
						"account_holder": {
							"label": "Nazwisko posiadacza rachunku",
							"errors": {
								"general": "Podaj imię i nazwisko posiadacza rachunku (maks. 70 znaków)."
							}
						},
						"transit_number": {
							"label": "Numer tranzytowy",
							"errors": {
								"general": "Podaj prawidłowy numer tranzytowy"
							}
						},
						"institution_number": {
							"label": "Numer instytucji",
							"errors": {
								"general": "Wprowadź prawidłowy numer instytucji"
							}
						},
						"bic": {
							"label": {
								"AU": "BSB"
							},
							"errors": {
								"general": {
									"AU": "Podaj prawidłowy kod BSB (bank state branch)"
								}
							},
							"tooltip": {
								"AU": "Kod BSB powinien składać się z 6 cyfr oddzielonych znakiem -. Przykład: 123-456"
							}
						},
						"routing_number": {
							"label": {
								"default": "Numer rozliczeniowy",
								"GB": "Kod banku (sort code)"
							},
							"errors": {
								"general": {
									"default": "Podaj prawidłowy numer rozliczeniowy",
									"GB": "Podaj poprawny kod banku (sort code)"
								}
							}
						}
					}
				},
				"control_over_management": {
					"title": {
						"default": "Kto zarządza firmą?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Jesteśmy prawnie zobowiązani przez dyrektywę UE w sprawie przeciwdziałania praniu brudnych pieniędzy ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "), aby zbierać takie informacje."
							}
						],
						"GB": [
							{
								"text": "Jesteśmy prawnie zobowiązani do gromadzenia tych informacji. Upewnij się, że Twój wpis w Companies House jest aktualny."
							}
						]
					},
					"infobox": "Prosimy o podanie danych osobowych i adresu zamieszkania osób, które sprawują kontrolę nad zarządzaniem Twoją firmą, takich jak np. dyrektor zarządzający lub członkowie zarządu.",
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz",
						"add_person": "+ Dodaj osobę"
					},
					"messages": {
						"lookup": "Czy te osoby zarządzają Twoją firmą? Sprawdź i potwierdź, czy wszystko jest poprawnie."
					}
				},
				"de_registration_information": {
					"title": {
						"unmanaged": "Czy Twoja firma jest zarejestrowaną działalnością?",
						"managed": "Czy ta firma jest zarejestrowaną działalnością?"
					},
					"subtitle": {
						"unmanaged": "Potrzebujemy Twój numer NIP, aby zweryfikować Twoją działalność.",
						"managed": "Potrzebujemy numeru rejestracyjnego firmy, aby zweryfikować podane dane biznesowe."
					},
					"question": {
						"title": {
							"unmanaged": "Podaj swój numer rejestracyjny i sąd rejestrowy",
							"managed": "Podaj numer rejestracyjny i sąd rejestrowy"
						}
					},
					"fields": {
						"registration_number": {
							"label": "Numer rejestracyjny"
						},
						"registration_court": {
							"label": "Sąd rejestrowy",
							"errors": {
								"general": {
									"unmanaged": "Wybierz swój sąd rejestrowy",
									"managed": "Wybierz sąd rejestrowy"
								}
							}
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"documents": {
					"title": "Prześlij dokumenty",
					"subtitle": "Potrzebujemy od Ciebie kilku dodatkowych dokumentów, które są niezbędne do potwierdzenia Twojej tożsamości. Prześlij pliki w formacie <strong>JPG</strong>, <strong>PNG</strong> lub <strong>PDF</strong> (maks. rozmiar pliku to 10 MB).",
					"subheadline": {
						"default": "Ponieważ Klarna jest bankiem z siedzibą w Szwecji, a zatem regulowanym pod kontrolą szwedzkiego Urzędu Nadzoru Finansowego, Klarna musi przestrzegać dyrektywy UE 2015/849. Klarna musi zebrać informacje o osobach, które kontrolują firmę, abyś mógł zacząć korzystać z usług Klarna. Prosimy o przesyłanie wyłącznie plików <strong>JPG, PNG lub PDF</strong> (max. rozmiar plików 10MB)",
						"US": "Klarna jest bankiem z siedzibą w Szwecji i podlega kontroli Szwedzkiego Urzędu Nadzoru Finansowego, w związku z czym musi przestrzegać dyrektywy UE 2015/849. Aby umożliwić rozpoczęcie korzystania z naszych usług, Klarna musi zebrać informacje o osobach kierujących firmą. Prosimy o dostarczenie następujących dokumentów, abyśmy mogli potwierdzić Państwa tożsamość. Pliki należy przesłać w formacie JPG, PNG lub PDF (maks. rozmiar pliku to 10 MB).",
						"IT": "Klarna jest bankiem z siedzibą w Szwecji i podlega kontroli Szwedzkiego Urzędu Nadzoru Finansowego, w związku z czym musi przestrzegać dyrektywy UE 2015/849. Aby umożliwić Państwu rozpoczęcie korzystania z naszych usług, Klarna musi zebrać informacje o osobach kierujących firmą. Uprzejmie informujemy, że aby przystąpić do składania wniosku, Państwa firma musi być zarejestrowana w Izbie Handlowej (Chamber of Commerce). Prosimy o przesłanie plików tylko w formacie JPG, PNG lub PDF (maks. rozmiar pliku to 10MB)"
					},
					"header_title": "Dokumenty",
					"stakeholder": "Interesariusz",
					"business_documents": "Dokumenty spółki",
					"browse_files": "Przeglądaj pliki",
					"optional": "(opcjonalne)",
					"upload_area": {
						"title": {
							"before_link": "Przeciągnij pliki tutaj lub",
							"link_text": "Wybierz pliki"
						},
						"description": "{acceptedFileFormats} - maksymalny rozmiar pliku to {maxFileSizeMB} MB"
					},
					"description": {
						"APPROVAL": "Prześlij <strong>zgodę</strong>",
						"CONTRACT": "Prześlij <strong>umowę</strong>",
						"CORRECTION_NOTE": "Prześlij <strong>notę korygującą</strong>",
						"COUNTERSIGNED_CONTRACT": "Prześlij <strong>podpisaną umowę</strong>",
						"ID_DOCUMENT": "Prześlij <strong>dowód osobisty</strong> lub <strong>paszport</strong>",
						"LICENSE": "Prześlij <strong>licencję</strong>",
						"PROOF_OF_ADDRESS": "Prześlij <strong>potwierdzenie adresu</strong>",
						"SPECIAL_AGREEMENT": "Prześlij <strong>umowę specjalną</strong>",
						"SUPPORTING_DOCUMENT": "Prześlij <strong>dokument pomocniczy</strong>",
						"TAX_OFFICE_REGISTRATION": "Prześlij <strong>potwierdzenie rejestracji w urzędzie skarbowym</strong>"
					},
					"explanation": {
						"APPROVAL": {
							"title": {
								"default": "Zgoda"
							},
							"subtitle": {
								"default": null
							}
						},
						"CONTRACT": {
							"title": {
								"default": "Umowa"
							},
							"subtitle": {
								"default": null
							}
						},
						"CORRECTION_NOTE": {
							"title": {
								"default": "Nota korygująca"
							},
							"subtitle": {
								"default": null
							}
						},
						"COUNTERSIGNED_CONTRACT": {
							"title": {
								"default": "Podpisana umowa"
							},
							"subtitle": {
								"default": null
							}
						},
						"ID_DOCUMENT": {
							"title": {
								"default": "Dowód tożsamości",
								"IT": "Dokument tożsamości"
							},
							"subtitle": {
								"default": "Jeżeli to konieczne prosimy o dostarczenie obu stron dowodu tożsamości.",
								"AT": "Prosimy o dostarczenie nam obu stron dowodu osobistego. Jeśli adres nie znajduje się na dowodzie osobistym, będziemy potrzebować dodatkowej dokumentacji, takiej jak rachunek za media, aby zweryfikować adres.",
								"AU": "W celu szybszej oceny wniosku prosimy o dostarczenie kopii ważnego dokumentu tożsamości ze zdjęciem, takiego jak paszport lub australijskie prawo jazdy, dla następujących osób związanych z firmą: Jednoosobowa działalność gospodarcza / spółka cywilna – właściciel(e). Spółka – przedstawiciel prawny, wszyscy dyrektorzy oraz każdy udziałowiec posiadający więcej niż 25% udziałów.",
								"BE": "Prosimy dostarczyć obie strony dowodu osobistego, upewnić się, że jakość obrazu jest wystarczająca i że wszystkie informacje są czytelne.",
								"DE": "Prosimy o dostarczenie nam obu stron dowodu osobistego. Jeśli adres nie znajduje się na dowodzie osobistym, będziemy potrzebować dodatkowej dokumentacji, takiej jak rachunek za media, aby zweryfikować adres.",
								"FR": "Prosimy dostarczyć obie strony dowodu osobistego, upewnić się, że jakość obrazu jest wystarczająca i że wszystkie informacje są czytelne.",
								"GB": "Przedstaw dokument tożsamości. Jeśli jest to dowód osobisty, pokaż jego obie strony.",
								"IT": "Ważny dowód tożsamości (przód/tył) dla każdej z osób wymienionych we wniosku. Prawo jazdy, paszport, karta/numer ubezpieczenia społecznego nie są akceptowane.",
								"NL": "Prosimy dostarczyć obie strony dowodu osobistego, upewnić się, że jakość obrazu jest wystarczająca i że wszystkie informacje są czytelne.",
								"US": "Prawo jazdy lub paszport – prosimy pokazać obie strony dokumentu tożsamości."
							}
						},
						"LICENSE": {
							"title": {
								"default": "Licencja"
							},
							"subtitle": {
								"default": null
							}
						},
						"PROOF_OF_ADDRESS": {
							"title": {
								"default": "Potwierdzenie adresu zamieszkania",
								"BE": "Potwierdzenie adresu zamieszkania",
								"CZ": "Potwierdzenie adresu zamieszkania",
								"ES": "Potwierdzenie adresu zamieszkania",
								"FI": "Potwierdzenie adresu zamieszkania",
								"FR": "Potwierdzenie adresu zamieszkania",
								"GR": "Potwierdzenie adresu zamieszkania",
								"IT": "Potwierdzenie adresu zamieszkania",
								"NL": "Potwierdzenie adresu zamieszkania",
								"PL": "Potwierdzenie adresu zamieszkania",
								"PT": "Potwierdzenie adresu zamieszkania"
							},
							"subtitle": {
								"default": "Akceptujemy następujące dokumenty (nie starsze niż 3 miesiące) jako potwierdzenie adresu zamieszkania: Rachunki za prąd, wodę, gaz, internet domowy, najnowsza deklaracja podatkowa (PIT) lub umowa najmu. Jeśli nie posiadasz żadnego z tych dokumentów, prosimy o przesłanie innego dowodu adresu zamieszkania i dodanie notatki z wyjaśnieniem.",
								"AU": "W celu szybszej oceny wniosku prosimy o dostarczenie jednego z poniższych dokumentów z ostatnich 90 dni w celu weryfikacji adresu zamieszkania: Rachunek za usługi komunalne, rachunek za internet, deklaracja podatkowa lub umowa najmu/dzierżawy. * Jeśli w ramach identyfikacji podano paszport lub jeśli Państwa obecny adres nie zgadza się z adresem na podanym dokumencie tożsamości, ten krok jest obowiązkowy.",
								"BE": "Jako dowód adresu zamieszkania przyjmujemy następujące dokumenty, które nie są starsze niż 3 miesiące: prąd, woda, gaz, deklaracja podatkowa lub umowa najmu. W przypadku braku któregokolwiek z dokumentów, prosimy o przesłanie innego dowodu potwierdzającego zamieszkanie w domu i dodanie notatki z powodem.",
								"FR": "Jako dowód adresu zamieszkania przyjmujemy następujące dokumenty, które nie są starsze niż 3 miesiące: prąd, woda, gaz, deklaracja podatkowa lub umowa najmu. W przypadku braku któregokolwiek z dokumentów, prosimy o przesłanie innego dowodu potwierdzającego zamieszkanie w domu i dodanie notatki z powodem.",
								"NL": "Jako dowód adresu zamieszkania przyjmujemy następujące dokumenty, które nie są starsze niż 3 miesiące: prąd, woda, gaz, deklaracja podatkowa lub umowa najmu. W przypadku braku któregokolwiek z dokumentów, prosimy o przesłanie innego dowodu potwierdzającego zamieszkanie w domu i dodanie notatki z powodem.",
								"US": "Akceptujemy rachunki za media (gaz, woda, internet, telefon itp.), najem/dzierżawę lub hipotekę z dowodem adresu – dokumenty te nie mogą być starsze niż 90 dni od daty złożenia wniosku.",
								"IT": "Jeśli na dowodzie osobistym widnieje inny adres niż aktualny adres zamieszkania, będziemy potrzebowali dodatkowego dokumentu, aby zweryfikować aktualne miejsce zamieszkania. Jako dowód adresu zamieszkania osób wymienionych we wniosku przyjmujemy następujące dokumenty (nie starsze niż 3 miesiące):"
							},
							"list": {
								"IT": [
									{
										"text": "Zaświadczenie o miejscu zamieszkania wydane online (za pośrednictwem SPID) lub przez gminę zamieszkania"
									},
									{
										"text": "Rachunki za prąd / wodę / gaz / internet"
									},
									{
										"text": "umowa najmu"
									}
								]
							}
						},
						"SPECIAL_AGREEMENT": {
							"title": {
								"default": "Umowa specjalna"
							},
							"subtitle": {
								"default": null
							}
						},
						"SUPPORTING_DOCUMENT": {
							"title": {
								"default": "Dokument pomocniczy",
								"GB": "Autoportret"
							},
							"subtitle": {
								"default": null,
								"AU": "Jeśli sprzedajecie Państwo markowe artykuły o wysokiej wartości, prosimy przedstawić 2–3 faktury od dostawców na te produkty. Prosimy o upewnienie się, że faktura zawiera zakupione produkty, nazwę dostawcy, nazwę odbiorców oraz adres dostawy.",
								"GB": "Prosimy o załączenie zdjęcia-autoportretu, trzymając dokument tożsamości."
							}
						},
						"TAX_OFFICE_REGISTRATION": {
							"title": {
								"default": "Dokument rejestracji w urzędzie skarbowym",
								"AT": "Dokument o rejestracji w urzędzie skarbowym",
								"AU": "Akt założycielski",
								"BE": "Numer VAT włączony dla transakcji transgranicznych (VIES).",
								"DE": "Dokument o rejestracji w urzędzie skarbowym",
								"FR": "Numer VAT włączony dla transakcji transgranicznych (VIES).",
								"IT": "Numer VAT włączony dla transakcji transgranicznych (VIES).",
								"NL": "Numer VAT włączony dla transakcji transgranicznych (VIES).",
								"NO": "Potwierdzenie rejestracji w Urzędzie Skarbowym",
								"US": "List EIN"
							},
							"subtitle": {
								"default": null,
								"AT": "Za dokumentację służbową uznajemy następujące dokumenty: Wypis z rejestru handlowego / licencja na prowadzenie działalności gospodarczej",
								"AU": "Jeśli ABN jest związany z trustem, prosimy dostarczyć kopię dokumentu trustu, w tym harmonogramu trustu. Uwaga, ten krok jest obowiązkowy dla trustów.",
								"BE": "Prosimy sprawdzić, czy numer VAT jest włączony dla transakcji transgranicznych. Jest to konieczne, nawet jeśli handel ma miejsce tylko w swoim lokalnym kraju, ponieważ Klarna jest podmiotem zagranicznym. https://ec.europa.eu/taxation_customs/vies/#/vat-validation Możecie Państwo skontaktować się z lokalnym urzędem skarbowym, aby poprosić o bezpłatną aktywację numeru VAT w systemie VIES.",
								"CZ": "Za dokumentację służbową uznajemy następujące dokumenty: Zaświadczenie o wpisie do Rejestru Publicznego lub wypis z rejestru handlowego jednoosobowej działalności gospodarczej.",
								"DE": "Za dokumentację służbową uznajemy następujące dokumenty: Wypis z rejestru handlowego / licencja na prowadzenie działalności gospodarczej",
								"ES": "Akceptujemy następujące dokumenty jako dokumenty firmowe: Akty założycielskie dla zarejestrowanych firm; dla osób prowadzących jednoosobową działalność gospodarczą – Poświadczenie informacji zawartych w spisie powszechnym / Model 036 / Model 037",
								"FI": "Za dokumentację służbową uznajemy następujące dokumenty: Rejestracja działalności gospodarczej dla osób prowadzących jednoosobową działalność gospodarczą - Poświadczenie informacji zawartych w spisie powszechnym / Model 036 / Model 037",
								"FR": "Prosimy sprawdzić, czy numer VAT jest włączony dla transakcji transgranicznych. Jest to konieczne, nawet jeśli handel ma miejsce tylko w swoim lokalnym kraju, ponieważ Klarna jest podmiotem zagranicznym. https://ec.europa.eu/taxation_customs/vies/#/vat-validation Możecie Państwo skontaktować się z lokalnym urzędem skarbowym, aby poprosić o bezpłatną aktywację numeru VAT w systemie VIES.",
								"GR": "Za dokumentację służbową uznajemy następujące dokumenty: Rejestracja w urzędzie skarbowym / rozpoczęcie działalności gospodarczej / dokument rejestracji działalności gospodarczej wydany przez właściwy serwis GEMI (Centralny Związek Izb)",
								"IT": "Mogą Państwo skontaktować się z urzędem skarbowym (Agenzia delle Entrate), aby poprosić o bezpłatną aktywację numeru VAT w systemie VIES. Będzie to konieczne, nawet jeśli działalność jest prowadzona tylko we Włoszech, ponieważ Klarna jest podmiotem zagranicznym.",
								"NL": "Prosimy sprawdzić, czy numer VAT jest włączony dla transakcji transgranicznych. Jest to konieczne, nawet jeśli handel ma miejsce tylko w swoim lokalnym kraju, ponieważ Klarna jest podmiotem zagranicznym. https://ec.europa.eu/taxation_customs/vies/#/vat-validation Możecie Państwo skontaktować się z lokalnym urzędem skarbowym, aby poprosić o bezpłatną aktywację numeru VAT w systemie VIES.",
								"NO": "Za dokumentację służbową uznajemy następujące dokumenty: Dokumenty firmowe",
								"PL": "Jako dokumenty potwierdzające prowadzenie działalności gospodarczej akceptujemy następujące dokumenty: zaświadczenie o wpisie do ewidencji gospodarczej CEIDG, odpis z KRS",
								"PT": "Akceptujemy następujące dokumenty jako dokumenty firmowe: Certidão Permanente (obowiązkowe), Certificate of Incorporation. W przypadku przedsiębiorców indywidualnych, rejestracja samozatrudnienia (Declaração de Início de Atividade).",
								"US": "Jest to list otrzymany z IRS nadający Państwu numer EIN (IRS CP575 EIN Letter). Jeśli Państwa firma jest jednoosobową działalnością, a wniosek składany jest na podstawie numeru SSN, prosimy o dostarczenie kopii karty SSN."
							},
							"link": {
								"BE": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"FR": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"NL": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"GR": "https://www.businessregistry.gr/publicity/index"
							}
						},
						"CERTIFIED_ID": {
							"title": {
								"default": "Poświadczony dokument tożsamości"
							},
							"subtitle": {
								"default": "Akceptujemy następujące dokumenty: Dowód osobisty, paszport, prawo jazdy. Dokumenty muszą spełniać następujące kryteria:"
							},
							"list": [
								{
									"text": "Poświadczone przez upoważnionego urzędnika (np. notariusza, prawnika upoważnionego do przyjmowania zaprzysiężonych zeznań, prawnika, adwokata i/lub biegłego księgowego)."
								},
								{
									"text": "Podpisane i opatrzone pieczęcią. Na pieczęci muszą znajdować się widoczne i możliwe do sprawdzenia dane dotyczące podmiotu certyfikującego, takie jak pełna nazwa, adres oraz, w stosownych przypadkach, numer rejestracyjny."
								},
								{
									"text": "Datowany – data certyfikacji nie starsza niż 6 miesięcy."
								},
								{
									"text": "Poświadczona za zgodność z oryginałem kopia poprzez wyraźne stwierdzenie, że widziano oryginalny dokument."
								}
							]
						}
					},
					"modal": {
						"title": "Dlaczego potrzebujemy Twoich dokumentów?",
						"close": "Zamknij",
						"content": [
							{
								"title": "Opis procedury",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Wymagania dotyczące plików",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Jak skanować dokumenty?",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							}
						]
					},
					"errors": {
						"general": "Przesyłanie nie powiodło się",
						"too_large_file": "Plik jest za duży <strong>(maks. {maxFileSizeMB} MB)</strong>",
						"max_num_files_exceeded": "Dopuszczalna liczba przesyłanych plików to {number}.",
						"invalid_file_format": "Nieprawidłowy format pliku. Akceptowane typy plików to {acceptedFileFormats}",
						"duplicate_file_name": "Zduplikowana nazwa pliku. Wszystkie przesyłane pliki muszą mieć unikalne nazwy.",
						"try_again": "Spróbuj ponownie lub <u>wybierz inny plik</u>"
					},
					"buttons": {
						"modal": "Dlaczego potrzebujemy Twoich dokumentów?",
						"next": "Dalej",
						"back": "Wstecz",
						"submit": "Prześlij dokumenty"
					}
				},
				"document_upload_success": {
					"title": "Przesyłanie zakończone.",
					"message": "Dziękujemy! Twoje dokumenty zostały przesłane pomyślnie."
				},
				"forced_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Podaj swój numer NIP",
							"AT": "Podaj swój numer NIP",
							"CA": "Czy możesz podać swój federalny nr BN?",
							"GR": "Czy możesz podać swój numer G.E.MI. (Γ.Ε.ΜΗ.)?",
							"NZ": "Czy możesz podać numer swojej firmy?"
						},
						"managed": {
							"default": "Czy możesz podać numer rejestracyjny firmy?",
							"AT": "Czy możesz podać numer rejestracyjny firmy?",
							"CA": "Czy możesz podać swój federalny nr BN?",
							"GR": "Czy możesz podać numer G.E.MI. (Γ.Ε.ΜΗ.) firmy?",
							"NZ": "Czy możesz podać numer rejestracyjny firmy?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Potrzebujemy Twój numer NIP, aby zweryfikować Twoją działalność.",
							"AT": "Potrzebujemy Twój numer NIP, aby zweryfikować Twoją działalność.",
							"CA": "Potrzebujemy Twojego federalnego numeru działalności gospodarczej nadanego Twojej firmie przez CRA (Canada Revenue Agency), aby zweryfikować dane Twojej firmy.",
							"GR": "Potrzebujemy Twojego numeru G.E.MI. (Γ.Ε.ΜΗ.), aby zweryfikować dane firmowe.",
							"NZ": "Potrzebujemy numeru rejestracyjnego Twojej firmy, aby zweryfikować Twoje dane."
						},
						"managed": {
							"default": "Potrzebujemy numeru rejestracyjnego firmy, aby zweryfikować podane dane biznesowe.",
							"AT": "Potrzebujemy numeru rejestracyjnego firmy, aby zweryfikować podane dane biznesowe.",
							"CA": "Potrzebujemy Twojego federalnego numeru działalności gospodarczej nadanego Twojej firmie przez CRA (Canada Revenue Agency), aby zweryfikować dane Twojej firmy.",
							"GR": "Potrzebujemy numeru G.E.MI. (Γ.Ε.ΜΗ.), aby zweryfikować dane firmowe.",
							"NZ": "Potrzebujemy numeru rejestracyjnego firmy, aby zweryfikować dane."
						}
					},
					"infobox": {
						"unmanaged": {
							"CA": "Informujemy, że Klarna nie może obecnie świadczyć usług płatniczych dla kanadyjskich jednoosobowych działalności gospodarczych. Kontynuowanie wniosku spowoduje jego odrzucenie."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Numer rejestracyjny",
								"AT": "Numer rejestracyjny",
								"CA": "Numer firmowy",
								"GR": "Numer G.E.MI. (Γ.Ε.ΜΗ.)",
								"NZ": "Numer firmowy"
							}
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"tax_identification_number": {
					"title": {
						"unmanaged": "Jaka jest Twoja klasyfikacja podatkowa?",
						"managed": "Czy możesz podać klasyfikację podatkową firmy?"
					},
					"subtitle": {
						"unmanaged": "W zależności od statusu prawnego firmy poprosimy Cię o różne informacje.",
						"managed": "W zależności od statusu prawnego firmy poprosimy Cię o różne informacje."
					},
					"info": {
						"unmanaged": "Numer EIN Twojej firmy (Employer Identification Number) można znaleźć w zeznaniach podatkowych, raportach kredytowych, dokumentacji płacowej lub licencjach i zezwoleniach.",
						"managed": "Numer EIN firmy (Employer Identification Number) można znaleźć w zeznaniach podatkowych, raportach kredytowych, dokumentacji płacowej lub licencjach i zezwoleniach."
					},
					"fields": {
						"registration_number": {
							"label": "Numer identyfikacyjny pracodawcy",
							"errors": {
								"general": "Wprowadź prawidłowy numer identyfikacyjny pracodawcy (Employer Identification Number)",
								"invalid": "Numer identyfikacyjny pracodawcy powinien składać się z 9 cyfr z symbolem „-” po pierwszych dwóch. Przykład: 12-3456789"
							}
						},
						"organization_entity": {
							"label": {
								"unmanaged": "Federalna Klasyfikacja Podatkowa",
								"managed": "Rodzaj działalności"
							},
							"errors": {
								"is_one_of": "Wybierz jeden z wymienionych rodzajów działalności"
							}
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"forced_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Czy możesz podać swój numer VAT?",
							"AU": "Czy możesz podać swój numer ABN?",
							"ES": "Jaki jest twój numer identyfikacji podatkowej?",
							"NZ": "Czy możesz podać swój numer GST?"
						},
						"managed": {
							"default": "Czy możesz podać numer VAT?",
							"AU": "Czy możesz podać numer ABN?",
							"ES": "Jaki jest twój numer identyfikacji podatkowej?",
							"NZ": "Czy możesz podać numer GST?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Posiadając Twój numer VAT, możemy łatwiej zweryfikować dane Twojej firmy.",
							"AU": "Posiadając Twój numer ABN, możemy łatwiej zweryfikować dane Twojej firmy.",
							"NZ": "Posiadając Twój numer GST, możemy łatwiej zweryfikować dane Twojej firmy.",
							"ES": "Posiadając Twój numer NIF, NIE, DNI, możemy łatwiej zweryfikować dane Twojej firmy."
						},
						"managed": {
							"default": "Numer VAT służy nam do weryfikacji danych firmy.",
							"AU": "Numer ABN służy nam do weryfikacji danych firmy.",
							"NZ": "Numer GST służy nam do weryfikacji danych firmy.",
							"ES": "Numery NIF, NIE lub DNI służą nam do weryfikacji danych firmy."
						}
					},
					"fields": {
						"vat_number": {
							"label": {
								"default": "Numer VAT",
								"AU": "ABN",
								"NZ": "Numer GST",
								"ES": "NIF / NIE / DNI"
							}
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"legal_entity_type": {
					"title": {
						"unmanaged": "Jaki rodzaj działalności prowadzisz?",
						"managed": "Jaki rodzaj działalności prowadzi ta firma?"
					},
					"subtitle": {
						"unmanaged": "Jesteśmy zobowiązani do zadania kilku szczegółowych pytań w zależności od rodzaju prowadzonej przez Ciebie działalności.",
						"managed": "Jesteśmy zobowiązani do zadania kilku szczegółowych pytań w zależności od rodzaju prowadzonej przez Ciebie działalności."
					},
					"fields": {
						"legal_entity_type": {
							"label": "Typ osoby prawnej",
							"errors": {
								"is_one_of": "Wybierz jeden z wymienionych rodzajów działalności"
							}
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"optional_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Czy Twoja firma jest zarejestrowaną działalnością?",
							"AU": "Czy Twoja firma posiada numer ACN?",
							"ES": "Czy Twoja firma znajduje się w Registro Mercantil?"
						},
						"managed": {
							"default": "Czy ta firma jest zarejestrowaną działalnością?",
							"AU": "Czy ta firma ma numer ACN?",
							"ES": "Czy Twoja firma znajduje się w Registro Mercantil?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Potrzebujemy Twój numer NIP, aby zweryfikować Twoją działalność.",
							"AT": "Potrzebujemy Twój numer NIP, aby zweryfikować Twoją działalność.",
							"AU": "Jeśli posiadasz numer ACN, wpisz go, w przeciwnym razie wybierz „nie” i przejdź dalej.",
							"ES": "Odpowiedź Tak, jeśli jesteś SL, SA, SCP itp. Odpowiedź Nie, jeśli jesteś „autónomo”, „freelancerem” itp...",
							"GB": "Potrzebujemy numeru organizacyjnego Twojej firmy, aby zweryfikować Twoje dane.",
							"GR": "Potrzebujemy Twojego numeru G.E.MI. (Γ.Ε.ΜΗ.), aby zweryfikować dane firmowe."
						},
						"managed": {
							"default": "Potrzebujemy numeru rejestracyjnego firmy, aby zweryfikować podane dane biznesowe.",
							"AT": "Potrzebujemy numeru rejestracyjnego firmy, aby zweryfikować podane dane biznesowe.",
							"AU": "Jeśli firma posiada numer ACN, wpisz go, w przeciwnym razie wybierz „nie” i przejdź dalej.",
							"ES": "Odpowiedź Tak, jeśli jesteś SL, SA, SCP itp. Odpowiedź Nie, jeśli jesteś „autónomo”, „freelancerem” itp...",
							"GB": "Potrzebujemy numeru organizacyjnego firmy, aby zweryfikować podane dane biznesowe.",
							"GR": "Potrzebujemy numeru G.E.MI. (Γ.Ε.ΜΗ.) firmy, aby zweryfikować dane firmowe."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Podaj swój numer rejestracyjny",
							"AT": "Podaj swój numer rejestracyjny",
							"AU": "Podaj swój numer ACN",
							"ES": "Podaj numer NIF / NIE / DNI swoje firmy",
							"GB": "Podaj swój numer organizacji",
							"GR": "Wprowadź swój numer G.E.MI. (Γ.Ε.ΜΗ.)"
						},
						"managed": {
							"default": "Podaj numer rejestracyjny",
							"AT": "Podaj numer rejestracyjny",
							"AU": "Podaj numer ACN",
							"ES": "Podaj numer NIF / NIE / DNI swoje firmy",
							"GB": "Podaj numer organizacji",
							"GR": "Wprowadź numer G.E.MI. (Γ.Ε.ΜΗ.)"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Numer rejestracyjny",
								"AT": "Numer rejestracyjny",
								"AU": "Australijski Numer Spółki (ACN)",
								"ES": "NIF / NIE / DNI firmy",
								"GB": "Numer organizacji",
								"GR": "Numer G.E.MI. (Γ.Ε.ΜΗ.)"
							},
							"errors": null
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"mid-selector": {
					"title": "Wybierz sklep",
					"subtitle": "Ten e-mail jest powiązany z wieloma sklepami. Prosimy wybrać sklep, aby kontynuować.",
					"mid-selector": "Identyfikator sprzedawcy / Nazwa sklepu",
					"buttons": {
						"next": "Kontynuuj"
					}
				},
				"optional_registration_information_widget": {
					"title": {
						"unmanaged": "Czy Twoja firma jest zarejestrowaną działalnością?",
						"managed": "Czy ta firma jest zarejestrowaną działalnością?"
					},
					"subtitle": {
						"unmanaged": {
							"default": "Potrzebujemy Twój numer NIP, aby zweryfikować Twoją działalność.",
							"AT": "Potrzebujemy Twój numer NIP, aby zweryfikować Twoją działalność."
						},
						"managed": {
							"default": "Potrzebujemy numeru rejestracyjnego firmy, aby zweryfikować podane dane biznesowe.",
							"AT": "Potrzebujemy numeru rejestracyjnego firmy, aby zweryfikować podane dane biznesowe."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Podaj swój numer rejestracyjny",
							"AT": "Podaj swój numer rejestracyjny"
						},
						"managed": {
							"default": "Podaj numer rejestracyjny",
							"AT": "Podaj numer rejestracyjny"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Numer rejestracyjny",
								"AT": "Numer rejestracyjny"
							}
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"optional_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Czy Twoja firma jest zarejestrowanym płatnikiem VAT?",
							"ES": "Czy Twoja firma posiada NIF / NIE / DNI?",
							"NZ": "Czy Twoja firma jest zarejestrowanym płatnikiem podatku od towarów i usług (GST)?"
						},
						"managed": {
							"default": "Czy ta firma jest zarejestrowanym płatnikiem VAT?",
							"ES": "Czy Twoja firma posiada NIF / NIE / DNI?",
							"NZ": "Czy ta firma jest zarejestrowanym płatnikiem podatku od towarów i usług (GST)?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Jeśli posiadasz numer VAT, możemy łatwiej zweryfikować dane Twojej firmy.",
							"ES": "Jeśli Twoja firma posiada numer NIF / NIE / DNI, możemy łatwiej zweryfikować dane Twojej firmy.",
							"NZ": "Jeśli posiadasz numer GST, możemy łatwiej zweryfikować dane Twojej firmy."
						},
						"managed": {
							"default": "Numer VAT służy nam do weryfikacji danych firmy.",
							"ES": "Jeśli Twoja firma posiada numer NIF / NIE / DNI, możemy łatwiej zweryfikować dane Twojej firmy.",
							"NZ": "Numer GST służy nam do weryfikacji danych firmy."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Wpisz swój numer VAT",
							"ES": "Podaj numer NIF / NIE / DNI swoje firmy",
							"NZ": "Wpisz swój numer GST"
						},
						"managed": {
							"default": "Wpisz numer VAT",
							"ES": "Podaj numer NIF / NIE / DNI swoje firmy",
							"NZ": "Wpisz swój numer GST"
						}
					},
					"vat_id": {
						"label": {
							"default": "Numer VAT",
							"ES": "NIF / NIE / DNI firmy",
							"NZ": "Numer GST"
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"optional_vat_registration_widget": {
					"title": {
						"unmanaged": "Czy Twoja firma jest zarejestrowanym płatnikiem VAT?",
						"managed": "Czy ta firma jest zarejestrowanym płatnikiem VAT?"
					},
					"subtitle": {
						"unmanaged": "Jeśli posiadasz numer VAT, możemy łatwiej zweryfikować dane Twojej firmy.",
						"managed": "Numer VAT służy nam do weryfikacji danych firmy."
					},
					"form_title": {
						"unmanaged": "Wpisz swój numer VAT",
						"managed": "Wpisz numer VAT"
					},
					"vat_id": {
						"label": {
							"default": "Numer VAT",
							"NZ": "Numer GST"
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"partnership_details": {
					"title": {
						"unmanaged": "Jaki jest adres Twojej firmy?",
						"managed": "Jaki jest adres siedziby firmy?"
					},
					"subtitle": {
						"unmanaged": "Musimy wiedzieć, gdzie znajduje się Twoja firma.",
						"managed": "Musimy wiedzieć, gdzie znajduje się firma."
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					},
					"fields": {
						"partnership_name": {
							"label": "Nazwa spółki",
							"errors": {
								"general": "Podaj nazwę spółki"
							}
						},
						"street": {
							"label": "Adres",
							"errors": {
								"general": "Podaj prawidłowy adres"
							}
						},
						"postal_code": {
							"label": "Kod pocztowy",
							"errors": {
								"general": "Podaj prawidłowy kod pocztowy"
							}
						},
						"city": {
							"label": "Miasto",
							"errors": {
								"general": "Podaj poprawną nazwę miasta"
							}
						},
						"country": {
							"label": "Kraj",
							"errors": {
								"general": "Podaj poprawną nazwę kraju"
							}
						}
					}
				},
				"partners_and_principals": {
					"title": {
						"default": "Do kogo należy firma?",
						"GB": "Kto zarządza firmą?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Jesteśmy prawnie zobowiązani przez dyrektywę UE w sprawie przeciwdziałania praniu brudnych pieniędzy ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "), aby zbierać takie informacje."
							}
						],
						"AU": [
							{
								"text": "Jako instytucja finansowa jesteśmy prawnie zobowiązani do gromadzenia tych informacji."
							}
						]
					},
					"infobox": "Prosimy o podanie danych osobowych i adresu zamieszkania wszystkich partnerów i dyrektorów, którzy sprawują kontrolę nad zarządzaniem Twoją firmą.",
					"buttons": {
						"add_person": "+ Dodaj osobę",
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"payouts_summary": {
					"title": "Rachunki bankowe",
					"default_bank_accounts": {
						"no_elements": "Brak domyślnego konta bankowego"
					},
					"additional_bank_accounts": {
						"no_elements": "Nie podano żadnych dodatkowych rachunków bankowych"
					}
				},
				"pre_assessment_company_details": {
					"title": "Podaj więcej szczegółów dotyczących możliwości.",
					"subtitle": "Podaj nam udział w wolumenie kart oraz dane firmy tego sprzedawcy. Proszę również o wskazanie, czy firma działa na innym rynku niż kraj rejestracji, gdyż jest to wymagane do oceny ryzyka.",
					"fields": {
						"volume_by_card": {
							"label": "Udział wolumenu kart w wolumenie ogółem (%)",
							"errors": {
								"invalid": "Wolumen kart powinien być liczbą z przedziału od 0 do 100",
								"invalid_hint": "Dodaj udział wolumenu transakcji kartami w całkowitym wolumenie Klarna dla tej opcji. Wpisz 0%, jeśli Twoja opcja nie ma żadnych płatności kartą"
							}
						},
						"average_order_value": {
							"label": "Średnia wartość zamówienia (w SEK)",
							"tooltip": "Powinna być dodatnią kwotą wyrażoną w SEK",
							"errors": {
								"invalid": "Powinna być dodatnią kwotą wyrażoną w SEK"
							}
						},
						"registration_country": {
							"label": "Kraj rejestracji",
							"errors": {
								"required": "Wymagamy podania kraju rejestracji"
							}
						},
						"operating_country": {
							"label": "Kraj operacji",
							"errors": {
								"required": "Wymagamy podania kraju operacji"
							}
						},
						"registration_number": {
							"label": {
								"default": "Numer rejestracyjny (wymagany w przypadku zarejestrowanych firm)",
								"AU": "ACN (wymagany dla zarejestrowanych firm)",
								"ES": "NIF/NIE/DNI firmy (wymagane dla zarejestrowanych firm)",
								"GR": "Numer G.E.MI. (Γ.Ε.ΜΗ.) (wymagany dla zarejestrowanych firm)",
								"NZ": "Numer firmowy (wymagany dla zarejestrowanych firm)",
								"US": "TIN/EIN (wymagany dla zarejestrowanych firm)"
							}
						},
						"vat_number": {
							"label": "ABN",
							"errors": {
								"required": "Podaj numer ACN lub ABN",
								"invalid": "ABN powinien składać się z 11 cyfr"
							}
						},
						"registration_authority": {
							"label": "Organ rejestracyjny",
							"errors": {
								"required": "Wybierz swój organ rejestracyjny"
							}
						},
						"company_name": {
							"label": "",
							"errors": {
								"required": ""
							}
						},
						"sales_contact": {
							"label": "E-mail przedstawiciela handlowego",
							"errors": {
								"invalid": "Podaj poprawny adres e-mail"
							}
						},
						"store_url": {
							"label": "Adres URL sklepu",
							"errors": {
								"required": "Adres URL sklepu jest wymagany",
								"invalid": "Podaj prawidłowy adres URL witryny internetowej"
							}
						},
						"goods_category": {
							"label": "Główna kategoria sprzedawanych towarów",
							"errors": {
								"invalid": "Należy wybrać jedną z opcji"
							}
						},
						"is_managed": {
							"label": "Zarządzany będzie aktywny?"
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"pre_assessment_products": {
					"title": "Wymień wszystkie produkty",
					"subtitle": "Do oceny ryzyka wymagane jest podanie wszystkich produkty w danym kraju sprzedaży",
					"select": {
						"label": "Wyszukaj produkt"
					},
					"selected": {
						"label": "Wybrane produkty:"
					},
					"clear": "Wyczyść wszystko",
					"errors": {
						"invalid": "Należy wybrać co najmniej jeden produkt z każdego kraju"
					},
					"channels": {
						"ONLINE": "Online",
						"IN_STORE": "W sklepie",
						"TELESALES": "Telesprzedaż",
						"SELLER_APP": "Aplikacja sprzedażowa"
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"wrong_prefill_data": {
					"title": "Podano nieprawidłowe dane",
					"subtitle": "Nieprawidłowe lub niezgodne informacje dostarczone przez SalesForce.",
					"details": "Szczegóły ",
					"fields": {
						"goodsCategory": "Kategoria towarów",
						"paymentInterval": "Interwał płatności",
						"paymentDelay": "Opóźnienie płatności",
						"registrationCountry": "Kraj rejestracji",
						"storeUrl": "Adres URL sklepu",
						"mainSellingCountry": "Główny kraj sprzedaży",
						"products": "Produkty",
						"products_item": "Produkt {index}",
						"products_item_yearlyAcquiredVolume": "Produkt {index} – roczny wolumen nabycia",
						"products_item_sellingCountry": "Produkt {index} – kraj sprzedaży",
						"products_item_productName": "Nazwa produktu {index}",
						"products_item_channels": "Produkt {index} – kanały",
						"products_item_channels_item": "Produkt {index} – kanały"
					},
					"error_types": {
						"fallback": "jest niepoprawne",
						"any": {
							"required": "jest wymagane, a nie podano żadnego"
						}
					}
				},
				"selling_countries": {
					"title": "Wymień wszystkie kraje sprzedaży",
					"subtitle": "Do oceny ryzyka wymagana jest pełna lista krajów",
					"select": {
						"label": "Wyszukaj kraj"
					},
					"selected": {
						"label": "Wybrane kraje:"
					},
					"fields": {
						"selling_countries": {
							"label": "Wybierz kraj",
							"errors": {
								"invalid": "Musisz wybrać co najmniej jeden kraj"
							}
						}
					},
					"clear": "Wyczyść wszystko",
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"main_selling_country": {
					"title": "Jaki jest główny rynek Klarna dla sprzedawcy?",
					"subtitle": "Wybierz rynek, na którym spodziewany jest największy wolumen Klarna",
					"errors": {
						"invalid": "Musisz wybrać kraj"
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"fca_number": {
					"title": "Wpisz numer FCA",
					"subtitle": "Jesteśmy prawnie zobowiązani do weryfikacji licencji brokera kredytowego.",
					"fields": {
						"fca_number": {
							"label": "Numer FCA",
							"errors": {
								"general": "Podaj prawidłowy numer FCA."
							}
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"sole_trader": {
					"title": "Do kogo należy firma?",
					"subtitle": {
						"default": [
							{
								"text": "Jesteśmy prawnie zobowiązani przez dyrektywę UE w sprawie przeciwdziałania praniu brudnych pieniędzy ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "), aby zbierać takie informacje."
							}
						]
					},
					"infobox": {
						"unmanaged": "Podaj swoje dane osobowe i adres zamieszkania.",
						"managed": "Podaj dane właściciela i jego adres zamieszkania."
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					},
					"fields": {
						"are_you_the_sole_trader": {
							"label": "Osoba składająca wniosek jest tożsama z osobą prowadzącą jednoosobową działalność gospodarczą",
							"error": "Przykro nam, ale możesz kontynuować tylko wtedy, gdy składasz ten wniosek osobiście jako jednoosobowa działalność gospodarcza."
						}
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Czy prowadzisz działalność pod innym adresem?",
								"managed": "Czy ta firma działa pod innym adresem?"
							},
							"subtitle": {
								"unmanaged": "Wybierz Tak, jeśli prowadzisz działalność gospodarczą pod innym adresem niż adres zamieszkania.",
								"managed": "Wybierz Tak, jeśli firma prowadzi działalność pod innym adresem niż adres zamieszkania przedsiębiorcy."
							}
						},
						"title": "Podaj adres firmy",
						"fields": {
							"street": {
								"label": "Adres",
								"errors": {
									"general": "Podaj prawidłowy adres"
								}
							},
							"postal_code": {
								"label": "Kod pocztowy",
								"errors": {
									"general": "Podaj prawidłowy kod pocztowy"
								}
							},
							"city": {
								"label": "Miasto",
								"errors": {
									"general": "Podaj prawidłową nazwę miasta"
								}
							},
							"country": {
								"label": "Kraj",
								"errors": {
									"general": "Podaj prawidłową nazwę kraju"
								}
							}
						}
					}
				},
				"sole_trader_confirmation": {
					"title": "Czy możesz potwierdzić jeszcze dwie rzeczy?",
					"subtitle": "",
					"fields": {
						"are_you_the_sole_trader": {
							"title": "Jesteś przedsiębiorcą jednoosobowym",
							"label": "Osoba składająca wniosek jest tożsama z osobą prowadzącą jednoosobową działalność gospodarczą"
						},
						"are_you_the_only_with_financial_control": {
							"title": "Tylko Ty masz kontrolę finansową",
							"label": "Właściciel jest jedyną osobą, która sprawuje kontrolę finansową nad kontem bankowym (kontami bankowymi) Twojej firmy"
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					},
					"robot_message": "Przepraszamy, ale musimy potwierdzić te dwie rzeczy"
				},
				"underwriting_info": {
					"title": "Podaj wolumen i termin płatności dla danej opcji",
					"subtitle": "Podaj całkowity oczekiwany roczny wolumen Klarna dla tej opcji dla wszystkich rynków oraz opóźnienie płatności. W przypadku, gdy opóźnienie płatności różni się w zależności od kraju, użyj tego dla wybranego głównego kraju sprzedaży.",
					"fields": {
						"yearly_acquired_volume": {
							"label": "Całkowity roczny wolumen rynku (w SEK)",
							"errors": {
								"invalid": "Całkowity roczny wolumen rynku powinien być dodatnią kwotą w SEK",
								"too_long": "Całkowity roczny wolumen rynku nie może zawierać więcej niż 16 cyfr"
							}
						},
						"payment_delay": {
							"label": "Opóźnienie płatności",
							"errors": {
								"general": "Podaj wartość opóźnienia płatności",
								"invalid": "Opóźnienie płatności powinno być liczbą pomiędzy {min} a {max}."
							}
						},
						"payment_interval": {
							"label": "Interwał płatności",
							"errors": {
								"invalid": "Należy wybrać jedną z opcji"
							}
						},
						"volume_by_card": {
							"label": "Udział w kasach (%)",
							"errors": {
								"invalid": "Udział w kasach powinien być liczbą z przedziału od 0 do 100",
								"invalid_hint": "Dodaj udział wolumenu transakcji kartami w całkowitym wolumenie Klarna dla tej opcji. Wpisz 0%, jeśli Twoja opcja nie ma żadnych płatności kartą"
							}
						},
						"average_order_value": {
							"label": "Średnia wartość zamówienia (w SEK)"
						}
					},
					"buttons": {
						"back": "Wstecz",
						"next": "Dalej"
					}
				},
				"store_details": {
					"title": {
						"unmanaged": {
							"default": "Podaj dane dotyczące Twojego sklepu."
						},
						"managed": "Jakie są dane sklepu?"
					},
					"subtitle": {
						"unmanaged": {
							"US": "Wykorzystamy te informacje do założenia Twojego konta firmowego.",
							"default": "Podane dane posłużą nam jako podstawowe informacje kontaktowe oraz do wglądu w Twój sklep."
						},
						"managed": "Podane dane posłużą jako podstawowe informacje kontaktowe dla klientów oraz do wglądu w sklep."
					},
					"fields": {
						"store_name": {
							"label": {
								"CA": "Nazwa marki / DBA",
								"MX": "Nazwa marki / DBA",
								"US": "Nazwa marki / DBA",
								"default": "Nazwa sklepu"
							},
							"errors": {
								"required": "Nazwa sklepu jest wymagana",
								"required_us": "Wymagana jest nazwa marki / DBA",
								"invalid": "Podaj nazwę sklepu składającą się z minimum 2 znaków",
								"invalid_us": "Podaj nazwę marki / DBA o długości minimum 2 znaków",
								"invalid_characters": "Nazwa sklepu nie może zawierać następujących znaków: < >",
								"invalid_characters_us": "Nazwa marki / DBA nie może zawierać następujących znaków: < >"
							}
						},
						"website": {
							"label": "Witryna sklepu internetowego",
							"errors": {
								"required": "Wymagane jest podanie adresu witryny",
								"invalid": "Podaj prawidłowy adres URL witryny internetowej"
							}
						},
						"goods_category": {
							"label": "Główna kategoria sprzedawanych towarów",
							"errors": {
								"required": "Wymagana jest kategoria towaru"
							}
						},
						"email": {
							"label": "E-mail do obsługi klienta",
							"errors": {
								"required": "Wymagany jest e-mail do obsługi klienta",
								"invalid": "Podaj poprawny adres e-mail"
							}
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Zmień produkty"
					}
				},
				"uk_company_details": {
					"title": {
						"unmanaged": "Jaki jest adres Twojej firmy?",
						"managed": "Jaki jest adres siedziby firmy?"
					},
					"subtitle": {
						"unmanaged": "Musimy wiedzieć, pod jakim adresem zarejestrowana jest Twoja firma.",
						"managed": "Musimy wiedzieć, pod jakim adresem zarejestrowana jest firma."
					},
					"question": {
						"title": {
							"unmanaged": "Czy prowadzisz działalność pod innym adresem?",
							"managed": "Czy ta firma działa pod innym adresem?"
						},
						"subtitle": {
							"unmanaged": "Wybierz Tak, jeśli prowadzisz działalność gospodarczą pod innym adresem niż adres rejestracyjny.",
							"managed": "Wybierz Tak, jeśli firma prowadzi działalność pod innym adresem niż adres rejestracyjny."
						}
					},
					"toggle": {
						"title": "Dodaj adres głównego miejsca prowadzenia działalności"
					},
					"fields": {
						"company_name": {
							"label": "Nazwa prawna przedsiębiorstwa",
							"errors": {
								"general": "Podaj nazwę firmy"
							}
						},
						"street": {
							"label": "Adres",
							"errors": {
								"general": "Podaj adres"
							}
						},
						"postal_code": {
							"label": "Kod pocztowy",
							"errors": {
								"general": "Podaj kod pocztowy"
							}
						},
						"city": {
							"label": "Miasto",
							"errors": {
								"general": "Podaj miasto"
							}
						},
						"country": {
							"label": "Kraj",
							"errors": {
								"general": "Podaj kraj"
							}
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					},
					"messages": {
						"lookup": "Czy to Twoja firma? Sprawdź i potwierdź, czy wszystko jest poprawnie."
					}
				},
				"uk_sole_trader": {
					"title": "Do kogo należy firma?",
					"subtitle": {
						"unmanaged": "Zamierzasz zawrzeć umowę z Klarna. Dlatego też musimy zebrać Twoje dane osobowe.",
						"managed": "Jesteśmy zobowiązani do zbierania i weryfikacji danych osobowych właściciela."
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Czy prowadzisz działalność pod innym adresem?",
								"managed": "Czy ta firma działa pod innym adresem?"
							},
							"subtitle": {
								"unmanaged": "Wybierz Tak, jeśli prowadzisz działalność gospodarczą pod innym adresem niż adres zamieszkania.",
								"managed": "Wybierz Tak, jeśli firma prowadzi działalność pod innym adresem niż adres zamieszkania przedsiębiorcy."
							}
						},
						"title": "Podaj adres firmy",
						"fields": {
							"street": {
								"label": "Adres",
								"errors": {
									"general": "Podaj prawidłowy adres"
								}
							},
							"postal_code": {
								"label": "Kod pocztowy",
								"errors": {
									"general": "Podaj prawidłowy kod pocztowy"
								}
							},
							"city": {
								"label": "Miasto",
								"errors": {
									"general": "Podaj prawidłową nazwę miasta"
								}
							},
							"country": {
								"label": "Kraj",
								"errors": {
									"general": "Podaj prawidłową nazwę kraju"
								}
							}
						}
					}
				},
				"us_sole_proprietorship": {
					"title": "Do kogo należy firma?",
					"subtitle": {
						"default": "Jako instytucja finansowa jesteśmy prawnie zobowiązani do gromadzenia tych informacji."
					},
					"infobox": {
						"unmanaged": "Podaj swoje dane osobowe i adres zamieszkania.",
						"managed": "Podaj dane właściciela i jego adres zamieszkania."
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Czy prowadzisz działalność pod innym adresem?",
								"managed": "Czy ta firma działa pod innym adresem?"
							},
							"subtitle": {
								"unmanaged": "Wybierz Tak, jeśli prowadzisz działalność gospodarczą pod innym adresem niż adres zamieszkania.",
								"managed": "Wybierz Tak, jeśli firma prowadzi działalność pod innym adresem niż adres zamieszkania przedsiębiorcy."
							}
						},
						"title": "Podaj adres firmy",
						"fields": {
							"street": {
								"label": "Adres",
								"errors": {
									"general": "Podaj prawidłowy adres"
								}
							},
							"postal_code": {
								"label": "Kod pocztowy",
								"errors": {
									"general": "Podaj prawidłowy kod pocztowy"
								}
							},
							"city": {
								"label": "Miasto",
								"errors": {
									"general": "Podaj prawidłową nazwę miasta"
								}
							},
							"country": {
								"label": "Kraj",
								"errors": {
									"general": "Podaj prawidłową nazwę kraju"
								}
							},
							"region": {
								"label": "Stan",
								"errors": {
									"general": "Podaj nazwę stanu"
								}
							}
						}
					}
				},
				"ultimate_beneficial_owner": {
					"title": {
						"default": "Czy w Twojej firmie są udziałowcy posiadający więcej niż 25% udziałów w firmie?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Jako instytucja finansowa jesteśmy prawnie zobowiązani do gromadzenia tych informacji."
							}
						],
						"default": [
							{
								"text": "Podaj dane osób, które posiadają więcej niż 25% akcji lub praw głosu w spółce lub sprawują podobną kontrolę.\nJesteśmy prawnie zobowiązani przez dyrektywę UE w sprawie przeciwdziałania praniu brudnych pieniędzy ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "), aby zbierać takie informacje."
							}
						]
					},
					"infobox": {
						"default": "Podaj dane osobowe i adres zamieszkania każdej osoby.",
						"AU": "Podaj dane osobowe i adres zamieszkania każdej osoby. W przypadku przedsiębiorstw o złożonych strukturach własnościowych muszą to być osoby fizyczne."
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz",
						"add_person": "+ Dodaj osobę"
					},
					"messages": {
						"lookup": "Czy te osoby posiadają więcej niż 25% udziałów w Twojej firmie? Sprawdź i potwierdź, czy wszystko jest poprawnie."
					}
				},
				"us_company_details": {
					"title": {
						"unmanaged": "Jaki jest adres Twojej firmy?",
						"managed": "Jaki jest zarejestrowany adres siedziby firmy?"
					},
					"subtitle": {
						"unmanaged": "Jest to miejsce, w którym Twoja firma jest legalnie zarejestrowana i będzie widniała na fakturach klientów Klarna.",
						"managed": "Musimy wiedzieć, pod jakim adresem zarejestrowana jest firma."
					},
					"question": {
						"title": {
							"unmanaged": "Czy prowadzisz działalność pod innym adresem?",
							"managed": "Czy ta firma działa pod innym adresem?"
						},
						"subtitle": {
							"unmanaged": "Wybierz Tak, jeśli prowadzisz działalność gospodarczą pod innym adresem niż adres rejestracyjny.",
							"managed": "Wybierz Tak, jeśli firma prowadzi działalność pod innym adresem niż adres rejestracyjny."
						}
					},
					"toggle": {
						"title": "Dodaj adres głównego miejsca prowadzenia działalności"
					},
					"fields": {
						"company_name": {
							"label": "Zarejestrowana nazwa firmy",
							"errors": {
								"general": "Podaj nazwę firmy"
							}
						},
						"street": {
							"label": "Adres",
							"errors": {
								"general": "Podaj adres"
							}
						},
						"postal_code": {
							"label": "Kod pocztowy",
							"errors": {
								"general": "Podaj kod pocztowy"
							}
						},
						"city": {
							"label": "Miasto",
							"errors": {
								"general": "Podaj miasto"
							}
						},
						"country": {
							"label": "Kraj",
							"errors": {
								"general": "Podaj kraj"
							}
						},
						"state_of_incorporation": {
							"label": "Stan, w którym dokonano rejestracji",
							"errors": {
								"general": "Podaj stan, w którym znajduje się siedziba spółki"
							}
						},
						"state": {
							"label": "Stan",
							"errors": {
								"general": "Podaj stan"
							}
						},
						"region": {
							"label": "Region",
							"errors": {
								"puerto_rico": "Puerto Rico nie jest dozwolone"
							}
						}
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"select_products": {
					"title": "Nasze usługi",
					"title_kco_hidden": "Metody płatności, które zwiększają sprzedaż.",
					"subtitle": "Wybierz usługi, które Cię interesują.",
					"subtitle_kco_hidden": "Uwolnij siłę nabywczą swoich klientów. Zaoferuj więcej opcji płatności, aby mogli sami decydować, kiedy i jak płacić.",
					"platform_alert": null,
					"buttons": {
						"next": "Dalej"
					}
				},
				"signup_products": {
					"title_line_1": "Produkty Klarny dostępne dla Twojego sklepu.",
					"title_kco_hidden_line_1": "Metody płatności, które",
					"title_kco_hidden_line_2": "zwiększają sprzedaż.",
					"subtitle": "Oferowanie rozwiązań płatniczych Klarny generuje wzrosty: wzrost konwersji średnio o 30%, średniego koszyka o 41% i częstotliwości zakupów o 36%.",
					"subtitle_kco_hidden": "Uwolnij siłę nabywczą swoich klientów. Zaoferuj więcej opcji płatności, aby mogli sami decydować, kiedy i jak płacić.",
					"info_block": "Wyświetlanie dostępnych produktów dla:",
					"special_offer": "Oferta specjalna: {percentageFee}% + {fixedFee} za transakcję. Ważna do: {validUntil}",
					"buttons": {
						"contact_sales": "Skontaktuj się z działem sprzedaży",
						"next": "Utwórz konto",
						"back": "Wstecz"
					}
				},
				"questionnaire": {
					"buttons": {
						"back": "Wstecz",
						"next": "Dalej"
					}
				},
				"business_concepts": {
					"title": "Wybierz odpowiednie koncepcje biznesowe.",
					"subtitle": "Wybierz tylko te, które mają zastosowanie. Może ich być wiele.",
					"errors": {
						"select_at_least_one": "Podaj co najmniej jedną koncepcję biznesową."
					},
					"buttons": {
						"next": "Dalej",
						"back": "Wstecz"
					}
				},
				"confirm_copy": {
					"title": "Potwierdź kopię",
					"disclaimer": "Wszelkie informacje istniejące w bieżącym MID zostaną nadpisane danymi z: ",
					"merchant_id": "{mid}",
					"buttons": {
						"skipCopy": "Nie kopiuj",
						"confirmCopy": "Skopiuj dane"
					}
				},
				"pre_assessment_summary": {
					"title": "Podsumowanie",
					"subtitle": "Prosimy o dokładne zapoznanie się z danymi, zanim zostaną one przekazane do oceny ryzyka.",
					"banner": {
						"mcc_deal": "To jest umowa MCC. Należy postępować zgodnie z procedurą eskalacji MCC / ECC"
					},
					"selling_countries": {
						"title": "Wybierz rynek, na którym spodziewany jest największy wolumen.",
						"main_selling_country": "Główny kraj sprzedaży"
					},
					"pre_assessment_products": {
						"title": "Produkty"
					},
					"company_details": {
						"title": "Dane firmy"
					},
					"fca_number": {
						"title": "Numer FCA"
					},
					"high_exposure_questionnaires": {
						"title": "Kwestionariusze wysokiego narażenia"
					},
					"mia_questionnaires": {
						"title": "Kwestionariusze MIA"
					},
					"buttons": {
						"back": "Wstecz",
						"edit": "Edytuj",
						"submit": "Prześlij"
					}
				},
				"pre_assessment_overview": {
					"title": "Podsumowanie oceny wstępnej",
					"subtitle_APPROVED": "Poniżej znajdują się zatwierdzone warunki dla tej opcji.",
					"subtitle_REJECTED": "Poniżej znajdują się odrzucone warunki dla tej opcji.",
					"subtitle_UNRESOLVED": "W przypadku zauważenia błędów możesz zmienić przesłane informacje. Nie spowoduje to otwarcia nowej sprawy.",
					"status": {
						"APPROVED": "Sprawa została zatwierdzona",
						"REJECTED": "Sprawa została odrzucona",
						"UNRESOLVED": "Czekamy na decyzję od oceny ryzyka...",
						"UNRESOLVED_TIMED_OUT": "Sprawa przejdzie przez ręczną ocenę ryzyka. Pamiętaj, że może to potrwać kilka dni.",
						"UNRESOLVED_TIMED_OUT_LINK_LABEL": "Wyświetl sprawę w interfejsie użytkownika Merchant Review GUI",
						"STARTED": "Sprawa jest przekazana do weryfikacji"
					},
					"buttons": {
						"change": "Zmień",
						"new_case": "Nowa sprawa"
					}
				},
				"recollection_introduction": {
					"title": {
						"default": "Witamy!"
					},
					"subtitle": {
						"default": [
							{
								"text": "Będąc spółką regulowaną pod nadzorem Szwedzkiego Urzędu Nadzoru Finansowego, Klarna jest zobowiązana do zapobiegania praniu pieniędzy zgodnie z dyrektywą UE 2015/849 (z późniejszymi zmianami lub zastąpioną). Dla Ciebie, jako sprzedawcy, dyrektywa oznacza, że Klarna będzie zbierać informacje o osobach kontrolujących Twoją firmę (beneficjenci rzeczywiści), zanim będzie można rozpocząć korzystanie z usług Klarna. Obecni sprzedawcy regularnie dostarczają takich informacji, aby zapewnić ich aktualność. Więcej informacji znajdziesz w dyrektywie UE "
							},
							{
								"text": "tutaj",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "."
							}
						]
					},
					"buttons": {
						"next": "Dalej"
					}
				},
				"recollection_confirmation": {
					"title": "Potwierdzenie",
					"subtitle": "Prosimy o dokładne zapoznanie się z danymi, zanim zostaną one przekazane do oceny ryzyka.",
					"stakeholder": "Interesariusz {index}",
					"buttons": {
						"back": "Wstecz",
						"submit": "Prześlij"
					}
				},
				"recollection_overview": {
					"title": "Dziękujemy!",
					"subtitle": "Poniżej znajduje się podsumowanie przesłanych przez Ciebie informacji.",
					"stakeholder": "Interesariusz {index}",
					"notice": "Twoje dane zostały przesłane pomyślnie."
				},
				"volume_separation": {
					"title_line_1": "Jak duży jest Twój sklep online?",
					"subtitle": "Klarna oferuje najlepsze rozwiązania dostosowane do potrzeb Twojej firmy – niezależnie od tego, czy jest ona duża czy mała.",
					"selector_title": "Roczny przychód",
					"below": "Poniżej {threshold}",
					"between": "Pomiędzy {belowThreshold} a {aboveThreshold}",
					"over": "Ponad {threshold}",
					"buttons": {
						"back": "Wstecz"
					}
				},
				"basic_info": {
					"title_line_1": "Zacznij sprzedawać",
					"title_line_2": "z Klarną",
					"subtitle": "Potrzebujemy kilku podstawowych informacji, aby skierować Cię we właściwe miejsce.",
					"fields": {
						"email": {
							"label": "Firmowy adres e-mail",
							"field_link": "Nie masz firmy?",
							"errors": {
								"required": "Wymagany jest adres e-mail",
								"invalid": "Podaj prawidłowy adres e-mail"
							}
						},
						"email_confirmation": {
							"label": "Potwierdź firmowy adres e-mail",
							"tooltip": "Twój firmowy adres e-mail będzie głównym sposobem komunikacji z firmą Klarna. Upewnij się, że jest poprawny",
							"errors": {
								"required": "Potwierdzenie adresu e-mail jest wymagane",
								"invalid": "Podaj dwa razy ten sam adres e-mail"
							}
						},
						"website": {
							"label": "Adres URL sklepu",
							"errors": {
								"required": "Wymagany jest adres URL platformy e-commerce",
								"invalid": "Podaj prawidłowy adres URL"
							}
						},
						"country": {
							"label": "Kraj rejestracji",
							"errors": {
								"general": "Wybierz jeden z dostępnych krajów"
							}
						}
					},
					"buttons": {
						"continue": "Kontynuuj"
					}
				},
				"contact_details": {
					"title_line_1": "Porozmawiajmy.",
					"subtitle": "Wypełnij ten formularz, a my skontaktujemy się z Tobą i zaproponujemy rozwiązania dostosowane do potrzeb Twojej firmy.",
					"fields": {
						"full_name": {
							"label": "Imię i nazwisko",
							"errors": {
								"required": "Wymagane jest podanie pełnego imienia i nazwiska"
							}
						},
						"phone": {
							"label": "Numer telefonu",
							"tooltip": "Musisz podać numer kierunkowy kraju, np. +48 54 754 3010.",
							"errors": {
								"required": "Wymagany jest numer telefonu",
								"invalid": "Niepoprawny numer telefonu"
							}
						},
						"tell_us_more": {
							"label": "Opowiedz nam trochę więcej o swojej firmie (opcjonalnie)"
						}
					},
					"buttons": {
						"back": "Wstecz",
						"submit": "Prześlij dane kontaktowe"
					}
				},
				"contact_received": {
					"title": "Do usłyszenia wkrótce!",
					"message_1": "Nasz zespół ds. sprzedaży skontaktuje się z Tobą możliwie szybko.",
					"message_2": "Nasz zespół skontaktuje się z Tobą możliwie szybko. Wysłaliśmy również potwierdzenie informacji, które nam przesłano "
				},
				"we_are_sorry": {
					"title": "Bardzo przepraszamy, ale w tym momencie nie możemy zaakceptować Państwa zgłoszenia.",
					"message_1_unsupported_country": "Aktualnie Klarna nie obsługuje wybranego przez Ciebie kraju:",
					"message_1_sensitive_goods": "Klarna nie obsługuje sprzedaży wybranej kategorii produktów:",
					"message_1_platform": "Klarna nie obsługuje wybranej platformy e-commerce:",
					"message_2": "Skontaktujemy się, gdy tylko będziemy mogli kontynuować Państwa aplikację. ",
					"platform_alert": {
						"jtl4": [
							{
								"text": "Nadal możesz używać"
							},
							{
								"text": "wtyczki",
								"link": "https://www.mollie.com/de/integrations/jtl"
							},
							{
								"text": "naszego partnera, Mollie."
							}
						]
					}
				},
				"platform": {
					"title_line_1": "Z jakiej platformy korzystasz?",
					"subtitle": "Wybierz swoją platformę e-commerce, a my zajmiemy się błyskawiczną integracją.",
					"custom": "Własna integracja",
					"other_platform": "Inna platforma",
					"platform_search": {
						"label": "Platforma e-commerce",
						"no_match": "Nie znaleziono żadnych dopasowań dla „{input}”"
					},
					"buttons": {
						"back": "Wstecz"
					}
				},
				"partner": {
					"title_line_1": "Którego partnera usług płatniczych chcesz wdrożyć?",
					"subtitle": "Wybierz partnera usług płatniczych, który najlepiej odpowiada Twoim potrzebom."
				},
				"account_creation_loading": {
					"title": "Zakładanie konta...",
					"message": "Tworzenie identyfikatora firmy..."
				},
				"application_checking": {
					"title": "Sprawdzamy Twoje zgłoszenie...",
					"message": "Analizowanie danych o sklepie"
				},
				"application_review": {
					"title": "Twój wniosek jest weryfikowany.",
					"title_approved": "Twój wniosek został zatwierdzony!",
					"message": "Jest to proces ręczny, więc czas obsługi może się różnić, ale zrobimy to tak szybko, jak to możliwe.",
					"email_info_1": "Wysłaliśmy do Ciebie wiadomość e-mail o temacie „{subject}”.",
					"email_info_2": "Postępuj zgodnie z podanymi tam krokami, aby zalogować się i śledzić status swojego wniosku.",
					"email_info_2_approved": "Wykonaj podane kroki, aby zalogować się i zintegrować Klarna z Twoim sklepem e-commerce.",
					"email_subject": "Witamy w Portalu dla handlowców Klarna!",
					"resend_email": "Wyślij ponownie wiadomość e-mail"
				},
				"user_already_exists": {
					"title": "Zaloguj się do Portalu dla handlowców, aby kontynuować.",
					"message_1": "Ten adres e-mail jest już powiązany z kontem Portalu dla handlowców. Aby dokonać zmian na istniejącym koncie, zaloguj się",
					"log_in": "Zaloguj się do Portalu dla handlowców",
					"forgot_password": "Nie pamiętasz hasła?"
				},
				"otherPlatform": {
					"info": "Mamy już integrację dla {platform}",
					"link": "Rozpocznij integrację",
					"title": "Możesz się smoooth zintegrować!",
					"info2": "Dobra wiadomość! Możesz zintegrować Klarna bezpośrednio z <strong>{platform}</strong>.",
					"link2": "Przejdź do integracji {platform} + Klarna"
				},
				"noLandingPagePlatform": {
					"text": {
						"one": {
							"default": "Skontaktuj się bezpośrednio z naszym zespołem sprzedaży",
							"SE": "Skontaktuj się bezpośrednio z naszym zespołem sprzedaży pod adresem"
						}
					}
				},
				"sensitive_goods": {
					"title_2": "Czy oferujesz/oferujecie któryś z poniższych produktów lub usług?",
					"subtitle_2": "Klarna może zdefiniować niektóre pozycje jako ograniczone na podstawie rynku, przepisów prawnych, wielkości sprzedaży, akceptowanego poziomu ryzyka i innych ograniczeń, które mogą być dozwolone i nie mogą być one przetwarzane bez zgody Klarna.",
					"titleV2": "Wybierz z poniższych opcji te, które dotyczą Twojej firmy.",
					"goodsCategories": {
						"CBD_HEMP_TOBACCO_ECIGARETTES_VAPE": {
							"title_2": "Produkty z ograniczeniami wiekowymi",
							"description_2": "Tytoń, e-papierosy, urządzenia vape, produkty z konopi indyjskich, alkohol, treści dla dorosłych"
						},
						"EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS": {
							"title_2": "Podróże, wycieczki i imprezy",
							"description_2": "Transport, imprezy, platforma biletowa, hotele lub zakwaterowanie, wypożyczalnie, biura podróży"
						},
						"WEAPONS_AMMUNITION": {
							"title_2": "Licencjonowana broń",
							"description_2": "Amunicja, noże bojowe, sprzęt myśliwski, pałki, gaz pieprzowy"
						},
						"MARKETPLACE": {
							"title_2": "Rynek peer to peer",
							"description_2": "Usługi umożliwiające stronom trzecim odsprzedaż ich towarów lub oferowanie usług za pośrednictwem ich platformy internetowej"
						},
						"PHARMACEUTICALS": {
							"title_2": "Usługi farmaceutyczne i medyczne",
							"description_2": "Dystrybucja leków na receptę, zabiegi medyczne, w tym estetyczne i tatuaże"
						},
						"SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT": {
							"title_2": "Członkostwa, subskrypcje i usługi",
							"description_2": "Subskrypcja na towary fizyczne, treści cyfrowe, usługi przesyłania strumieniowego, serwisy randkowe itp."
						},
						"NONE": {
							"title_2": "Oferuję inny rodzaj produktu/usługi"
						}
					},
					"link": "Więcej o pozycjach objętych ograniczeniami",
					"buttons": {
						"next": "Dalej",
						"continue": "Kontynuuj"
					}
				}
			},
			"address_form_component": {
				"postal_code": {
					"tooltip": {
						"default": "Wprowadź swój kod pocztowy, aby automatycznie wypełnić inne części adresu.",
						"US": "Wprowadź swój kod pocztowy, aby automatycznie wypełnić inne części adresu."
					},
					"label": {
						"default": "Kod pocztowy",
						"US": "Kod pocztowy"
					},
					"error": {
						"default": "Podaj prawidłowy kod pocztowy",
						"US": "Podaj prawidłowy kod pocztowy"
					}
				},
				"city": {
					"label": "Miasto",
					"error": "Podaj miasto"
				},
				"street": {
					"label": "Adres",
					"error": "Podaj adres",
					"tooltip": "Zacznij wpisywać, aby zobaczyć więcej propozycji ulic",
					"no_suggestion_found": "Brak dopasowań dla {input}"
				},
				"country": {
					"label": "Kraj",
					"error": "Podaj kraj"
				},
				"region": {
					"label": "Państwo/region (nieobowiązkowo)"
				},
				"state": {
					"label": "Stan",
					"error": "Podaj stan"
				}
			},
			"platforms": {
				"custom": "Integracja API",
				"other": "Nie mogę znaleźć mojej platformy"
			},
			"buttons": {
				"back": "Wstecz"
			},
			"products": {
				"not_available": "Niedostępne w {reason}",
				"not_available_country": "Niedostępne w Twoim kraju",
				"not_available_platform": "Niedostępne na {platform}",
				"why_product": "Dlaczego warto?",
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Zastąp standardową bramkę płatności w swoim sklepie zoptymalizowaną bramką Klarny."
					},
					"description_expanded": {
						"default": "Zastąp standardową bramkę płatności w swoim sklepie zoptymalizowaną bramką Klarny."
					},
					"options": {
						"kco_one-pay-now": {
							"name": {
								"default": "Zapłać teraz"
							},
							"description": {
								"default": "Zaoferuj natychmiastowe płatności kartą lub przelewem."
							}
						},
						"kco_one-pay-later": {
							"name": {
								"default": "Zapłać za 30 dni"
							},
							"description": {
								"default": "Zaoferuj 30 dni na zapłatę. Bez odsetek."
							}
						},
						"kco_one-slice-it": {
							"name": {
								"default": "Finansowanie"
							},
							"description": {
								"default": "Zaoferuj możliwość spłaty przez 6–36 miesięcy.",
								"DE": "Zaoferuj możliwość spłaty przez 6–24 miesiące",
								"AT": "Zaoferuj możliwość spłaty przez 6–24 miesiące."
							}
						},
						"kco_one-slice-it-in-3": {
							"name": {
								"default": "Raty"
							},
							"description": {
								"default": "Zaoferuj 3 bezodsetkowe raty.",
								"GB": "Zaoferuj 3 bezodsetkowe raty."
							}
						},
						"kco_one-slice-it-in-4": {
							"name": {
								"default": "Płatność podzielona na 4 raty",
								"US": "Raty",
								"AU": "Zapłać w 4 ratach"
							},
							"description": {
								"default": "Zaoferuj 4 bezodsetkowe raty.",
								"GB": "Zaoferuj 4 bezodsetkowe raty."
							}
						}
					},
					"features": {
						"other_payment_options": {
							"name": {
								"default": "Inne opcje płatności"
							},
							"description": {
								"default": "Karty kredytowe, karty debetowe i inne"
							}
						},
						"on_site_messaging": {
							"name": {
								"default": "Wysyłanie wiadomości w witrynie"
							}
						},
						"billing": {
							"name": {
								"default": "Automatyczna identyfikacja i fakturowanie"
							}
						},
						"shipping": {
							"name": {
								"default": "Spersonalizowane opcje wysyłki"
							}
						},
						"post_purchase": {
							"name": {
								"default": "Wsparcie posprzedażowe"
							}
						}
					}
				},
				"kp_one": {
					"name": {
						"default": "Sposób płatności"
					},
					"description": {
						"default": "Dodaj rozwiązania płatnicze Klarny do swojego check-outu"
					},
					"description_expanded": {
						"default": "Oferowanie rozwiązań płatniczych Klarna generuje wzrosty: wzrost konwersji średnio o 30%, średniego koszyka o 41% i częstotliwości zakupów o 36%."
					},
					"options": {
						"kp_one-pay-now": {
							"name": {
								"default": "Zapłać teraz"
							},
							"description": {
								"default": "Zaoferuj natychmiastowe płatności kartą lub przelewem."
							}
						},
						"kp_one-pay-later": {
							"name": {
								"default": "Zapłać za 30 dni"
							},
							"description": {
								"default": "Twoim Klienci płacą 30 dni po zakupie. Bez odsetek, bez haczyków."
							}
						},
						"kp_one-slice-it": {
							"name": {
								"default": "Finansowanie"
							},
							"description": {
								"default": "Klienci mogą płacić na przestrzeni 6–36 miesięcy.",
								"DE": "Klienci mogą płacić na przestrzeni 6–24 miesięcy",
								"AT": "Klienci mogą płacić na przestrzeni 6–24 miesięcy"
							}
						},
						"kp_one-slice-it-in-3": {
							"name": {
								"default": "Raty"
							},
							"description": {
								"default": "Zaoferuj 3 bezodsetkowe raty.",
								"GB": "Zaoferuj 3 bezodsetkowe raty."
							}
						},
						"kp_one-slice-it-in-4": {
							"name": {
								"default": "Płatność podzielona na 4 raty",
								"US": "4 płatności",
								"CA": "4 płatności",
								"AU": "Zapłać w 4 ratach"
							},
							"description": {
								"default": "Zaoferuj 4 bezodsetkowe raty.",
								"GB": "Zaoferuj 4 bezodsetkowe raty.",
								"US": "Zamówienia od 35 do 1000 USD mogą być podzielone na 4 bezodsetkowe raty, płatne co 2 tygodnie.",
								"CA": "Zamówienia od 35 do 1000 USD mogą być podzielone na 4 bezodsetkowe raty, płatne co 2 tygodnie."
							}
						},
						"kp_one-pay-by-card": {
							"name": {
								"default": "Płatność kartą"
							},
							"description": {
								"default": "Zaoferuj natychmiastowe płatności kartą lub przelewem."
							}
						}
					}
				}
			}
		},
		"fields": {
			"enm": {
				"product_channel": {
					"label": "Jak zamierzasz prowadzić sprzedaż?",
					"options": {
						"IN_STORE": "Sklep stacjonarny",
						"TELESALES": "Sprzedaż zdalna"
					},
					"description": {
						"IN_STORE": "Sprzedaż odbywa się głównie osobiście, a klient otrzymuje artykuły od razu.",
						"TELESALES": "Sprzedaż odbywa się głównie przez telefon na podstawie rozmów przychodzących. Klient nie otrzymuje artykułów od razu."
					}
				},
				"country": {
					"label": "Kraj"
				},
				"organization_category": {
					"label": "Typ osoby prawnej",
					"options": {
						"SOLE_TRADER": "Jednoosobowa działalność gospodarcza",
						"PARTNERSHIP": "Współpraca",
						"UNDEFINED": "NIEZDEFINIOWANE",
						"BV": "BV",
						"CV": "CV",
						"CVOA": "CVOA",
						"EEN": "EEN",
						"MTS": "MTS",
						"NV": "NV",
						"SE": "SE",
						"VOF": "VOF",
						"C_CORP": "Korporacja C",
						"S_CORP": "Korporacja S",
						"TRUST_ESTATE": "Fundusz powierniczy",
						"INDIVIDUAL": "Indywidualna",
						"SOLE_PROPRIETORSHIP": "Jednoosobowa działalność gospodarcza",
						"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Jednoosobowa spółka z ograniczoną odpowiedzialnością",
						"LIMITED_LIABILITY_COMPANY": "Spółka z ograniczoną odpowiedzialnością",
						"PUBLIC_LISTED_COMPANY": "Spółka publiczna notowana na giełdzie",
						"PRIVATE_COMPANY": "PRYWATNA_FIRMA"
					}
				},
				"store_category": {
					"label": "Główna kategoria sprzedawanych towarów",
					"options": {
						"ADULT_SHOES_AND_CLOTHING": "Odzież i obuwie – Obuwie i odzież dla dorosłych",
						"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Produkty samochodowe – Części i akcesoria samochodowe",
						"BAGS_AND_WALLETS": "Biżuteria i akcesoria – Torby i portfele",
						"BODY_AND_HAIR_CARE": "Zdrowie i uroda – Pielęgnacja ciała i włosów",
						"BOOK_AND_MAGAZINES": "Rozrywka – książki i czasopisma",
						"CANDY": "Żywność i napoje – Cukierki",
						"CAR_ELECTRONICS": "Elektronika – Elektronika samochodowa",
						"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Produkty dla dzieci – Odzież dziecięca i produkty pielęgnacyjne",
						"CHILDREN_TOYS": "Produkty dla dzieci – Zabawki dla dzieci",
						"CLEANING_AND_SANITARY": "Dom i ogród – Sprzątanie i higiena",
						"COLLECTIBLES": "Rekreacja, sport i hobby – Kolekcje",
						"CONCEPT_STORES_AND_MISCELLANEOUS": "Rekreacja, sport i hobby – Concept store’y i pozostałe",
						"COSMETICS": "Zdrowie i uroda – Kosmetyki",
						"COSTUMES_AND_PARTY_SUPPLIES": "Rekreacja, sport i hobby – Kostiumy i artykuły na przyjęcia",
						"DATING_SERVICES": "Produkty niematerialne – Usługi randkowe",
						"DECORATION_AND_ART": "Dom i ogród – Dekoracje i sztuka",
						"DIETARY_SUPPLEMENTS": "Zdrowie i uroda – Suplementy diety",
						"DIGITAL_SERVICES": "Produkty niematerialne – Usługi cyfrowe",
						"DIVERSIFIED_CHILDREN_PRODUCTS": "Produkty dla dzieci – Różne produkty dla dzieci",
						"DIVERSIFIED_ELECTRONICS": "Elektronika – Różna elektronika",
						"DIVERSIFIED_ENTERTAINMENT": "Rozrywka – Różna rozrywka",
						"DIVERSIFIED_EROTIC_MATERIAL": "Materiały Erotyczne – Różne materiały erotyczne",
						"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Zdrowie i uroda – Różne produkty dla zdrowia i urody",
						"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Dom i ogród – Różne produkty dla domu i ogrodu",
						"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Biżuteria i akcesoria – Różna biżuteria i akcesoria",
						"EDUCATION": "Produkty niematerialne – Edukacja",
						"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektronika – Sprzęt elektroniczny i związane z nim akcesoria",
						"EROTIC_CLOTHING_AND_ACCESSORIES": "Materiały Erotyczne – Odzież i akcesoria erotyczne",
						"EVENT_TICKETS": "Produkty niematerialne – Bilety na imprezy",
						"FOOD_AND_BEVERAGE": "Żywność i napoje – Żywność i napoje",
						"FRAGRANCES": "Zdrowie i uroda – Perfumy",
						"FURNITURE": "Dom i ogród – Meble",
						"GENERAL_SHOES_AND_CLOTHING": "Odzież i obuwie – Obuwie i odzież ogólnie",
						"HOBBY_ARTICLES": "Rekreacja, sport i hobby – Artykuły hobbystyczne",
						"HOUSEHOLD_ELECTRONICS": "Elektronika – Elektronika użytkowa",
						"JEWELRY_AND_WATCHES": "Biżuteria i akcesoria – Biżuteria i zegarki",
						"KITCHENWARE": "Dom i ogród – Przybory kuchenne",
						"MARKETPLACES": "Produkty niematerialne – Rynki",
						"MUSIC_AND_MOVIES": "Rozrywka – Muzyka i filmy",
						"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Rekreacja, sport i hobby – Instrumenty i sprzęt muzyczny",
						"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Biżuteria i akcesoria – Okulary przeciwsłoneczne bez recepty i soczewki",
						"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektronika – Urządzenia biurowe i podobne akcesoria",
						"OTHER_SERVICES": "Produkty niematerialne – Pozostałe usługi",
						"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Zdrowie i uroda – Pielęgnacja osobista i poprawa sylwetki",
						"PET_SUPPLIES": "Dom i ogród – Artykuły dla zwierząt domowych",
						"PHARMACEUTICAL_PRODUCTS": "Zdrowie i uroda – Produkty farmaceutyczne",
						"PLANTS_AND_FLOWERS": "Dom i ogród – Rośliny i kwiaty",
						"PRESCRIPTION_OPTICS": "Zdrowie i uroda – Optyka na receptę",
						"PRINTS_AND_PHOTOS": "Rekreacja, sport i hobby – Wydruki i zdjęcia",
						"SAFETY_PRODUCTS": "Dom i ogród – Produkty związane z bezpieczeństwem",
						"SEX_TOYS": "Materiały Erotyczne – Zabawki erotyczne",
						"SPORTS_GEAR_AND_OUTDOOR": "Rekreacja, sport i hobby – Sprzęt sportowy i outdoor",
						"TOBACCO": "Żywność i napoje – Tytoń",
						"TOOLS_AND_HOME_IMPROVEMENT": "Dom i ogród – Narzędzia i wyposażenie domu",
						"TRAVEL_SERVICES": "Produkty niematerialne – Usługi turystyczne",
						"UNDERWEAR": "Odzież i buty – Bielizna",
						"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Rozrywka – Gry wideo i powiązane akcesoria",
						"WHEELS_AND_TIRES": "Produkty samochodowe – Koła i opony",
						"WINE_BEER_AND_LIQUOR": "Żywność i napoje – piwo, wino i alkohole wysokoprocentowe",
						"YOUTHFUL_SHOES_AND_CLOTHING": "Odzież i obuwie – Obuwie i odzież dla młodzieży"
					}
				},
				"currency": {
					"label": "Waluta"
				},
				"account_type": {
					"label": "Typ rachunku bankowego",
					"options": {
						"IBAN": "IBAN",
						"LOCAL_SE": "Lokalny Szwecja",
						"LOCAL_US": "Lokalny USA",
						"LOCAL_GENERIC": "Lokalny Norwegia/Dania",
						"SPECIAL": "Specjalny",
						"BANKGIRO": "Lokalny Szwecja Bankgiro",
						"PLUSGIRO": "Lokalny Szwecja Plusgiro"
					}
				},
				"person_role": {
					"label": "Rola",
					"options": {
						"LEGAL_REPRESENTATIVE": "Przedstawiciel prawny",
						"ALTERNATIVE_BENEFICIAL_OWNER": "Beneficjent alternatywny",
						"ULTIMATE_BENEFICIAL_OWNER": "Beneficjent ostateczny",
						"OWNER": "Właściciel"
					}
				},
				"business_size": {
					"label": "Wielkość firmy",
					"options": {
						"LARGE": "duża",
						"MEDIUM": "średnia",
						"small": "mała"
					}
				},
				"sensitive_good_category": {
					"label": "Czy oferujesz któryś z poniższych produktów lub usług w fizycznym sklepie?",
					"options": {
						"AGE_RESTRICTED_PRODUCTS": "Produkty z ograniczeniami wiekowymi",
						"LICENSED_WEAPONS": "Licencjonowana broń",
						"PHARMA_AND_MEDICAL_SERVICES": "Usługi farmaceutyczne i medyczne",
						"TRAVEL_TOURS_EVENTS": "Podróże, wycieczki i imprezy",
						"PEER_TO_PEER_MARKETPLACE": "Rynek peer to peer",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Członkostwa, subskrypcje i usługi",
						"NONE": "Oferuję inny rodzaj produktu/usługi"
					},
					"description": {
						"AGE_RESTRICTED_PRODUCTS": "Tytoń, e-papierosy, urządzenia vape, produkty z konopi indyjskich, alkohol, treści dla dorosłych",
						"LICENSED_WEAPONS": "Amunicja, noże bojowe, sprzęt myśliwski, pałki, gaz pieprzowy",
						"PHARMA_AND_MEDICAL_SERVICES": "Dystrybucja leków na receptę, zabiegi medyczne, w tym estetyczne i tatuaże",
						"TRAVEL_TOURS_EVENTS": "Transport, imprezy, platforma biletowa, hotele lub zakwaterowanie, wypożyczalnie, biura podróży",
						"PEER_TO_PEER_MARKETPLACE": "Usługi umożliwiające stronom trzecim odsprzedaż ich towarów lub oferowanie usług za pośrednictwem ich platformy internetowej",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Subskrypcja na towary fizyczne, treści cyfrowe, usługi przesyłania strumieniowego, serwisy randkowe itp.",
						"NONE": "Oferuję inny rodzaj produktu/usługi"
					},
					"error_message": "Przepraszamy! Nie możemy dalej rozpatrywać Twojego wniosku, ponieważ obecnie nie obsługujemy wybranego przez Ciebie typu produktów lub usług."
				}
			},
			"common": {
				"country": {
					"label": "Kraj"
				},
				"address": {
					"city": {
						"label": "Miasto"
					},
					"postal_code": {
						"label": "Kod pocztowy"
					},
					"region": {
						"label": "Państwo/region"
					},
					"street_address": {
						"label": "Adres sklepu stacjonarnego"
					},
					"street_address2": {
						"label": "Linia adresu 2"
					}
				}
			},
			"payload": {
				"business_information": {
					"company_name": {
						"label": "Nazwa firmy"
					},
					"registration_authority": {
						"label": "Organ rejestracyjny"
					},
					"registration_id": {
						"label": "Numer rejestracyjny"
					},
					"subject_to_vat": {
						"label": "Czy Twoja firma jest zarejestrowanym płatnikiem VAT?"
					},
					"vat_id": {
						"label": "Numer VAT"
					},
					"persons": {
						"date_of_birth": {
							"label": "Data urodzenia"
						},
						"first_name": {
							"label": "Imię"
						},
						"last_name": {
							"label": "Nazwisko"
						},
						"person_identity_document": {
							"label": "Dokument tożsamości"
						},
						"person_proof_of_address": {
							"label": "Potwierdzenie adresu"
						},
						"personal_identifier": {
							"label": "Dowód osobisty"
						}
					},
					"should_auto_capture_orders": {
						"label": "Czy chcesz automatycznie przyjmować zamówienia?",
						"tooltip": "Zamówienia powinny być przyjmowane w momencie przekazania w sklepie lub wysyłki z magazynu. Jeśli wybierzesz opcję auto-przyjmowania, zamówienie zostanie automatycznie przyjęte w momencie potwierdzenia zakupu przez klienta."
					}
				},
				"contract_entity": {
					"label": "Podmiot umowny"
				},
				"contract_onboarding_type": {
					"label": "Typ wdrażanego partnera biznesowego"
				},
				"underwriting_inquiry_email": {
					"label": "E-mail do undererwritingu"
				},
				"bank_accounts": {
					"account_holder": {
						"label": "Nazwisko posiadacza rachunku"
					},
					"account_number": {
						"label": "Numer konta"
					},
					"bic": {
						"label": "Kod BIC"
					},
					"iban": {
						"label": "Numer rachunku (IBAN)"
					},
					"is_default": {
						"label": "Użyj tego konta dla nieokreślonych walut"
					},
					"routing_number": {
						"label": "Numer rozliczeniowy"
					}
				},
				"in_stores": {
					"contact_email": {
						"label": "E-mail kontaktowy"
					},
					"name": {
						"label": "Nazwa sklepu"
					},
					"support_email": {
						"label": "E-mail do obsługi klienta"
					},
					"support_phone": {
						"label": "Numer telefonu do obsługi klienta"
					},
					"business_concepts": {
						"options": {
							"TRADITIONAL_SALE_OF_GOODS": "Tradycyjna sprzedaż towarów",
							"VOUCHER": "Voucher",
							"MEMBERSHIP": "Członkostwo",
							"SUBSCRIPTION": "Subskrypcja",
							"PHARMACIES": "Apteki",
							"US_PHARMACIES": "Apteki amerykańskie",
							"MEDICAL_SERVICES": "Usługi medyczne",
							"MARKETPLACES": "Rynki",
							"FIREARM_DEALERS": "Handlarze broni palnej",
							"AUCTIONS": "Aukcje",
							"ALCOHOL": "Alkohol",
							"TOBACCO": "Tytoń",
							"HEMP_CBD_THC": "Konopie, CBD lub THC",
							"DONATIONS_CHARITY": "Darowizny i działalność charytatywna",
							"TRAVEL": "Podróże",
							"EVENTS": "Eventy",
							"COURSES": "Kursy",
							"EDUCATIONAL_COURSES": "Kursy edukacyjne",
							"FOOD_DELIVERY": "Dostawa jedzenia",
							"CUSTOMISED_PRE_ORDER_FURNITURE": "Niestandardowe zamówienie w przedsprzedaży / meble",
							"DIGITAL_CONTENT": "Treści cyfrowe",
							"GAMING_INDUSTRY": "Branża gier (hazard, zakłady, kasyna, loterie)"
						}
					}
				},
				"terms_and_conditions": {
					"default": "Warunki i regulamin",
					"UPSELL_WEBSTORE_TO_KPOS": "Warunki Klarna dla sprzedaży w sklepach fizycznych"
				},
				"pricing_terms": {
					"default": "Warunki cenowe",
					"UPSELL_WEBSTORE_TO_KPOS": "Warunki cenowe Klarna dla sklepów fizycznych"
				}
			}
		},
		"group": {
			"title": {
				"additional_data": "Informacje dodatkowe",
				"bank_account": "Podaj dane konta bankowego Twojej firmy.",
				"business_size": "Jaka jest oczekiwana roczna wielkość sprzedaży za pośrednictwem punktu sprzedaży Klarna?",
				"in_store_get_started": "Rozpocznij działalność ze wsparciem Klarna.",
				"in_store_legal_form": "Jaki rodzaj działalności prowadzisz?",
				"in_store_registered_address": "Jaki jest adres firmy?",
				"in_store_registration": "Czy Twoja firma jest zarejestrowaną działalnością?",
				"in_store_stakeholder": "Kto zarządza firmą?",
				"in_store_stores": "Jakie są szczegóły dotyczące punktu sprzedaży Klarna?",
				"in_store_vat": "Czy Twoja firma jest zarejestrowanym płatnikiem VAT?",
				"product_channel": "Jak Twoja firma planuje korzystać z punktu sprzedaży Klarna?",
				"sensitive_goods": "Jakie kategorie produktów będziesz sprzedawać za pomocą punktu sprzedaży Klarna?",
				"ads_manager_get_started": "Już prawie koniec!",
				"content_store_get_started": "Już prawie koniec!"
			},
			"subtitle": {
				"additional_data": "Analizujemy otrzymany wniosek i potrzebujemy kilku dodatkowych informacji, aby kontynuować jego rozpatrywanie.",
				"bank_account": "Transakcje Klarna będą przekazywane na ten rachunek bankowy.",
				"business_size": "Potrzebujemy pewnych podstawowych informacji dotyczących Twojej firmy, aby rozpatrzyć Twój wniosek.",
				"in_store_get_started": "Potrzebujemy kilku podstawowych informacji, aby skierować Cię we właściwe miejsce",
				"in_store_legal_form": "Jesteśmy zobowiązani do zadania kilku szczegółowych pytań w zależności od rodzaju prowadzonej przez Ciebie działalności.",
				"in_store_registered_address": "To adres siedziby firmy w dokumentach urzędowych, który będzie widniał na fakturach klientów Klarna.",
				"in_store_registration": "Potrzebujemy numeru rejestracyjnego Twojej firmy, aby zweryfikować Twoje dane biznesowe.",
				"in_store_stakeholder": "Jako instytucja finansowa jesteśmy zobowiązani do uzyskania tych informacji.",
				"in_store_stores": "Wykorzystamy te informacje, aby skonfigurować Twoje nowe konto punktu sprzedaży Klarna.",
				"in_store_vat": "Jeśli posiadasz numer VAT, możemy łatwiej zweryfikować dane Twojej firmy.",
				"product_channel": "Wybierz swój główny kanał sprzedaży. Będziesz mógł korzystać z punktu sprzedaży Klarna w obu kanałach.",
				"sensitive_goods": "Samoobsługowe wdrożenie punktu sprzedaży Klarna nie pozwala na sprzedaż artykułów, które zostały zdefiniowane przez Klarna jako zastrzeżone.",
				"ads_manager_get_started": "Podaj rozliczeniowy adres e-mail, na który będą wysyłane faktury za kampanie. Aby aktywować konto, musisz być administratorem. Administrator może następnie przyznać uprawnienia innym użytkownikom.",
				"content_store_get_started": "Przed uzyskaniem dostępu do Content Managera przeczytaj i zaakceptuj nasz Regulamin."
			},
			"summary": {
				"title": "Przed wysłaniem wniosku sprawdź swoje dane"
			},
			"status": {
				"UNDERWRITING_INITIATED": {
					"title": {
						"default": "Przetwarzamy Twój wniosek. Może to zająć kilka sekund.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Poczekaj chwilę...",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Poczekaj chwilę..."
					},
					"paragraphs": {
						"default": [
							{
								"text": "Twój wniosek jest w trakcie rozpatrywania – tworzymy Twój nowy identyfikator sprzedawcy."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Przygotowujemy wszystkie elementy dla Twojego konta Ads Manager."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Przygotowujemy wszystkie elementy dla Twojego konta Menedżera treści."
							}
						]
					}
				},
				"ONBOARDING_COMPLETED": {
					"title": {
						"default": "Gratulacje! Twój wniosek został zatwierdzony.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Wszystko gotowe!",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Wszystko gotowe!"
					},
					"paragraphs": {
						"default": [
							{
								"text": "Przejdźmy do integracji Klarna w Twoim sklepie online. Przejdź do zakładki Produkty w ramach swojego konta na Portalu dla sprzedawców, aby znaleźć swoje dane uwierzytelniające integrację i instrukcje, jak z nich korzystać"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Teraz skonfigurujmy Twój sklep, aby od razu można było zacząć przyjmować płatności."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Przejdź do Ads Managera, aby rozpocząć tworzenie pierwszej kampanii."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Przejdź do Content Managera i opublikuj swoją pierwszą ofertę już dziś."
							}
						]
					},
					"second_title": {
						"default": "Więcej informacji na temat integracji z Klarna można znaleźć w otrzymanej dokumentacji",
						"UPSELL_WEBSTORE_TO_KPOS": "Potrzebujesz pomocy w konfiguracji sklepu? Możemy Ci pomóc.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Potrzebujesz pomocy w korzystaniu z Ads Managera? Sprawdź nasze FAQ lub skontaktuj się z naszym wsparciem biznesowym, chętnie Ci pomożemy.",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Potrzebujesz pomocy w korzystaniu z Content Managera? Sprawdź nasze FAQ lub skontaktuj się z naszym wsparciem biznesowym, chętnie Ci pomożemy."
					},
					"second_paragraphs": {
						"default": [
							{
								"text": "Nasze wytyczne w zakresie najlepszych praktyk mogą pomóc Ci optymalnie wykorzystać współpracę z nami."
							},
							{
								"text": "Klarna Checkout",
								"link": "#"
							},
							{
								"text": "Płatności Klarna",
								"link": "#"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Skontaktuj się z naszym działem wsparcia biznesowego. Z przyjemnością udzielimy Ci pomocy."
							},
							{
								"text": "Skontaktuj się z działem wsparcia",
								"link": "https://www.klarna.com/se/foretag/butikssupport/"
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Zapoznaj się z FAQ.",
								"link": "https://portal.klarna.com/?help-page=topic%3Aads-manager"
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Zapoznaj się z FAQ.",
								"link": "https://portal.klarna.com/?help-page=topic%3Acontent-manager"
							}
						]
					},
					"button_text": {
						"default": "Zacznijmy.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Zacznijmy",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Zacznijmy",
						"UPSELL_WEBSTORE_TO_KPOS": "Rozpocznij sprzedaż"
					}
				},
				"MANUAL_UNDERWRITING_INITIATED": {
					"title": "Dziękujemy! Sprawdzamy Twój wniosek",
					"badge": "Czas: ok. 5-7 dni",
					"paragraphs": [
						{
							"text": "Po zakończeniu weryfikacji wniosku lub gdy będziemy potrzebować dodatkowych informacji, otrzymasz stosowny e-mail."
						}
					],
					"second_title": "W wolnej chwili sprawdź swoją skrzynkę pocztową",
					"second_paragraphs": [
						{
							"text": "Wysłaliśmy do Ciebie z linkiem Witamy na portalu dla sprzedawców Klarna. Aby zalogować się i aktywować konto, postępuj zgodnie z podanymi tam krokami."
						}
					]
				},
				"SUSPENDED": {
					"title": "Niestety, Twój wniosek nie został zaakceptowany.",
					"paragraphs": [
						{
							"text": "Po przeanalizowaniu informacji dotyczących Twojej firmy, nie możemy przejść do kolejnych kroków związanych z rozpatrzeniem wniosku. <strong>{businessName}</strong>"
						},
						{
							"text": "Oto kilka z najczęstszych powodów:"
						},
						{
							"list": [
								{
									"text": "Twój sklep nie spełnia wymogów etycznych firmy Klarna."
								},
								{
									"text": "Brak kontaktu z obsługą klienta."
								},
								{
									"text": "Inne czynniki o charakterze administracyjnym."
								}
							]
						},
						{
							"text": "Dziękujemy za zainteresowanie ofertą <strong>Klarna dla sklepów fizycznych.</strong> Mamy nadzieję, że w przyszłości będziemy mogli współpracować."
						}
					],
					"second_title": "W razie dalszych pytań",
					"second_paragraphs": [
						{
							"text": "co do naszej decyzji lub innych produktów Klarna prosimy o kontakt, chętnie pomożemy."
						}
					]
				}
			},
			"stakeholders": {
				"LEGAL_REPRESENTATIVE": {
					"title": {
						"default": "Kto podpisuje umowy w Twojej firmie?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Twoja firma ma zamiar zawrzeć umowę z Klarna. Musimy wiedzieć, kto jest prawnie upoważniony do podpisywania umów."
							}
						]
					}
				},
				"OWNER": {
					"title": {
						"default": "Czy w Twojej firmie są udziałowcy posiadający więcej niż 25% udziałów w firmie?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Jako instytucja finansowa jesteśmy prawnie zobowiązani do gromadzenia tych informacji."
							}
						],
						"default": [
							{
								"text": "Podaj dane osób, które posiadają więcej niż 25% akcji lub praw głosu w spółce lub sprawują podobną kontrolę.\nJesteśmy prawnie zobowiązani przez dyrektywę UE w sprawie przeciwdziałania praniu brudnych pieniędzy ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "), aby zbierać takie informacje."
							}
						]
					}
				},
				"ALTERNATIVE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Kto zarządza firmą?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Jesteśmy prawnie zobowiązani przez dyrektywę UE w sprawie przeciwdziałania praniu brudnych pieniędzy ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "), aby zbierać takie informacje."
							}
						],
						"US": [
							{
								"text": "Jako instytucja finansowa jesteśmy prawnie zobowiązani do gromadzenia tych informacji."
							}
						],
						"CA": [
							{
								"text": "Jako instytucja finansowa jesteśmy prawnie zobowiązani do gromadzenia tych informacji."
							}
						],
						"AU": [
							{
								"text": "Jako instytucja finansowa jesteśmy prawnie zobowiązani do gromadzenia tych informacji."
							}
						]
					}
				},
				"ULTIMATE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Czy w Twojej firmie są udziałowcy posiadający więcej niż 25% udziałów w firmie?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Jako instytucja finansowa jesteśmy prawnie zobowiązani do gromadzenia tych informacji."
							}
						],
						"default": [
							{
								"text": "Podaj dane osób, które posiadają więcej niż 25% akcji lub praw głosu w spółce lub sprawują podobną kontrolę.\nJesteśmy prawnie zobowiązani przez dyrektywę UE w sprawie przeciwdziałania praniu brudnych pieniędzy ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "), aby zbierać takie informacje."
							}
						]
					}
				}
			}
		},
		"product-selection-container": {
			"products": {
				"products_block": {
					"title_1": "Rozwiązania",
					"title_2": "Sposoby płatności",
					"note": "Wszystkie ceny dotyczą jednej transakcji.",
					"per_transaction": "za transakcję",
					"cross_border_notice": "Mogą obowiązywać dodatkowe opłaty transgraniczne",
					"cross_border_notice_pricing_annex_suffix": {
						"before_link": "patrz",
						"link_text": "załącznik do cennika"
					},
					"not_available_for_business": "Niedostępne dla Twojej firmy",
					"not_available_for_country": "Możesz sprzedawać tylko na inne rynki",
					"not_compatible_with_platform": "Niedostępne dla Twojej platformy",
					"installed": "Zainstalowany"
				},
				"buttons": {
					"next": "Dalej"
				}
			}
		}
	}
};